import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import Select from "react-select";
import { BASE_URL } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import usePermission from "../../config/permissions";
import {
  CustomImageModal,
  customSortByKey,
  generateCustomFileForUpload,
  handleAllError,
  handleErrorToast,
} from "../CustomFunctions";
import {
  AddwithBlueCircle,
  AddwithWhiteCircle,
  CloudUpload,
  DeleteDustbin,
  DropdownArrowOption,
  UpdatePencil,
} from "../AllSvg";
import ReactQuill from "react-quill";
import { QuillEditorFormats, QuillEditorModules } from "../CustomUtilities";
import { ViewLetterBuilder } from "../DynamicBuilders/LetterBuilderManagement/LetterTemplateComponentsTesting";
import { formattedDateLong } from "../Date";

// ! *************** Departments Crud Models Start ***************

const Department = ({ getDepartment, departmentname }) => {
  const [show, setShow] = useState(false);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [filteredList, setFilteredList] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    updated_by: sessionStorage.getItem("emp_code"),
    sub_company: sessionStorage.getItem("company_id"),
  });

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["title"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });

    // Filter logic based on the input
    if (name === "title") {
      const filtered = departmentname.filter((item) =>
        item.title.toLowerCase().includes(value.toLowerCase()),
      );
      setFilteredList(filtered);
    }
  };

  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm() && formData.title != null) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      setLoading(true); //loading logic
      try {
        let res = await axios.post(`${BASE_URL}/wfm/department/`, formData);

        if (res.status === 200) {
          await getDepartment();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="upload-svg"
        title="Add Department"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> Add Department
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        {/* <Modal.Header closeButton>
              <Modal.Title>Request Leave</Modal.Title>
            </Modal.Header> */}
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}
              <div className="flex-column">
                <label
                  htmlFor="title"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Title<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Department Name"
                  onChange={handleInputChange}
                  value={formData.title}
                  className={`form-input ${errors.title ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.title && (
                  <span className="error-message font-size-text ">
                    {errors.title}
                  </span>
                )}
                {filteredList.length > 0 && (
                  <div className="list-group">
                    {filteredList.map((item, index) => (
                      <div key={index} className="list-group-item">
                        {item.title}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {PERMISSION_AUTHORITY ? (
                <div className="flex-column">
                  <label
                    htmlFor="sub_company"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Sub Company<span className="required">*</span>
                  </label>
                  <select
                    id="sub_company"
                    name="sub_company"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.sub_company
                      ? "error"
                      : inputState.sub_company
                        ? "success"
                        : ""
                      }`}
                  >
                    {SUB_COMPANIES.map((company) => (
                      <option value={company.id}>{company.title}</option>
                    ))}
                    ;
                  </select>
                  {errors.title && (
                    <span className="error-message font-size-text ">
                      {errors.title}
                    </span>
                  )}
                </div>
              ) : null}
              <div className="button-models">
                <button
                  className="model-button   font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

const DepartmentUpdate = ({ i, getDepartment, departmentname }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [filteredList, setFilteredList] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    updated_by: sessionStorage.getItem("emp_code"),
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["title"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });

    // Filter logic based on the input
    if (name === "title") {
      const filtered = departmentname.filter((item) =>
        item.title.toLowerCase().includes(value.toLowerCase()),
      );
      setFilteredList(filtered);
    }
  };

  // ?  ************** Validation End **************  ! //

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/department/${i.id}/`,
          formData,
        );

        if (res.status === 200) {
          await getDepartment();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button className="model-edit-button-ml" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
            fill="#145650"
          />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Department {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}
              <div className="flex-column">
                <label
                  htmlFor="title"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Title<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Department Name"
                  onChange={handleInputChange}
                  value={formData.title}
                  className={`form-input ${errors.title ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.title && (
                  <span className="error-message font-size-text ">
                    {errors.title}
                  </span>
                )}
                {filteredList.length > 0 && (
                  <div className="list-group">
                    {filteredList.map((item, index) => (
                      <div key={index} className="list-group-item">
                        {item.title}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button   font-weight500    "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  onClick={handleFormSubmitPut}
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const DepartmentDelete = ({ i, getDepartment }) => {
  const [show, setShow] = useState(false);
  const [inactiveDepartment, setInactiveDepartment] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    // getInactiveDepartment();
  };

  // const getInactiveDepartment = async () => {
  //   try {
  //     const res = await axios.get(
  //       `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${sessionStorage.getItem(
  //         "company_id"
  //       )}/inactive/`
  //     );
  //     // const res = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/beb197dd-9ad1-4136-a1ad-bb469e7127a2/active/`);
  //     setInactiveDepartment(res.data);
  //   } catch (err) {
  //     // alert(err.message);
  //   }
  // }
  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.delete(`${BASE_URL}/wfm/department/${i.id}/`);

      if (res.status === 200) {
        await getDepartment();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="model-delete-button" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Department {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete department {i.title}
            <div className="button-models">
              <button
                className="model-button   font-weight500    "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ? *************** Departments Crud Models End ***************

// ! *************** Designagtion Crud Models Start ***************

const DesignationName = ({ getDesignation, designationname }) => {
  const [show, setShow] = useState(false);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

  const [formData, setFormData] = useState({
    title: "",
    sub_company: sessionStorage.getItem("company_id"),
    updated_by: sessionStorage.getItem("emp_code"),
  });
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [filteredList, setFilteredList] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["title"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] =
          `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  console.log(designationname);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });

    // Filter logic based on the input
    if (name === "title") {
      const filtered = designationname.filter((item) =>
        item.title.toLowerCase().includes(value.toLowerCase()),
      );
      setFilteredList(filtered);
    }
  };

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm() && formData.title != null) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      setLoading(true); //loading logic
      try {
        let res = await axios.post(`${BASE_URL}/wfm/designation/`, formData);
        if (res.status === 200) {
          await getDesignation();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="upload-svg"
        title="Add Designation"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> Add Designation
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <div className="flex-column">
                <label
                  htmlFor="title"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Title<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Designation Name"
                  onChange={handleInputChange}
                  value={formData.title}
                  className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""}`}
                />
                {errors.title && (
                  <span className="error-message font-size-text ">
                    {errors.title}
                  </span>
                )}
                {filteredList.length > 0 && (
                  <div className="list-group">
                    {filteredList.map((item, index) => (
                      <div key={index} className="list-group-item">
                        {item.title}
                      </div>
                    ))}
                  </div>
                )}
                {PERMISSION_AUTHORITY ? (
                  <div className="flex-column">
                    <label
                      htmlFor="sub_company"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Sub Company<span className="required">*</span>
                    </label>
                    <select
                      id="sub_company"
                      name="sub_company"
                      value={formData.sub_company}
                      onChange={handleInputChange}
                      className={`form-input form-group-selection ${errors.sub_company
                        ? "error"
                        : inputState.sub_company
                          ? "success"
                          : ""
                        }`}
                    >
                      {SUB_COMPANIES.map((company) => (
                        <option value={company.id}>{company.title}</option>
                      ))}
                      ;
                    </select>
                    {errors.title && (
                      <span className="error-message font-size-text ">
                        {errors.title}
                      </span>
                    )}
                  </div>
                ) : null}
                <div className="button-models">
                  <button
                    className="model-button   font-weight500   "
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                    onClick={handleFormSubmit}
                    disabled={loading}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const DesignationUpdate = ({ i, getDesignation, designationname }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [filteredList, setFilteredList] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    updated_by: sessionStorage.getItem("emp_code"),
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["title"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });

    // Filter logic based on the input
    if (name === "title") {
      const filtered = designationname.filter((item) =>
        item.title.toLowerCase().includes(value.toLowerCase()),
      );
      setFilteredList(filtered);
    }
  };

  // ?  ************** Validation End **************  ! //

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/designation/${i.id}/`,
          formData,
        );

        if (res.status === 200) {
          await getDesignation();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button className="model-edit-button-ml" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
            fill="#145650"
          />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Designation {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}
              <div className="flex-column">
                <label
                  htmlFor="title"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Title<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Department Name"
                  onChange={handleInputChange}
                  value={formData.title}
                  className={`form-input ${errors.title ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.title && (
                  <span className="error-message font-size-text ">
                    {errors.title}
                  </span>
                )}
                {filteredList.length > 0 && (
                  <div className="list-group">
                    {filteredList.map((item, index) => (
                      <div key={index} className="list-group-item">
                        {item.title}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button font-weight500"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  onClick={handleFormSubmitPut}
                  className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const DesignationDelete = ({ i, getDesignation }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/designation/${i.id}/`);

      if (res.status === 200) {
        await getDesignation();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="model-delete-button" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Designatiion {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete department {i.title}
            <div className="button-models">
              <button
                className="model-button   font-weight500    "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                onClick={handleFormSubmitDelete}
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ? *************** Designagtion Crud Models End ***************

// ! *************** Sub Company Crud Models Start ***************

const AddSubCompany = ({ getSubCompany }) => {
  const [show, setShow] = useState(false);
  const [lettersTemplate, setLettersTemplateData] = useState([]);
  const [toggleCompany, setToggleCompany] = useState(
    sessionStorage.getItem("company_id"),
  );
  const [buffer, setBuffering] = useState(true);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
    getLetterTemplates();
  };
  const initialData = {
    title: "",
    company_name: "",
    company_address: "",
    company_number: "",
    company_gst: "",
    company_logo: "",
    updated_by: sessionStorage.getItem("emp_code"),
    company_letter_template: "",
  };

  const [formData, setFormData] = useState(initialData);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const quillRef = useRef(null);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["title", "company_logo", "company_address"];
    // const requiredFields = ["title", "company_name", "company_address", "company_number", "company_gst", "company_logo"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (value) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };

  const handleFileChange = (e) => {
    const { name, value } = e.target;
    const file = e.target.files[0];

    if (file) {
      setFormData({ ...formData, [name]: file });
    } else {
      console.log("no file");
    }

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const handleFileClear = (name) => {
    setFormData({
      ...formData,
      [name]: null,
    });
  };

  const getLetterTemplates = async () => {
    setBuffering(true);
    try {
      const template = await axios.get(
        `${BASE_URL}/wfm/letter-builder-template/`,
      );

      setLettersTemplateData(template.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  // ?  ************** Validation End **************  ! //
  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      setLoading(true); //loading logic

      const uploadData = new FormData();
      uploadData.append("title", formData.title);
      uploadData.append("company_name", formData.company_name);
      uploadData.append("company_address", formData.company_address);
      uploadData.append("company_number", formData.company_number);
      uploadData.append("company_gst", formData.company_gst);
      uploadData.append(
        "company_letter_template",
        formData.company_letter_template,
      );
      uploadData.append("updated_by", formData.updated_by);
      try {
        const companyLogo = formData.company_logo;
        if (companyLogo) {
          const customFile = generateCustomFileForUpload(
            companyLogo,
            "Aimantra",
          );
          uploadData.append("company_logo", customFile);
        }
        let res = await axios.post(`${BASE_URL}/wfm/subcompany/`, uploadData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (res.status === 200) {
          setShow(false);
          await getSubCompany();
          setFormData(initialData);
          toast.success("Subcompany created successfully.");
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const convertSpaces = (html) => {
    return html.replace(/  /g, "&nbsp;&nbsp;");
  };
  const onEditorContentChange = (content) => {
    const contentWithSpaces = convertSpaces(content);
    const fixedContent = contentWithSpaces.replace(
      /href="(?!http)([^"]+)"/g,
      'href="https://$1"'
    );
    setFormData((prev) => ({
      ...prev,
      company_address: fixedContent,
    }));

    if (isSubmitted && content.trim() !== '') {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.company_address;
        return newErrors;
      });

      setInputState((prev) => ({
        ...prev,
        company_address: true,
      }));
    }
  };

  return (
    <>
      <button className="upload-svg" onClick={handleShow}>
        <AddwithWhiteCircle />{" "}Subcompany
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="five-sixth-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Sub Company</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-form">
            <div className="form-flex-wrap">
              <div title="title" className="flex-column">
                <label
                  htmlFor="title"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Company Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="title"
                  name="title"
                  placeholder="Title"
                  onChange={handleInputChange}
                  value={formData.title}
                  className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
                    }`}
                />
                {errors.title && (
                  <span className="error-message font-size-text ">
                    {errors.title}
                  </span>
                )}
              </div>

              <div title="company_name" className="flex-column">
                <label
                  htmlFor="company_name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Company Full Name
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="company_name"
                  name="company_name"
                  placeholder="Company Name"
                  onChange={handleInputChange}
                  value={formData.company_name}
                  className={`form-input ${errors.company_name
                    ? "error"
                    : inputState.company_name
                      ? "success"
                      : ""
                    }`}
                />
                {errors.company_name && (
                  <span className="error-message font-size-text ">
                    {errors.company_name}
                  </span>
                )}
              </div>

              <div title="company_number" className="flex-column">
                <label
                  htmlFor="company_number"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Company Number
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="company_number"
                  name="company_number"
                  placeholder="Company Number"
                  onChange={handleInputChange}
                  value={formData.company_number}
                  className={`form-input ${errors.company_number
                    ? "error"
                    : inputState.company_number
                      ? "success"
                      : ""
                    }`}
                />
                {errors.company_number && (
                  <span className="error-message font-size-text ">
                    {errors.company_number}
                  </span>
                )}
              </div>

              <div title="company_gst" className="flex-column">
                <label
                  htmlFor="company_gst"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Company Gst Number
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="company_gst"
                  name="company_gst"
                  placeholder="Company Gst"
                  onChange={handleInputChange}
                  value={formData.company_gst}
                  className={`form-input ${errors.company_gst
                    ? "error"
                    : inputState.company_gst
                      ? "success"
                      : ""
                    }`}
                />
                {errors.company_gst && (
                  <span className="error-message font-size-text ">
                    {errors.company_gst}
                  </span>
                )}
              </div>

              <div title="company_address" className="flex-column">
                <label
                  htmlFor="company_address"
                  className="form-labels  font-weight500    font-size-subheading mb-2"
                >
                  Company Address<span className="required">*</span>
                </label>
                <ReactQuill
                  ref={quillRef}
                  theme="snow"
                  value={formData.company_address}
                  onChange={onEditorContentChange}
                  modules={QuillEditorModules}
                  formats={QuillEditorFormats}
                  className={`form-input-quill ${errors.company_address
                    ? "error"
                    : inputState.company_address
                      ? "success"
                      : ""
                    }`}
                />
                {errors.company_address && (
                  <span className="error-message font-size-text mt-2">
                    {errors.company_address}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <div title="company_logo" className="flex-column">
                  <label
                    htmlFor="company_logo"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Company Logo (PNG File)<span className="required">*</span>
                  </label>
                  {/* {formData.company_logo && (
                  <CustomImageModal customStyle>
                    <img
                      src={formData.company_logo}
                      alt="Company Logo Preview"
                      width={100}
                    />
                  </CustomImageModal>
                )} */}
                  <div
                    className={`file-upload-container flex-row justify-between form-input ${errors.company_logo ? "error" : formData.company_logo ? "success" : ""}`}
                  >
                    <label
                      className={`file-label ${errors.company_logo ? "error" : ""}`}
                    >
                      <input
                        type="file"
                        name="company_logo"
                        accept=".png"
                        onChange={handleFileChange}
                        className={`file-input`}
                        style={{ display: "none" }}
                      />
                      <CloudUpload />
                      <span
                        className="text-capitalize"
                        style={{ marginLeft: "20px" }}
                      >
                        {formData.company_logo
                          ? formData.company_logo.name
                          : "No file selected"}
                      </span>
                    </label>
                    {formData.company_logo && (
                      <span
                        className="file-clear"
                        onClick={(e) => handleFileClear("company_logo")}
                      >
                        Clear
                      </span>
                    )}
                  </div>
                  {errors.company_logo && (
                    <span className="error-message font-size-text ">
                      {errors.company_logo}
                    </span>
                  )}
                </div>

                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Letter Templates
                  </label>
                  <select
                    name="company_letter_template"
                    value={formData.company_letter_template}
                    onChange={handleInputChange}
                    className={`form-input`}
                    required
                  >
                    <option value="">Select a Template</option>
                    {lettersTemplate.map((i, index) => (
                      <option key={index} value={i.id}>
                        {i.template_name} - {i.sub_company_title}
                      </option>
                    ))}
                  </select>
                  {formData.company_letter_template && (
                    <div className="flex-row">
                      <ViewLetterBuilder
                        buttonDisplay={"Model-Eye-Name"}
                        buttonDisplayName="Preview Letter Template"
                        templateID={formData?.company_letter_template}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="button-models">
              <button
                type="button"
                onClick={handleClose}
                className="model-button   font-weight500    model-button-cancel"
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmit}
                className="model-button   font-weight500    model-button-submit"
                disabled={loading}
              >
                {loading ? "Adding..." : "Add"}
              </button>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted &&
                Object.keys(errors).length > 0 &&
                (Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">
                    Please fill all mandatory fields!
                  </h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors)
                      .map((field) =>
                        field
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (char) => char.toUpperCase()),
                      )
                      .join(", ") + " are required!"}
                  </h6>
                ))}
            </p>
          </form>
        </Modal.Body>
      </Modal>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};

const UpdateSubCompany = ({ i, getSubCompany }) => {
  const [show, setShow] = useState(false);
  const [lettersTemplate, setLettersTemplateData] = useState([]);
  const [buffer, setBuffering] = useState(true);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    const empCode = sessionStorage.getItem("emp_code");
    getLetterTemplates(i.id);

    setFormData((prev) => ({
      ...prev,
      ...i,
      updated_by: empCode || prev.updated_by,
    }));
    setShow(true);
  };

  const quillRef = useRef();

  const initialData = {
    title: "",
    company_name: "",
    company_address: "",
    company_number: "",
    company_gst: "",
    company_logo: "",
    company_letter_template: "",
    updated_by: sessionStorage.getItem('emp_code')
  }

  const [formData, setFormData] = useState(initialData);

  // !  ************** Validation start **************  ! //
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["title", "company_logo", "company_address"];
    // const requiredFields = ["title", "company_name", "company_address", "company_number", "company_gst", "company_logo"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const { name, value } = e.target;
    const file = e.target.files[0];

    if (file) {
      setFormData({ ...formData, [name]: file, });
    } else {
      console.log('no file')
    }

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const handleFileClear = (name) => {
    setFormData({
      ...formData,
      [name]: null,
    });
  };

  const getLetterTemplates = async (div) => {
    setBuffering(true);
    try {
      const template = await axios.get(
        `${BASE_URL}/wfm/letter-builder-template-bysubcompany/${div || "null"}/`,
      );

      setLettersTemplateData(template.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      setLoading(true);

      const formDatatoupload = new FormData();
      formDatatoupload.append("title", formData.title);
      formDatatoupload.append("company_name", formData.company_name);
      formDatatoupload.append("company_address", formData.company_address);
      formDatatoupload.append("company_number", formData.company_number);
      formDatatoupload.append("company_gst", formData.company_gst);
      formDatatoupload.append(
        "company_letter_template",
        formData.company_letter_template || "",
      );
      formDatatoupload.append("updated_by", formData.updated_by);
      const companyLogo = formData.company_logo;

      if (companyLogo && typeof companyLogo !== "string") {
        const customFile = generateCustomFileForUpload(companyLogo, "Aimantra");
        formDatatoupload.append("company_logo", customFile);
      }

      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/subcompany/${i.id}/`,
          formDatatoupload,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200) {
          setShow(false);
          await getSubCompany();
          toast.success("Subcompany updated successfully.");
        } else {
          console.error(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const convertSpaces = (html) => {
    return html.replace(/  /g, "&nbsp;&nbsp;");
  };
  const onEditorContentChange = (content) => {
    const contentWithSpaces = convertSpaces(content);
    const fixedContent = contentWithSpaces.replace(
      /href="(?!http)([^"]+)"/g,
      'href="https://$1"'
    );
    setFormData((prev) => ({
      ...prev,
      company_address: fixedContent,
    }));

    if (isSubmitted && content.trim() !== '') {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.company_address;
        return newErrors;
      });

      setInputState((prev) => ({
        ...prev,
        company_address: true,
      }));
    }
  };

  return (
    <>
      <button className="model-edit-button-ml" onClick={handleShow}>
        <UpdatePencil />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="five-sixth-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Sub Company {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-form">
            <div className="form-flex-wrap">
              <div title="title" className="flex-column">
                <label
                  htmlFor="title"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Company Name
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="title"
                  name="title"
                  placeholder="Title"
                  onChange={handleInputChange}
                  value={formData.title}
                  className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
                    }`}
                />
                {errors.title && (
                  <span className="error-message font-size-text ">
                    {errors.title}
                  </span>
                )}
              </div>

              <div title="company_name" className="flex-column">
                <label
                  htmlFor="company_name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Company Full Name
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="company_name"
                  name="company_name"
                  placeholder="Company Name"
                  onChange={handleInputChange}
                  value={formData.company_name}
                  className={`form-input ${errors.company_name
                    ? "error"
                    : inputState.company_name
                      ? "success"
                      : ""
                    }`}
                />
                {errors.company_name && (
                  <span className="error-message font-size-text ">
                    {errors.company_name}
                  </span>
                )}
              </div>

              <div title="company_number" className="flex-column">
                <label
                  htmlFor="company_number"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Company Number
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="company_number"
                  name="company_number"
                  placeholder="Company Number"
                  onChange={handleInputChange}
                  value={formData.company_number}
                  className={`form-input ${errors.company_number
                    ? "error"
                    : inputState.company_number
                      ? "success"
                      : ""
                    }`}
                />
                {errors.company_number && (
                  <span className="error-message font-size-text ">
                    {errors.company_number}
                  </span>
                )}
              </div>

              <div title="company_gst" className="flex-column">
                <label
                  htmlFor="company_gst"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Company Gst Number
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="company_gst"
                  name="company_gst"
                  placeholder="Company Gst"
                  onChange={handleInputChange}
                  value={formData.company_gst}
                  className={`form-input ${errors.company_gst
                    ? "error"
                    : inputState.company_gst
                      ? "success"
                      : ""
                    }`}
                />
                {errors.company_gst && (
                  <span className="error-message font-size-text ">
                    {errors.company_gst}
                  </span>
                )}
              </div>

              <div title="company_address" className="flex-column">
                <label
                  htmlFor="company_address"
                  className="form-labels  font-weight500 mb-2   font-size-subheading"
                >
                  Company Address
                </label>

                <ReactQuill
                  ref={quillRef}
                  theme="snow"
                  value={formData.company_address}
                  onChange={onEditorContentChange}
                  modules={QuillEditorModules}
                  formats={QuillEditorFormats}
                  className={`form-input-quill  ${errors.company_address
                    ? "error"
                    : inputState.company_address
                      ? "success"
                      : ""
                    }`}
                />
                {errors.company_address && (
                  <span className="error-message font-size-text mt-2">
                    {errors.company_address}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <div title="company_logo" className="flex-column">
                  <label
                    htmlFor="company_logo"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Company Logo (PNG File):
                  </label>
                  {formData.company_logo && (
                    <CustomImageModal customStyle>
                      <img
                        src={formData.company_logo}
                        alt="Company Logo Preview"
                        width={100}
                      />
                    </CustomImageModal>
                  )}
                  <div
                    className={`file-upload-container flex-row justify-between form-input ${errors.company_logo ? 'error' : formData.company_logo ? 'success' : ''}`}
                  >
                    <label
                      className={`file-label ${errors.company_logo ? 'error' : ''}`}
                    >
                      <input
                        type="file"
                        name="company_logo"
                        accept=".png"
                        onChange={handleFileChange}
                        className={`file-input`}
                        style={{ display: "none" }}
                      />
                      <CloudUpload />
                      <span className="text-capitalize" style={{ marginLeft: "20px" }}>
                        {formData.company_logo ? formData.company_logo.name : 'No file selected'}
                      </span>
                    </label>
                    {formData.company_logo && (
                      <span
                        className="file-clear"
                        onClick={(e) => handleFileClear("company_logo")}
                      >
                        Clear
                      </span>
                    )}
                  </div>
                  {errors.company_logo && (
                    <span className="error-message font-size-text ">
                      {errors.company_logo}
                    </span>
                  )}
                </div>

                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Letter Templates
                  </label>
                  <select
                    name="company_letter_template"
                    value={formData.company_letter_template}
                    onChange={handleInputChange}
                    className={`form-input`}
                    required
                  >
                    <option value="">Select a Template</option>
                    {lettersTemplate.map((i, index) => (
                      <option key={index} value={i.id}>
                        {i.template_name}
                      </option>
                    ))}
                  </select>
                  {formData?.company_letter_template && (
                    <div className="flex-row">
                      <ViewLetterBuilder
                        buttonDisplay={"Model-Eye-Name"}
                        buttonDisplayName="Preview Letter Template"
                        templateID={formData?.company_letter_template}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="button-models">
              <button
                type="button"
                onClick={handleClose}
                className="model-button   font-weight500    model-button-cancel"
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitPut}
                className="model-button   font-weight500    model-button-submit"
                disabled={loading}
              >
                {/* //loading logic */}
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted && Object.keys(errors).length > 0 && (
                Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">Please fill all mandatory fields!</h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors)
                      .map((field) =>
                        field
                          .replace(/_/g, ' ')
                          .replace(/\b\w/g, (char) => char.toUpperCase())
                      )
                      .join(', ') + ' are required!'}
                  </h6>
                )
              )}
            </p>
          </form>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const DeleteSubCompany = ({ i, getSubCompany }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    setLoading(true); //loading logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/subcompany/${i.id}/`);

      if (res.status === 200) {
        setShow(false);
        await getSubCompany();
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId);
    } finally {
      setLoading(false); //loading logic
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete SubCompany"
        className="model-delete-button"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete SubCompany "{i.title}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete the SubCompany - "<b>{i?.title}</b>"
            <div className="subcompany-details">
              <div className="align-center">
                {i?.company_logo ? (
                  <CustomImageModal customStyle>
                    <img
                      src={i?.company_logo}
                      alt="Logo Preview"
                      className=" user_img_display"
                    // alt="profile" className='width-5vw image-radius'
                    />
                  </CustomImageModal>
                ) : (
                  "-No Logo-"
                )}
              </div>
              <ul>
                <li>
                  <b>Name:</b> {i?.title || "-"}
                </li>
                <li>
                  <b>Company Full Name:</b> {i?.company_name || "-"}
                </li>
                <li className="flex gap-1">
                  <span>
                    <b>Address:</b>
                  </span>{" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: i?.company_address || "-",
                    }}
                  ></span>
                </li>
                <li>
                  <b>GST:</b> {i?.company_gst || "-"}
                </li>
                <li>
                  <b>Number:</b> {i?.company_number || "-"}
                </li>
                <li className={i?.active_employee_count > 0 ? "required" : ""}>
                  <b>Active Employees:</b> {i?.active_employee_count ?? "-"}
                </li>
              </ul>
            </div>
            {i?.active_employee_count > 0 && (
              <div className="flex-column" style={{ marginTop: "5px" }}>
                <label
                  className="form-labels font-weight500 font-size-subheading flex item-center gap-1"
                  style={{ marginTop: "5px" }}
                >
                  <input
                    type="checkbox"
                    checked={deleteConfirmation}
                    onChange={(e) => setDeleteConfirmation(e.target.checked)}
                  />
                  <span style={{ color: "red" }}>
                    {`Note: This Subcompany has is ${i?.active_employee_count || 0} Employees. Please confirm you still want to delete this record.`}
                  </span>
                </label>
              </div>
            )}
            <div className="button-models">
              <button
                className="model-button model-button-cancel   font-weight500    "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                // className="model-button   font-weight500    model-button-delete"
                className={
                  i?.active_employee_count > 0 && !deleteConfirmation
                    ? "model-button model-button-cancel font-weight500"
                    : "model-button model-button-delete font-weight500 font-size-heading"
                }
                disabled={
                  loading ||
                  (i?.active_employee_count > 0 && !deleteConfirmation)
                }
              >
                {i?.active_employee_count > 0 && !deleteConfirmation
                  ? "Confirm Delete"
                  : loading
                    ? "Deleting..."
                    : "Delete"}
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ? *************** SubComany Crud Models End ***************

// ! *************** Sub Company Crud Models Start ***************

const Woksiteadd = ({ getWoksiteList }) => {
  const [show, setShow] = useState(false);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    title: "",
    sub_company: sessionStorage.getItem("company_id"),
    updated_by: sessionStorage.getItem("emp_code"),
  });

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["title"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      setLoading(true); //loading logic
      try {
        let res = await axios.post(`${BASE_URL}/wfm/worksite/`, formData);

        if (res.status === 200) {
          setShow(false);
          await getWoksiteList();
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button className="upload-svg" title="Add Worksite" onClick={handleShow}>
        <AddwithWhiteCircle /> Add Worksite
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        {/* <Modal.Header closeButton>
              <Modal.Title>Request Leave</Modal.Title>
            </Modal.Header> */}
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}
              <div className="flex-column">
                <label
                  htmlFor="title"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Worksite Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Worksite Name"
                  onChange={handleInputChange}
                  value={formData.title}
                  className={`form-input ${errors.title ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.title && (
                  <span className="error-message font-size-text ">
                    {errors.title}
                  </span>
                )}
                {PERMISSION_AUTHORITY ? (
                  <div className="flex-column">
                    <label
                      htmlFor="sub_company"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Sub Company<span className="required">*</span>
                    </label>
                    <select
                      id="sub_company"
                      name="sub_company"
                      value={formData.sub_company}
                      onChange={handleInputChange}
                      className={`form-input form-group-selection ${errors.sub_company
                        ? "error"
                        : inputState.sub_company
                          ? "success"
                          : ""
                        }`}
                    >
                      {SUB_COMPANIES.map((company) => (
                        <option value={company.id}>{company.title}</option>
                      ))}
                      ;
                    </select>
                    {errors.title && (
                      <span className="error-message font-size-text ">
                        {errors.title}
                      </span>
                    )}
                  </div>
                ) : null}
                <div className="button-models">
                  <button
                    className="model-button   font-weight500   "
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    //   type="submit"
                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                    onClick={handleFormSubmit}
                    disabled={loading}
                  >
                    Submit
                  </button>
                </div>{" "}
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const Woksiteupdate = ({ i, getWoksiteList }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    title: "",
    updated_by: sessionStorage.getItem("emp_code"),
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["title"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/worksite/${i.id}/`,
          formData,
        );

        if (res.status === 200) {
          setShow(false);
          await getWoksiteList();
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button className="model-edit-button-ml" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
            fill="#145650"
          />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Worksite Name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}
              <div className="flex-column">
                <label
                  htmlFor="title"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Worksite Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Worksite Name"
                  onChange={handleInputChange}
                  value={formData.title}
                  className={`form-input ${errors.title ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.title && (
                  <span className="error-message font-size-text ">
                    {errors.title}
                  </span>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button   font-weight500    "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  onClick={handleFormSubmitPut}
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const WoksiteDelete = ({ i, getWoksiteList }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/worksite/${i.id}/`);

      if (res.status === 200) {
        setShow(false);
        await getWoksiteList();
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="model-delete-button" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete this Worksite</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete worksite with name {i.title}
            <div className="button-models">
              <button
                className="model-button   font-weight500    "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ? *************** SubComany Crud Models End ***************

// ! *************** Attendance Policy Crud Models Start ***************

const AttendancePolicyBackup = ({ getAttPolicyName }) => {
  const [show, setShow] = useState(false);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    name: "",
    ontime: false,
    ontime_in_time_check: false,
    ontime_in_time: "",
    ontime_out_time: "",
    ontime_durations: false,
    ontime_duration: "",

    late_mark: false,
    late_in_time_check: false,
    late_in_time: "",
    late_out_time: "",
    late_durations: false,
    late_duration: "",

    halfday: false,
    halfday_in_time_check: false,
    halfday_in_time: "",
    halfday_out_time: "",
    halfday_durations: false,
    halfday_duration: "",
    shortleave_durations: false,
    shortleave_duration: "",
    weeklyoff_durations: false,
    weeklyoff_duration: "",
    apply_shortleave_duration: "",
    rectified_late_mark_count: 0,

    sub_company: sessionStorage.getItem("company_id"),
    updated_by: sessionStorage.getItem("emp_code"),
  });

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["name"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      setLoading(true); //loading logic
      try {
        let res = await axios.post(
          `${BASE_URL}/wfm/attendancepolicy/`,
          formData,
        );

        if (res.status === 200) {
          await getAttPolicyName();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="upload-svg"
        title="Add Attendance Policy"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> Attendance Policy
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        {/* <Modal.Header closeButton>
              <Modal.Title>Request Leave</Modal.Title>
            </Modal.Header> */}
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}
              <div className="flex-column">
                <label
                  htmlFor="name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Attendance Policy Name"
                  onChange={handleInputChange}
                  value={formData.name}
                  className={`form-input ${errors.name ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.name && (
                  <span className="error-message font-size-text ">
                    {errors.name}
                  </span>
                )}
              </div>
              {PERMISSION_AUTHORITY ? (
                <div className="flex-column">
                  <label
                    htmlFor="sub_company"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Sub Company<span className="required">*</span>
                  </label>
                  <select
                    id="sub_company"
                    name="sub_company"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.sub_company
                      ? "error"
                      : inputState.sub_company
                        ? "success"
                        : ""
                      }`}
                  >
                    {SUB_COMPANIES.map((company) => (
                      <option value={company.id}>{company.title}</option>
                    ))}
                    ;
                  </select>
                  {errors.title && (
                    <span className="error-message font-size-text ">
                      {errors.title}
                    </span>
                  )}
                </div>
              ) : null}
              <div className="flex-row ">
                <div className="flex-column">
                  <label
                    htmlFor="rectified_late_mark_count"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Rectified Late Mark<span className="required">*</span>
                  </label>
                  <input
                    type="number"
                    id="rectified_late_mark_count"
                    name="rectified_late_mark_count"
                    placeholder="Number of rectified late Marks"
                    onChange={handleInputChange}
                    value={formData.rectified_late_mark_count}
                    className={`multi-day-input1 ${errors.rectified_late_mark_count
                      ? "error"
                      : inputState.tile
                        ? "success"
                        : ""
                      }`}
                  />
                  {errors.rectified_late_mark_count && (
                    <span className="error-message font-size-text ">
                      {errors.rectified_late_mark_count}
                    </span>
                  )}
                </div>

                <div className="flex-column multi-day">
                  <label
                    htmlFor="apply_shortleave_duration"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Apply Short Leave Eligibility Durations
                  </label>
                  <input
                    type="text"
                    id="apply_shortleave_duration"
                    name="apply_shortleave_duration"
                    placeholder="00.0"
                    onChange={handleInputChange}
                    value={formData.apply_shortleave_duration}
                    className={`multi-day-input1 form-input-background`}
                  />
                </div>
              </div>

              {/* <div className="flex-row">

                <div className="flex-column">

                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label htmlFor="rectified_late_mark_count" className="form-labels  font-weight500    font-size-subheading">
                        Rectified Late Marks <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        id="rectified_late_mark_count"
                        name="rectified_late_mark_count"
                         placeholder="00.0"
                        onChange={handleInputChange}
                        value={formData.rectified_late_mark_count}
                        className={`multi-day-input1 form-input-background`}
                      />
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="flex-row">
                <label
                  htmlFor="name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Ontime Check
                </label>
                <input
                  type="checkbox"
                  name="ontime"
                  onChange={handleInputChange}
                  checked={formData.ontime}
                  className={`form-checkbox`}
                />
              </div>

              <div className="flex-row justify-between">
                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Ontime In-Time Check
                    </label>
                    <input
                      type="checkbox"
                      name="ontime_in_time_check"
                      onChange={handleInputChange}
                      checked={formData.ontime_in_time_check}
                      className={`form-checkbox`}
                    />
                  </div>
                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label className="form-labels  font-weight500    font-size-subheading">
                        Ontime In Time
                      </label>
                      <input
                        className="multi-day-input1 form-input-background"
                        type="time"
                        step="1"
                        name="ontime_in_time"
                        value={formData.ontime_in_time}
                        onChange={handleInputChange}
                      />
                    </div>
                    {/* <div className="flex-column multi-day">
                  <label className="form-labels  font-weight500    font-size-subheading">Ontime Out Time</label>
                  <input
                    className="multi-day-input1 form-input-background"
                    name="ontime_out_time"
                    type="time"
                    step="1"
                    value={formData.ontime_out_time}
                    onChange={handleInputChange}
                  />
                </div> */}
                  </div>
                </div>

                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Ontime Work Durations
                    </label>
                    <input
                      type="checkbox"
                      name="ontime_durations"
                      onChange={handleInputChange}
                      checked={formData.ontime_durations}
                      className={`form-checkbox`}
                    />
                  </div>

                  <div className="flex-column">
                    <label
                      htmlFor="ontime_duration"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Ontime Work Durations
                    </label>
                    <input
                      type="text"
                      id="ontime_duration"
                      name="ontime_duration"
                      placeholder="0.00"
                      onChange={handleInputChange}
                      value={formData.ontime_duration}
                      className={`multi-day-input1 form-input-background`}
                    />
                  </div>
                </div>
              </div>

              <div className="flex-row">
                <label
                  htmlFor="late_mark"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Late Check
                </label>
                <input
                  type="checkbox"
                  name="late_mark"
                  onChange={handleInputChange}
                  checked={formData.late_mark}
                  className={`form-checkbox`}
                />
              </div>

              <div className="flex-row justify-between">
                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Late In-Time Check
                    </label>
                    <input
                      type="checkbox"
                      name="late_in_time_check"
                      onChange={handleInputChange}
                      checked={formData.late_in_time_check}
                      className={`form-checkbox`}
                    />
                  </div>
                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label className="form-labels  font-weight500    font-size-subheading">
                        Late In Time
                      </label>
                      <input
                        className="multi-day-input1 form-input-background"
                        type="time"
                        step="1"
                        name="late_in_time"
                        value={formData.late_in_time}
                        onChange={handleInputChange}
                      />
                    </div>
                    {/* <div className="flex-column multi-day">
                  <label className="form-labels  font-weight500    font-size-subheading">Late Out Time</label>
                  <input
                    className="multi-day-input1 form-input-background"
                    name="late_out_time"
                    type="time"
                    step="1"
                    value={formData.late_out_time}
                    onChange={handleInputChange}
                  />
                </div> */}
                  </div>
                </div>

                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Late Work Durations
                    </label>
                    <input
                      type="checkbox"
                      name="late_durations"
                      onChange={handleInputChange}
                      checked={formData.late_durations}
                      className={`form-checkbox`}
                    />
                  </div>

                  <div className="flex-column">
                    <label
                      htmlFor="late_duration"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Late Work Durations
                    </label>
                    <input
                      type="text"
                      id="late_duration"
                      name="late_duration"
                      placeholder="0.00"
                      onChange={handleInputChange}
                      value={formData.late_duration}
                      className={`multi-day-input1 form-input-background`}
                    />
                  </div>
                </div>
              </div>

              <div className="flex-row">
                <label
                  htmlFor="name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Halfday Check
                </label>
                <input
                  type="checkbox"
                  name="halfday"
                  onChange={handleInputChange}
                  checked={formData.halfday}
                  className={`form-checkbox`}
                />
              </div>

              <div className="flex-row justify-between">
                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Halfday In-Time Check
                    </label>
                    <input
                      type="checkbox"
                      name="halfday_in_time_check"
                      onChange={handleInputChange}
                      checked={formData.halfday_in_time_check}
                      className={`form-checkbox`}
                    />
                  </div>

                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label className="form-labels  font-weight500    font-size-subheading">
                        Halfday In Time
                      </label>
                      <input
                        className="multi-day-input1 form-input-background"
                        type="time"
                        step="1"
                        name="halfday_in_time"
                        value={formData.halfday_in_time}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  {/* <div className="flex-column multi-day">
                  <label className="form-labels  font-weight500    font-size-subheading">Halfday Out Time</label>
                  <input
                    className="multi-day-input1 form-input-background"
                    name="halfday_out_time"
                    type="time"
                    step="1"
                    value={formData.halfday_out_time}
                    onChange={handleInputChange}
                  />
                </div> */}
                </div>

                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="halfday_durations"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Halfday Work Durations
                    </label>
                    <input
                      type="checkbox"
                      name="halfday_durations"
                      onChange={handleInputChange}
                      checked={formData.halfday_durations}
                      className={`form-checkbox`}
                    />
                  </div>

                  <div className="flex-column">
                    <label
                      htmlFor="halfday_duration"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Halfday Work Durations
                    </label>
                    <input
                      type="text"
                      id="halfday_duration"
                      name="halfday_duration"
                      placeholder="0.00"
                      onChange={handleInputChange}
                      value={formData.halfday_duration}
                      className={`multi-day-input1 form-input-background`}
                    />
                  </div>
                </div>
              </div>

              <div className="flex-row justify-between">
                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="shortleave_durations"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Short Leave Eligibility
                    </label>
                    <input
                      type="checkbox"
                      name="shortleave_durations"
                      onChange={handleInputChange}
                      checked={formData.shortleave_durations}
                      className={`form-checkbox`}
                    />
                  </div>

                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label
                        htmlFor="shortleave_duration"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Short Leave Eligibility Work Durations
                      </label>
                      <input
                        type="text"
                        id="shortleave_duration"
                        name="shortleave_duration"
                        placeholder="00.0"
                        onChange={handleInputChange}
                        value={formData.shortleave_duration}
                        className={`multi-day-input1 form-input-background`}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="weeklyoff_durations"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      WeeklyOff Eligibility
                    </label>
                    <input
                      type="checkbox"
                      name="weeklyoff_durations"
                      onChange={handleInputChange}
                      checked={formData.weeklyoff_durations}
                      className={`form-checkbox`}
                    />
                  </div>
                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label
                        htmlFor="weeklyoff_duration"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        WeeklyOff Eligibility Work Durations
                      </label>
                      <input
                        type="text"
                        id="weeklyoff_duration"
                        name="weeklyoff_duration"
                        placeholder="00.0"
                        onChange={handleInputChange}
                        value={formData.weeklyoff_duration}
                        className={`multi-day-input1 form-input-background`}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="flex-row policy-input width-15vw">
                <div className="flex-column multi-day">
                  <label htmlFor="apply_shortleave_duration" className="form-labels  font-weight500    font-size-subheading">
                    Apply Short Leave Eligibility Durations
                  </label>
                  <input
                    type="text"
                    id="apply_shortleave_duration"
                    name="apply_shortleave_duration"
                    placeholder="00.0"
                    onChange={handleInputChange}
                    value={formData.apply_shortleave_duration}
                    className={`multi-day-input1 form-input-background`}
                  />
                </div>
              </div> */}

              <div className="button-models">
                <button
                  className="model-button model-button-cancel font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const AttendancePolicyUpdateBackup = ({ i, getAttPolicyName }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    name: "",
    ontime: false,
    ontime_in_time_check: false,
    ontime_in_time: "",
    ontime_out_time: "",
    ontime_durations: false,
    ontime_duration: "",

    late_mark: false,
    late_in_time_check: false,
    late_in_time: "",
    late_out_time: "",
    late_durations: false,
    late_duration: "",

    halfday: false,
    halfday_in_time_check: false,
    halfday_in_time: "",
    halfday_out_time: "",
    halfday_durations: false,
    halfday_duration: "",
    shortleave_durations: false,
    shortleave_duration: "",
    weeklyoff_durations: false,
    weeklyoff_duration: "",
    rectified_late_mark_count: 0,
    updated_by: sessionStorage.getItem("emp_code"),
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  console.log(formData);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["name", "rectified_late_mark_count"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ?  ************** Validation End **************  ! //

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/attendancepolicy/${i.id}/`,
          formData,
        );

        if (res.status === 200) {
          await getAttPolicyName();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Update Attendance Policy"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Policy {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}
              <div className="flex-column">
                <label
                  htmlFor="name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Attendance Policy Name"
                  onChange={handleInputChange}
                  value={formData.name}
                  className={`form-input ${errors.name ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.name && (
                  <span className="error-message font-size-text ">
                    {errors.name}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="rectified_late_mark_count"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Rectified Late Mark<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id="rectified_late_mark_count"
                  min={0}
                  name="rectified_late_mark_count"
                  placeholder="Number of rectified late Marks"
                  onChange={handleInputChange}
                  value={formData.rectified_late_mark_count}
                  className={`form-input ${errors.rectified_late_mark_count
                    ? "error"
                    : inputState.tile
                      ? "success"
                      : ""
                    }`}
                />
                {errors.rectified_late_mark_count && (
                  <span className="error-message font-size-text ">
                    {errors.rectified_late_mark_count}
                  </span>
                )}
              </div>
              <div className="flex-row">
                <label
                  htmlFor="name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Ontime Check
                </label>
                <input
                  type="checkbox"
                  name="ontime"
                  onChange={handleInputChange}
                  checked={formData.ontime}
                  className={`form-checkbox`}
                />
              </div>

              <div className="flex-row">
                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Ontime In-Time Check
                    </label>
                    <input
                      type="checkbox"
                      name="ontime_in_time_check"
                      onChange={handleInputChange}
                      checked={formData.ontime_in_time_check}
                      className={`form-checkbox`}
                    />
                  </div>

                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label className="form-labels  font-weight500    font-size-subheading">
                        Ontime In Time
                      </label>
                      <input
                        className="multi-day-input1 form-input-background"
                        type="time"
                        step="1"
                        name="ontime_in_time"
                        value={formData.ontime_in_time}
                        onChange={handleInputChange}
                      />
                    </div>
                    {/* <div className="flex-column multi-day">
                  <label className="form-labels  font-weight500    font-size-subheading">Ontime Out Time</label>
                  <input
                    className="multi-day-input1 form-input-background"
                    name="ontime_out_time"
                    type="time"
                    step="1"
                    value={formData.ontime_out_time}
                    onChange={handleInputChange}
                  />
                </div> */}
                  </div>
                </div>

                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Ontime Work Durations
                    </label>
                    <input
                      type="checkbox"
                      name="ontime_durations"
                      onChange={handleInputChange}
                      checked={formData.ontime_durations}
                      className={`form-checkbox`}
                    />
                  </div>

                  <div className="flex-column">
                    <label
                      htmlFor="ontime_duration"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Ontime Work Durations
                    </label>
                    <input
                      type="text"
                      id="ontime_duration"
                      name="ontime_duration"
                      placeholder="0.00"
                      onChange={handleInputChange}
                      value={formData.ontime_duration}
                      className={`multi-day-input1 form-input-background`}
                    />
                  </div>
                </div>
              </div>

              <div className="flex-row">
                <label
                  htmlFor="late_mark"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Late Check
                </label>
                <input
                  type="checkbox"
                  name="late_mark"
                  onChange={handleInputChange}
                  checked={formData.late_mark}
                  className={`form-checkbox`}
                />
              </div>

              <div className="flex-row">
                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Late In-Time Check
                    </label>
                    <input
                      type="checkbox"
                      name="late_in_time_check"
                      onChange={handleInputChange}
                      checked={formData.late_in_time_check}
                      className={`form-checkbox`}
                    />
                  </div>

                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label className="form-labels  font-weight500    font-size-subheading">
                        Late In Time
                      </label>
                      <input
                        className="multi-day-input1 form-input-background"
                        type="time"
                        step="1"
                        name="late_in_time"
                        value={formData.late_in_time}
                        onChange={handleInputChange}
                      />
                    </div>
                    {/* <div className="flex-column multi-day">
                  <label className="form-labels  font-weight500    font-size-subheading">Late Out Time</label>
                  <input
                    className="multi-day-input1 form-input-background"
                    name="late_out_time"
                    type="time"
                    step="1"
                    value={formData.late_out_time}
                    onChange={handleInputChange}
                  />
                </div> */}
                  </div>
                </div>

                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Late Work Durations
                    </label>
                    <input
                      type="checkbox"
                      name="late_durations"
                      onChange={handleInputChange}
                      checked={formData.late_durations}
                      className={`form-checkbox`}
                    />
                  </div>

                  <div className="flex-column">
                    <label
                      htmlFor="late_duration"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Late Work Durations
                    </label>
                    <input
                      type="text"
                      id="late_duration"
                      name="late_duration"
                      placeholder="0.00"
                      onChange={handleInputChange}
                      value={formData.late_duration}
                      className={`multi-day-input1 form-input-background`}
                    />
                  </div>
                </div>
              </div>

              <div className="flex-row">
                <label
                  htmlFor="name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Halfday Check
                </label>
                <input
                  type="checkbox"
                  name="halfday"
                  onChange={handleInputChange}
                  checked={formData.halfday}
                  className={`form-checkbox`}
                />
              </div>

              <div className="flex-row">
                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Halfday In-Time Check
                    </label>
                    <input
                      type="checkbox"
                      name="halfday_in_time_check"
                      onChange={handleInputChange}
                      checked={formData.halfday_in_time_check}
                      className={`form-checkbox`}
                    />
                  </div>

                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label className="form-labels  font-weight500    font-size-subheading">
                        Halfday In Time
                      </label>
                      <input
                        className="multi-day-input1 form-input-background"
                        type="time"
                        step="1"
                        name="halfday_in_time"
                        value={formData.halfday_in_time}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  {/* <div className="flex-column multi-day">
                  <label className="form-labels  font-weight500    font-size-subheading">Halfday Out Time</label>
                  <input
                    className="multi-day-input1 form-input-background"
                    name="halfday_out_time"
                    type="time"
                    step="1"
                    value={formData.halfday_out_time}
                    onChange={handleInputChange}
                  />
                </div> */}
                </div>

                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Halfday Work Durations
                    </label>
                    <input
                      type="checkbox"
                      name="halfday_durations"
                      onChange={handleInputChange}
                      checked={formData.halfday_durations}
                      className={`form-checkbox`}
                    />
                  </div>

                  <div className="flex-column">
                    <label
                      htmlFor="halfday_duration"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Halfday Work Durations
                    </label>
                    <input
                      type="text"
                      id="halfday_duration"
                      name="halfday_duration"
                      placeholder="0.00"
                      onChange={handleInputChange}
                      value={formData.halfday_duration}
                      className={`multi-day-input1 form-input-background`}
                    />
                  </div>
                </div>
              </div>

              <div className="flex-row">
                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="shortleave_durations"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Short Leave Eligibility
                    </label>
                    <input
                      type="checkbox"
                      name="shortleave_durations"
                      onChange={handleInputChange}
                      checked={formData.shortleave_durations}
                      className={`form-checkbox`}
                    />
                  </div>

                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label
                        htmlFor="shortleave_duration"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Short Leave Eligibility Work Durations
                      </label>
                      <input
                        type="text"
                        id="shortleave_duration"
                        name="shortleave_duration"
                        placeholder="00.0"
                        onChange={handleInputChange}
                        value={formData.shortleave_duration}
                        className={`multi-day-input1 form-input-background`}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="weeklyoff_durations"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      WeeklyOff Eligibility
                    </label>
                    <input
                      type="checkbox"
                      name="weeklyoff_durations"
                      onChange={handleInputChange}
                      checked={formData.weeklyoff_durations}
                      className={`form-checkbox`}
                    />
                  </div>
                  <div className="flex-row">
                    <div className="flex-column multi-day">
                      <label
                        htmlFor="weeklyoff_duration"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        WeeklyOff Eligibility Work Durations
                      </label>
                      <input
                        type="text"
                        id="weeklyoff_duration"
                        name="weeklyoff_duration"
                        placeholder="00.0"
                        onChange={handleInputChange}
                        value={formData.weeklyoff_duration}
                        className={`multi-day-input1 form-input-background`}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="button-models">
                <button
                  className="model-button model-button-cancel font-weight500"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmitPut}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};



const AttendancePolicyAdd = ({ getAttPolicyList, SUB_COMPANIES, PERMISSION_AUTHORITY }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setFormData(initialData)
    setErrors({})
    setShow(false)
  };
  const handleShow = () => {
    setShow(true)
  };

  const initialData = {
    name: "",

    ontime: false,
    ontime_in_time_check: false,
    ontime_in_time: "",
    ontime_out_time: "",
    ontime_durations: false,
    ontime_duration: "",

    late_mark: false,
    late_in_time_check: false,
    late_in_time: "",
    late_out_time: "",
    late_durations: false,
    late_duration: "",

    halfday: false,
    halfday_in_time_check: false,
    halfday_in_time: "",
    halfday_out_time: "",
    halfday_durations: false,
    halfday_duration: "",

    shortleave_durations: false,
    shortleave_duration: "",

    weeklyoff_durations: false,
    weeklyoff_duration: "",

    rectified_late_mark_count: "",
    apply_shortleave_duration: "",

    sub_company: sessionStorage.getItem("company_id"),
    updated_by: sessionStorage.getItem("emp_code"),
  }

  const [formData, setFormData] = useState(initialData);

  // !  ************** Validation start **************  ! //
  const [inputState, setInputState] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "name",
      "sub_company",
      "rectified_late_mark_count",
      "apply_shortleave_duration",
      formData.ontime_in_time_check ? 'ontime_in_time' : null,
      formData.ontime_durations ? 'ontime_duration' : null,
      formData.late_in_time_check ? 'late_in_time' : null,
      formData.late_durations ? 'late_duration' : null,
      formData.halfday_in_time_check ? 'halfday_in_time' : null,
      formData.halfday_durations ? 'halfday_duration' : null,
      formData.shortleave_durations ? 'shortleave_duration' : null,
      formData.weeklyoff_durations ? 'weeklyoff_duration' : null,
      formData.halfday_durations ? 'halfday_duration' : null,
    ].filter(Boolean);

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Please wait...");
      try {
        setLoading(true);
        let res = await axios.post(`${BASE_URL}/wfm/attendancepolicy/`, formData);

        if (res.status === 200) {
          await getAttPolicyList();
          setShow(false);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="upload-svg"
        title="Add Attendance Policy"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> Attendance Policy
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="three-fourth-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Attendance Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="attendance-policy-container">
            {/* BASIC INFO */}

            <div className="att-policy-card">
              <div className="att-policy-title">Basic Information</div>

              <div className="content-tabs att-policy-checkbox-row">
                <div className="att-policy-header-grid">
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Policy Name<span className="required">*</span>
                    </label>

                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className={!PERMISSION_AUTHORITY ? "form-input" : "form-input-half-half"}
                      placeholder="Attendance Policy Name"
                    />
                    {errors.name && (
                      <span className="error-message font-size-text ">
                        {errors.name}
                      </span>
                    )}
                  </div>
                </div>

                {PERMISSION_AUTHORITY ? (
                  <div className="att-policy-header-grid">
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading">
                        Sub Company<span className="required">*</span>
                      </label>
                      <select
                        id="sub_company"
                        name="sub_company"
                        value={formData.sub_company}
                        onChange={handleInputChange}
                        className={`form-input-half-half ${errors.sub_company
                          ? "error"
                          : inputState.sub_company
                            ? "success"
                            : ""
                          }`}
                      >
                        {SUB_COMPANIES.map((company) => (
                          <option value={company.id}>{company.title}</option>
                        ))}
                        ;
                      </select>
                      {errors.title && (
                        <span className="error-message font-size-text ">
                          {errors.title}
                        </span>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>

            </div>

            {/* Extras */}

            <div className="att-policy-card">
              <div className="att-policy-block">
                <div className="att-policy-grid">
                  <div className="att-policy-input-group">
                    <label>Allowed Rectified Late Marks</label>

                    <input
                      type="number"
                      name="rectified_late_mark_count"
                      value={formData.rectified_late_mark_count}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="00.0"
                    />
                    {errors.rectified_late_mark_count && (
                      <span className="error-message font-size-text ">
                        {errors.rectified_late_mark_count}
                      </span>
                    )}
                  </div>

                  <div className="att-policy-input-group">
                    <label> Apply Short Leave Eligibility Duration</label>

                    <input
                      type="text"
                      name="apply_shortleave_duration"
                      value={formData.apply_shortleave_duration}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="00.0"
                    />
                    {errors.apply_shortleave_duration && (
                      <span className="error-message font-size-text ">
                        {errors.apply_shortleave_duration}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* ONTIME POLICY */}

            <div className="att-policy-card">
              <div className="att-policy-checkbox-row">
                <label
                  className="att-policy-title"
                  style={{ cursor: "pointer" }}
                  htmlFor="ontime"
                >
                  Enable Ontime Rules
                </label>
                <label className="checkbox-click">
                  <input
                    id="ontime"
                    type="checkbox"
                    name="ontime"
                    checked={formData.ontime}
                    onChange={handleInputChange}
                  />
                  <div className="checkmark-medium "></div>
                </label>
              </div>

              <div className="att-policy-block">
                <div className="att-policy-grid">
                  <div className="att-policy-input-group">
                    <div className="att-policy-checkbox-row">
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor="ontime_in_time_check"
                      >
                        Ontime In Time
                      </label>
                      <label className="checkbox-click">
                        <input
                          id="ontime_in_time_check"
                          type="checkbox"
                          name="ontime_in_time_check"
                          checked={formData.ontime_in_time_check}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium "></div>
                      </label>
                    </div>

                    <input
                      type="time"
                      name="ontime_in_time"
                      value={formData.ontime_in_time}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                    />
                    {errors.ontime_in_time && (
                      <span className="error-message font-size-text ">
                        {errors.ontime_in_time}
                      </span>
                    )}
                  </div>

                  <div className="att-policy-input-group">
                    <div className="att-policy-checkbox-row">
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor="ontime_durations"
                      >
                        Ontime Duration
                      </label>
                      <label className="checkbox-click">
                        <input
                          id="ontime_durations"
                          type="checkbox"
                          name="ontime_durations"
                          checked={formData.ontime_durations}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium "></div>
                      </label>
                    </div>
                    <input
                      type="text"
                      name="ontime_duration"
                      value={formData.ontime_duration}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="00.0"
                    />
                    {errors.ontime_duration && (
                      <span className="error-message font-size-text ">
                        {errors.ontime_duration}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* LATE POLICY */}

            <div className="att-policy-card">

              <div className="att-policy-checkbox-row">
                <label
                  className="att-policy-title"
                  style={{ cursor: "pointer" }}
                  htmlFor="late_mark"
                >
                  Enable Late Rules
                </label>
                <label className="checkbox-click">
                  <input
                    id="late_mark"
                    type="checkbox"
                    name="late_mark"
                    checked={formData.late_mark}
                    onChange={handleInputChange}
                  />
                  <div className="checkmark-medium "></div>
                </label>
              </div>

              <div className="att-policy-block">

                <div className="att-policy-grid">
                  <div className="att-policy-input-group">
                    <div className="att-policy-checkbox-row">
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor="late_in_time_check"
                      >
                        Late In Time
                      </label>
                      <label className="checkbox-click">
                        <input
                          id="late_in_time_check"
                          type="checkbox"
                          name="late_in_time_check"
                          checked={formData.late_in_time_check}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium "></div>
                      </label>
                    </div>

                    <input
                      type="time"
                      name="late_in_time"
                      value={formData.late_in_time}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                    />
                    {errors.late_in_time && (
                      <span className="error-message font-size-text ">
                        {errors.late_in_time}
                      </span>
                    )}
                  </div>

                  <div className="att-policy-input-group">
                    <div className="att-policy-checkbox-row">
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor="late_durations"
                      >
                        Late Duration
                      </label>
                      <label className="checkbox-click">
                        <input
                          id="late_durations"
                          type="checkbox"
                          name="late_durations"
                          checked={formData.late_durations}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium "></div>
                      </label>
                    </div>
                    <input
                      type="text"
                      name="late_duration"
                      value={formData.late_duration}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="00.0"
                    />
                    {errors.late_duration && (
                      <span className="error-message font-size-text ">
                        {errors.late_duration}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* HALFDAY POLICY */}

            <div className="att-policy-card">
              <div className="att-policy-checkbox-row">
                <label
                  className="att-policy-title"
                  style={{ cursor: "pointer" }}
                  htmlFor="halfday"
                >
                  Halfday Rules
                </label>
                <label className="checkbox-click">
                  <input
                    id="halfday"
                    type="checkbox"
                    name="halfday"
                    checked={formData.halfday}
                    onChange={handleInputChange}
                  />
                  <div className="checkmark-medium "></div>
                </label>
              </div>

              <div className="att-policy-block">
                <div className="att-policy-grid">
                  <div className="att-policy-input-group">

                    <div className="att-policy-checkbox-row">
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor="halfday_in_time_check"
                      >
                        Halfday In Time
                      </label>
                      <label className="checkbox-click">
                        <input
                          id="halfday_in_time_check"
                          type="checkbox"
                          name="halfday_in_time_check"
                          checked={formData.halfday_in_time_check}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium "></div>
                      </label>
                    </div>
                    <input
                      type="time"
                      name="halfday_in_time"
                      value={formData.halfday_in_time}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                    />
                    {errors.halfday_in_time && (
                      <span className="error-message font-size-text ">
                        {errors.halfday_in_time}
                      </span>
                    )}
                  </div>

                  <div className="att-policy-input-group">
                    <div className="att-policy-checkbox-row">
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor="halfday_durations"
                      >
                        Halfday Duration
                      </label>
                      <label className="checkbox-click">
                        <input
                          id="halfday_durations"
                          type="checkbox"
                          name="halfday_durations"
                          checked={formData.halfday_durations}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium "></div>
                      </label>
                    </div>
                    <input
                      type="text"
                      name="halfday_duration"
                      value={formData.halfday_duration}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="00.0"
                    />
                    {errors.halfday_duration && (
                      <span className="error-message font-size-text ">
                        {errors.halfday_duration}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* SHORT LEAVE and Weeklyoff Comp Off */}

            <div className="att-policy-card">
              <div className="att-policy-title">Short Leave & Weekly Off Eligibility</div>

              <div className="att-policy-block">
                <div className="att-policy-grid">
                  <div className="att-policy-input-group">
                    <div className="att-policy-checkbox-row">
                      <label style={{ cursor: "pointer" }} htmlFor="shortleave_durations">Short Leave Duration</label>
                      <label className="checkbox-click">
                        <input
                          id="shortleave_durations"
                          type="checkbox"
                          name="shortleave_durations"
                          checked={formData.shortleave_durations}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium "></div>
                      </label>
                    </div>

                    <input
                      type="text"
                      name="shortleave_duration"
                      value={formData.shortleave_duration}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="Duration (00.0)"
                    />
                    {errors.shortleave_duration && (
                      <span className="error-message font-size-text ">
                        {errors.shortleave_duration}
                      </span>
                    )}
                  </div>

                  <div className="att-policy-input-group">
                    <div className="att-policy-checkbox-row">
                      <label style={{ cursor: "pointer" }} htmlFor="weeklyoff_durations">Weekly Off Duration</label>
                      <label className="checkbox-click">
                        <input
                          id="weeklyoff_durations"
                          type="checkbox"
                          name="weeklyoff_durations"
                          checked={formData.weeklyoff_durations}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium "></div>
                      </label>
                    </div>

                    <input
                      type="text"
                      name="weeklyoff_duration"
                      value={formData.weeklyoff_duration}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="Duration (00.0)"
                    />
                    {errors.weeklyoff_duration && (
                      <span className="error-message font-size-text ">
                        {errors.weeklyoff_duration}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>


            {/* BUTTONS */}

            <div className="button-models">
              <button
                className="model-button model-button-cancel"
                onClick={handleClose}
              >
                Cancel
              </button>

              <button
                className="model-button model-button-leave"
                onClick={handleFormSubmit}
                disabled={loading}
              >
                Add Policy
              </button>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted && Object.keys(errors).length > 0 && (
                Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">Please fill all mandatory fields!</h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors).map((field) =>
                      field.charAt(0).toUpperCase() + field.slice(1)
                    ).join(', ') + ' are required!'}
                  </h6>
                )
              )}
            </p>
          </div>

          <ToastContainer position="top-center" />
        </Modal.Body>
      </Modal>
    </>
  );
};

const AttendancePolicyUpdate = ({ i, getAttPolicyList, SUB_COMPANIES, PERMISSION_AUTHORITY }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setFormData(initialData)
    setErrors({})
    setShow(false)
  };
  const handleShow = () => {
    setFormData(i)
    setShow(true)
  };

  const initialData = {
    name: "",

    ontime: false,
    ontime_in_time_check: false,
    ontime_in_time: "",
    ontime_out_time: "",
    ontime_durations: false,
    ontime_duration: "",

    late_mark: false,
    late_in_time_check: false,
    late_in_time: "",
    late_out_time: "",
    late_durations: false,
    late_duration: "",

    halfday: false,
    halfday_in_time_check: false,
    halfday_in_time: "",
    halfday_out_time: "",
    halfday_durations: false,
    halfday_duration: "",

    shortleave_durations: false,
    shortleave_duration: "",

    weeklyoff_durations: false,
    weeklyoff_duration: "",

    rectified_late_mark_count: "",
    apply_shortleave_duration: "",

    sub_company: sessionStorage.getItem("company_id"),
    updated_by: sessionStorage.getItem("emp_code"),
  }

  const [formData, setFormData] = useState(initialData);

  // !  ************** Validation start **************  ! //
  const [inputState, setInputState] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "name",
      "sub_company",
      "rectified_late_mark_count",
      "apply_shortleave_duration",
      formData.ontime_in_time_check ? 'ontime_in_time' : null,
      formData.ontime_durations ? 'ontime_duration' : null,
      formData.late_in_time_check ? 'late_in_time' : null,
      formData.late_durations ? 'late_duration' : null,
      formData.halfday_in_time_check ? 'halfday_in_time' : null,
      formData.halfday_durations ? 'halfday_duration' : null,
      formData.shortleave_durations ? 'shortleave_duration' : null,
      formData.weeklyoff_durations ? 'weeklyoff_duration' : null,
      formData.halfday_durations ? 'halfday_duration' : null,
    ].filter(Boolean);

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        setLoading(true);
        let res = await axios.put(`${BASE_URL}/wfm/attendancepolicy/${i.id}/`, formData);

        if (res.status === 200) {
          await getAttPolicyList();
          handleClose()
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Update Attendance Policy"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="three-fourth-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Attendance Policy {i.title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="attendance-policy-container">
            {/* BASIC INFO */}

            <div className="att-policy-card">
              <div className="att-policy-title">Basic Information</div>

              <div className="content-tabs att-policy-checkbox-row">
                <div className="att-policy-header-grid">
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Policy Name<span className="required">*</span>
                    </label>

                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className={!PERMISSION_AUTHORITY ? "form-input" : "form-input-half-half"}
                      placeholder="Attendance Policy Name"
                    />
                    {errors.name && (
                      <span className="error-message font-size-text ">
                        {errors.name}
                      </span>
                    )}
                  </div>
                </div>
                {PERMISSION_AUTHORITY ? (
                  <div className="att-policy-header-grid">
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading">
                        Sub Company<span className="required">*</span>
                      </label>
                      <select
                        id="sub_company"
                        name="sub_company"
                        value={formData.sub_company}
                        onChange={handleInputChange}
                        className={`form-input-half-half ${errors.sub_company
                          ? "error"
                          : inputState.sub_company
                            ? "success"
                            : ""
                          }`}
                      >
                        {SUB_COMPANIES.map((company) => (
                          <option value={company.id}>{company.title}</option>
                        ))}
                        ;
                      </select>
                      {errors.title && (
                        <span className="error-message font-size-text ">
                          {errors.title}
                        </span>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>

            {/* EXTRAS */}

            <div className="att-policy-card">
              <div className="att-policy-block">
                <div className="att-policy-grid">
                  <div className="att-policy-input-group">
                    <label>Allowed Rectified Late Marks</label>

                    <input
                      type="number"
                      name="rectified_late_mark_count"
                      value={formData.rectified_late_mark_count}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="00.0"
                    />
                    {errors.rectified_late_mark_count && (
                      <span className="error-message font-size-text ">
                        {errors.rectified_late_mark_count}
                      </span>
                    )}
                  </div>

                  <div className="att-policy-input-group">
                    <label>Apply Short Leave Eligibility Duration</label>

                    <input
                      type="text"
                      name="apply_shortleave_duration"
                      value={formData.apply_shortleave_duration}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="00.0"
                    />
                    {errors.apply_shortleave_duration && (
                      <span className="error-message font-size-text ">
                        {errors.apply_shortleave_duration}
                      </span>
                    )}
                  </div>

                </div>
              </div>
            </div>

            {/* ONTIME POLICY */}

            <div className="att-policy-card">

              <div className="att-policy-checkbox-row">
                <label
                  className="att-policy-title"
                  style={{ cursor: "pointer" }}
                  htmlFor="ontime"
                >
                  Enable Ontime Rules
                </label>

                <label className="checkbox-click">
                  <input
                    id="ontime"
                    type="checkbox"
                    name="ontime"
                    checked={formData.ontime}
                    onChange={handleInputChange}
                  />
                  <div className="checkmark-medium"></div>
                </label>
              </div>

              <div className="att-policy-block">
                <div className="att-policy-grid">
                  <div className="att-policy-input-group">
                    <div className="att-policy-checkbox-row">
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor="ontime_in_time_check"
                      >
                        Ontime In Time
                      </label>
                      <label className="checkbox-click">
                        <input
                          id="ontime_in_time_check"
                          type="checkbox"
                          name="ontime_in_time_check"
                          checked={formData.ontime_in_time_check}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium"></div>
                      </label>
                    </div>

                    <input
                      type="time"
                      name="ontime_in_time"
                      value={formData.ontime_in_time}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                    />
                    {errors.ontime_in_time && (
                      <span className="error-message font-size-text ">
                        {errors.ontime_in_time}
                      </span>
                    )}
                  </div>

                  <div className="att-policy-input-group">
                    <div className="att-policy-checkbox-row">
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor="ontime_durations"
                      >
                        Ontime Duration
                      </label>
                      <label className="checkbox-click">
                        <input
                          id="ontime_durations"
                          type="checkbox"
                          name="ontime_durations"
                          checked={formData.ontime_durations}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium"></div>
                      </label>
                    </div>

                    <input
                      type="text"
                      name="ontime_duration"
                      value={formData.ontime_duration}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="00.0"
                    />
                    {errors.ontime_duration && (
                      <span className="error-message font-size-text ">
                        {errors.ontime_duration}
                      </span>
                    )}
                  </div>

                </div>
              </div>
            </div>

            {/* LATE POLICY */}

            <div className="att-policy-card">

              <div className="att-policy-checkbox-row">
                <label
                  className="att-policy-title"
                  style={{ cursor: "pointer" }}
                  htmlFor="late_mark"
                >
                  Enable Late Rules
                </label>

                <label className="checkbox-click">
                  <input
                    id="late_mark"
                    type="checkbox"
                    name="late_mark"
                    checked={formData.late_mark}
                    onChange={handleInputChange}
                  />
                  <div className="checkmark-medium"></div>
                </label>
              </div>

              <div className="att-policy-block">
                <div className="att-policy-grid">

                  <div className="att-policy-input-group">
                    <div className="att-policy-checkbox-row">
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor="late_in_time_check"
                      >
                        Late In Time
                      </label>
                      <label className="checkbox-click">
                        <input
                          id="late_in_time_check"
                          type="checkbox"
                          name="late_in_time_check"
                          checked={formData.late_in_time_check}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium"></div>
                      </label>
                    </div>

                    <input
                      type="time"
                      name="late_in_time"
                      value={formData.late_in_time}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                    />
                    {errors.late_in_time && (
                      <span className="error-message font-size-text ">
                        {errors.late_in_time}
                      </span>
                    )}
                  </div>

                  <div className="att-policy-input-group">
                    <div className="att-policy-checkbox-row">
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor="late_durations"
                      >
                        Late Duration
                      </label>

                      <label className="checkbox-click">
                        <input
                          id="late_durations"
                          type="checkbox"
                          name="late_durations"
                          checked={formData.late_durations}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium"></div>
                      </label>
                    </div>

                    <input
                      type="text"
                      name="late_duration"
                      value={formData.late_duration}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="00.0"
                    />
                    {errors.late_duration && (
                      <span className="error-message font-size-text ">
                        {errors.late_duration}
                      </span>
                    )}
                  </div>

                </div>
              </div>
            </div>

            {/* HALFDAY POLICY */}

            <div className="att-policy-card">

              <div className="att-policy-checkbox-row">
                <label
                  className="att-policy-title"
                  style={{ cursor: "pointer" }}
                  htmlFor="halfday"
                >
                  Halfday Rules
                </label>

                <label className="checkbox-click">
                  <input
                    id="halfday"
                    type="checkbox"
                    name="halfday"
                    checked={formData.halfday}
                    onChange={handleInputChange}
                  />
                  <div className="checkmark-medium"></div>
                </label>
              </div>

              <div className="att-policy-block">
                <div className="att-policy-grid">

                  <div className="att-policy-input-group">

                    <div className="att-policy-checkbox-row">
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor="halfday_in_time_check"
                      >
                        Halfday In Time
                      </label>

                      <label className="checkbox-click">
                        <input
                          id="halfday_in_time_check"
                          type="checkbox"
                          name="halfday_in_time_check"
                          checked={formData.halfday_in_time_check}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium"></div>
                      </label>
                    </div>

                    <input
                      type="time"
                      name="halfday_in_time"
                      value={formData.halfday_in_time}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                    />
                    {errors.halfday_in_time && (
                      <span className="error-message font-size-text ">
                        {errors.halfday_in_time}
                      </span>
                    )}
                  </div>

                  <div className="att-policy-input-group">

                    <div className="att-policy-checkbox-row">
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor="halfday_durations"
                      >
                        Halfday Duration
                      </label>

                      <label className="checkbox-click">
                        <input
                          id="halfday_durations"
                          type="checkbox"
                          name="halfday_durations"
                          checked={formData.halfday_durations}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium"></div>
                      </label>
                    </div>

                    <input
                      type="text"
                      name="halfday_duration"
                      value={formData.halfday_duration}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="00.0"
                    />
                    {errors.halfday_duration && (
                      <span className="error-message font-size-text ">
                        {errors.halfday_duration}
                      </span>
                    )}
                  </div>

                </div>
              </div>
            </div>

            {/* SHORT LEAVE and Weeklyoff Comp Off */}

            <div className="att-policy-card">

              <div className="att-policy-title">
                Short Leave & Weekly Off Eligibility
              </div>

              <div className="att-policy-block">
                <div className="att-policy-grid">

                  <div className="att-policy-input-group">

                    <div className="att-policy-checkbox-row">
                      <label style={{ cursor: "pointer" }} htmlFor="shortleave_durations">Short Leave Duration</label>
                      <label className="checkbox-click">
                        <input
                          id="shortleave_durations"
                          type="checkbox"
                          name="shortleave_durations"
                          checked={formData.shortleave_durations}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium"></div>
                      </label>
                    </div>

                    <input
                      type="text"
                      name="shortleave_duration"
                      value={formData.shortleave_duration}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="Duration (00.0)"
                    />
                    {errors.shortleave_duration && (
                      <span className="error-message font-size-text ">
                        {errors.shortleave_duration}
                      </span>
                    )}
                  </div>

                  <div className="att-policy-input-group">

                    <div className="att-policy-checkbox-row">
                      <label style={{ cursor: "pointer" }} htmlFor="weeklyoff_durations">Weekly Off Duration</label>
                      <label className="checkbox-click">
                        <input
                          id="weeklyoff_durations"
                          type="checkbox"
                          name="weeklyoff_durations"
                          checked={formData.weeklyoff_durations}
                          onChange={handleInputChange}
                        />
                        <div className="checkmark-medium"></div>
                      </label>
                    </div>

                    <input
                      type="text"
                      name="weeklyoff_duration"
                      value={formData.weeklyoff_duration}
                      onChange={handleInputChange}
                      className="form-input-small-half"
                      placeholder="Duration (00.0)"
                    />
                    {errors.weeklyoff_duration && (
                      <span className="error-message font-size-text ">
                        {errors.weeklyoff_duration}
                      </span>
                    )}
                  </div>

                </div>
              </div>
            </div>

            {/* BUTTONS */}

            <div className="button-models">

              <button
                className="model-button model-button-cancel"
                onClick={handleClose}
              >
                Cancel
              </button>

              <button
                className="model-button model-button-leave"
                onClick={handleFormSubmit}
                disabled={loading}
              >
                Update Policy
              </button>

            </div>
            <p className="error-message font-size-text">
              {isSubmitted && Object.keys(errors).length > 0 && (
                Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">Please fill all mandatory fields!</h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors).map((field) =>
                      field.charAt(0).toUpperCase() + field.slice(1)
                    ).join(', ') + ' are required!'}
                  </h6>
                )
              )}
            </p>
          </div>

          <ToastContainer position="top-center" />
        </Modal.Body>
      </Modal>
    </>
  );
};

const AttendancePolicyDelete = ({ i, getAttPolicyList }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/attendancepolicy/${i.id}/`);

      if (res.status === 200) {
        await getAttPolicyList();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        className="model-delete-button"
        title={
          i.inactive_count === 0
            ? "Delete Attendance Policy"
            : `Inactive Employee: ${i.inactive_count}`
        }
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Attendance Policy with {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to Delete Attendance Policy "{i.name}"?
            {i.inactive_count > 0 && (
              <>
                <br />"{i.inactive_count}" Inactive Employee Exist with "
                {i.name}" Attendance Policy
              </>
            )}
            <div className="button-models">
              <button
                className="model-button model-button-cancel font-weight500"
                onClick={handleClose}
              >
                Cancel
              </button>
              {i.active_count + i.inactive_count === 0 && (
                <button
                  onClick={handleFormSubmitDelete}
                  className="model-button model-button-delete font-weight500"
                >
                  Delete
                </button>
              )}
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ? *************** Attendance Policy Crud Models End ***************

// ! ***************  Salary Structure Heading Crud Models Start ***************

const SalaryStructureHeadingAdd = ({
  salaryStructureHeadings,
  getSalaryStructureHeadings,
  SUB_COMPANIES,
  PERMISSION_AUTHORITY,
}) => {
  const [show, setShow] = useState(false);
  const [salaryslipView, setSalarySlipView] = useState(true);
  const [finalAmount, setFinalAmount] = useState(false);

  const handleClose = () => {
    setFormData({
      title: "",
      sub_company: sessionStorage.getItem("company_id"),
      sorting_var: "",
      salary_type: "",
      updated_by: sessionStorage.getItem("emp_code"),
    });
    setSalarySlipView(false);
    setFinalAmount(false);
    setShow(false);
  };

  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    title: "",
    sub_company: sessionStorage.getItem("company_id"),
    sorting_var: "",
    salary_type: "",
    updated_by: sessionStorage.getItem("emp_code"),
  });
  const [suggestion, setSuggestPosition] = useState("");

  useEffect(() => {
    const getNextSortingPosition = () => {
      const maxSortingVar = Math.max(
        ...salaryStructureHeadings.map((heading) =>
          Number(heading.sorting_var),
        ),
        1,
      );
      setSuggestPosition(maxSortingVar + 1);
    };

    getNextSortingPosition();
  }, [salaryStructureHeadings]);

  // Validation
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "title",
      "sub_company",
      "sorting_var",
      "salary_type",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] =
          `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    // // Add more validation for numerical fields as needed
    // if (formData.epf_criteria && isNaN(formData.epf_criteria)) {
    //   newErrors.epf_criteria = 'EPF criteria must be a valid number!';
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const updatedFormData = {
      ...formData,
      salaryslip: salaryslipView,
      final_salary: finalAmount,
    };
    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait...");
      setLoading(true); //loading logic
      try {
        let res = await axios.post(
          `${BASE_URL}/wfm/salaryheading/`,
          updatedFormData,
        );
        if (res.status === 200) {
          await getSalaryStructureHeadings();
          handleClose();
          // toast.success('Salary Policy created successfully!');
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false); //loading logic
      }
    }
  };

  return (
    <>
      <button
        className="upload-svg"
        title="Add Salary Heading"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> Add Salary Heading
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header
          closeButton
          className=" task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Add Salary Heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <div className="flex-column">
                <label
                  htmlFor="title"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Title<span className="required">*</span>
                </label>
                <input
                  maxLength={50}
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Heading Name"
                  onChange={handleInputChange}
                  value={formData.title}
                  className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
                    }`}
                />
                {errors.title && (
                  <span className="error-message font-size-text ">
                    {errors.title}
                  </span>
                )}
              </div>

              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="salary_type "
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Salary Type<span className="required">*</span>
                </label>
                <br />
                <select
                  id="salary_type"
                  name="salary_type"
                  value={formData.salary_type}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.salary_type
                    ? "error"
                    : inputState.salary_type
                      ? "success"
                      : ""
                    }`}
                >
                  <option value="">Select Salary Type</option>
                  <option value="allowance">Allowance</option>
                  <option value="deduction">Deduction</option>
                  <option value="total">Total</option>
                  <option value="difference">Difference</option>
                </select>
                <div className="form-group-selection-arrow">
                  <DropdownArrowOption />
                </div>
                {errors.salary_type && (
                  <span className="error-message font-size-text ">
                    {errors.salary_type}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="sorting_var"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Heading Sort Position (1 is Top)
                  <span className="required">*</span>
                </label>
                <input
                  id="sorting_var"
                  name="sorting_var"
                  type="number"
                  min={1}
                  maxLength={10}
                  placeholder={`Heading Position (Suggestion: ${suggestion})`}
                  onWheel={(e) => e.target.blur()}
                  onChange={handleInputChange}
                  value={formData.sorting_var}
                  className={`form-input ${errors.sorting_var
                    ? "error"
                    : inputState.sorting_var
                      ? "success"
                      : ""
                    }`}
                />
                {errors.sorting_var && (
                  <span className="error-message font-size-text ">
                    {errors.sorting_var}
                  </span>
                )}
              </div>

              {PERMISSION_AUTHORITY ? (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="sub_company"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Sub Company<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="sub_company"
                    name="sub_company"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.sub_company
                      ? "error"
                      : inputState.sub_company
                        ? "success"
                        : ""
                      }`}
                  >
                    <option value="">Select Site Company </option>
                    {SUB_COMPANIES.map((company) => (
                      <option value={company.id}>{company.title}</option>
                    ))}
                    ;
                  </select>
                  <div className="form-group-selection-arrow">
                    <DropdownArrowOption />
                  </div>
                  {errors.sub_company && (
                    <span className="error-message font-size-text ">
                      {errors.sub_company}
                    </span>
                  )}
                </div>
              ) : null}
              {/* <div className="flex-row justify-between"> */}
              <div className="flex-row ">
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    id="toggle1"
                    checked={salaryslipView}
                    onChange={() => setSalarySlipView(!salaryslipView)}
                  />
                  <label htmlFor="toggle1"></label>
                </div>
                <hr style={{ marginTop: "10px" }} className="field-cont-hr" />
                <label
                  htmlFor="EmpCode"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  {salaryslipView ? "View" : "Hide"} in Salary Slip{" "}
                </label>
              </div>
              <div className="flex-row ">
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    id="toggle2"
                    checked={finalAmount}
                    onChange={() => setFinalAmount(!finalAmount)}
                  />
                  <label htmlFor="toggle2"></label>
                </div>
                <hr style={{ marginTop: "10px" }} className="field-cont-hr" />
                <label
                  htmlFor="EmpCode"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Final Salary Amount{" "}
                </label>
              </div>
              {/* </div> */}
              <div className="button-models">
                <button
                  className="model-button model-button-cancel  font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const SalaryStructureHeadingUpdate = ({
  i,
  salaryStructureHeadings,
  getSalaryStructureHeadings,
  SUB_COMPANIES,
  PERMISSION_AUTHORITY,
}) => {
  const [show, setShow] = useState(false);
  const [salaryslipView, setSalarySlipView] = useState(i.salaryslip || false);
  const [finalAmount, setFinalAmount] = useState(i.final_salary || false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setFormData(i);
    setShow(true);
  };

  const [formData, setFormData] = useState({
    title: "",
    sub_company: sessionStorage.getItem("company_id"),
    sorting_var: "",
    salary_type: "",
    updated_by: sessionStorage.getItem("emp_code"),
  });

  const [suggestion, setSuggestPosition] = useState("");

  useEffect(() => {
    const getNextSortingPosition = () => {
      const maxSortingVar = Math.max(
        ...salaryStructureHeadings.map((heading) =>
          Number(heading.sorting_var),
        ),
        1,
      );
      setSuggestPosition(maxSortingVar + 1);
    };

    getNextSortingPosition();
  }, [salaryStructureHeadings]);

  // Validation
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "title",
      "sub_company",
      "sorting_var",
      "salary_type",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] =
          `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const updatedFormData = {
      ...formData,
      salaryslip: salaryslipView,
      final_salary: finalAmount,
    };
    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait...");
      setLoading(true); //loading logic
      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/salaryheading/${i.id}/`,
          updatedFormData,
        );
        if (res.status === 200) {
          await getSalaryStructureHeadings();
          setShow(false);
        }
      } catch (err) {
        handleAllError(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false); //loading logic
      }
    }
  };

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Update Salary Heading"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header
          closeButton
          className=" task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Update Salary Heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <div className="flex-column">
                <label
                  htmlFor="title"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Title<span className="required">*</span>
                </label>
                <input
                  maxLength={50}
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Salary Heading Title"
                  onChange={handleInputChange}
                  value={formData.title}
                  className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
                    }`}
                />
                {errors.title && (
                  <span className="error-message font-size-text ">
                    {errors.title}
                  </span>
                )}
              </div>

              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="salary_type "
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Salary Type<span className="required">*</span>
                </label>
                <br />
                <select
                  id="salary_type"
                  name="salary_type"
                  value={formData.salary_type}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.salary_type
                    ? "error"
                    : inputState.salary_type
                      ? "success"
                      : ""
                    }`}
                >
                  <option value="">Select Salary Type</option>
                  <option value="allowance">Allowance</option>
                  <option value="deduction">Deduction</option>
                  <option value="total">Total</option>
                  <option value="difference">Difference</option>
                </select>
                <div className="form-group-selection-arrow">
                  <DropdownArrowOption />
                </div>
                {errors.salary_type && (
                  <span className="error-message font-size-text ">
                    {errors.salary_type}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="sorting_var"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Heading Sort Position (1 is Top)
                  <span className="required">*</span>
                </label>
                <input
                  id="sorting_var"
                  name="sorting_var"
                  type="number"
                  min={1}
                  maxLength={10}
                  placeholder={`Heading Position (Suggestion: ${suggestion})`}
                  onWheel={(e) => e.target.blur()}
                  onChange={handleInputChange}
                  value={formData.sorting_var}
                  className={`form-input ${errors.sorting_var
                    ? "error"
                    : inputState.sorting_var
                      ? "success"
                      : ""
                    }`}
                />
                {errors.sorting_var && (
                  <span className="error-message font-size-text ">
                    {errors.sorting_var}
                  </span>
                )}
              </div>

              {PERMISSION_AUTHORITY ? (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="sub_company"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Sub Company<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="sub_company"
                    name="sub_company"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.sub_company
                      ? "error"
                      : inputState.sub_company
                        ? "success"
                        : ""
                      }`}
                  >
                    <option value="">Select Site Company </option>
                    {SUB_COMPANIES.map((company) => (
                      <option value={company.id}>{company.title}</option>
                    ))}
                    ;
                  </select>
                  <div className="form-group-selection-arrow">
                    <DropdownArrowOption />
                  </div>
                  {errors.sub_company && (
                    <span className="error-message font-size-text ">
                      {errors.sub_company}
                    </span>
                  )}
                </div>
              ) : null}
              <div className="flex-row ">
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    id="toggle1"
                    checked={salaryslipView}
                    onChange={() => setSalarySlipView(!salaryslipView)}
                  />
                  <label htmlFor="toggle1"></label>
                </div>
                <hr style={{ marginTop: "10px" }} className="field-cont-hr" />
                <label
                  htmlFor="EmpCode"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  {salaryslipView ? "View" : "Hide"} in Salary Slip{" "}
                </label>
              </div>
              <div className="flex-row ">
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    id="toggle2"
                    checked={finalAmount}
                    onChange={() => setFinalAmount(!finalAmount)}
                  />
                  <label htmlFor="toggle2"></label>
                </div>
                <hr style={{ marginTop: "10px" }} className="field-cont-hr" />
                <label
                  htmlFor="EmpCode"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Final Salary Amount{" "}
                </label>
              </div>
              <div className="button-models">
                <button
                  className="model-button model-button-cancel  font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const SalaryStructureHeadingDelete = ({ i, getSalaryStructureHeadings }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/salaryheading/${i.id}/`);

      if (res.status === 200) {
        await getSalaryStructureHeadings();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        className="model-delete-button"
        title="Delete Salary Heading"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Salary Heading: {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to Delete Salary Salary Heading: "{i.title}"
            <div className="button-models">
              <button
                className="model-button model-button-cancel  font-weight500    "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ? *************** Salary Structure Heading Policy Crud Models End ***************

// ! ***************  SalaryCalculationPolicy Crud Models Start ***************

const SalaryCalculationPolicyAdd = ({ getSalaryCalculationPolicyList }) => {
  const [show, setShow] = useState(false);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    policy_name: "",
    sub_company: sessionStorage.getItem("company_id"),
  });

  // Validation
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["policy_name", "sub_company"];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] =
          `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait...");
      setLoading(true); //loading logic
      try {
        let res = await axios.post(`${BASE_URL}/wfm/salarypolicy/`, formData);
        if (res.status === 200) {
          await getSalaryCalculationPolicyList();
          setShow(false);
          // toast.success('Salary Policy created successfully!');
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false); //loading logic
      }
    }
  };

  return (
    <>
      <button
        className="models-button model-add"
        title="Add Salary Calculation"
        onClick={handleShow}
      >
        <AddwithBlueCircle />
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header
          closeButton
          className=" task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Add Salary Heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <div className="flex-column">
                <label
                  htmlFor="policy_name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Policy Name<span className="required">*</span>
                </label>
                <input
                  maxLength={100}
                  type="text"
                  id="policy_name"
                  name="policy_name"
                  placeholder="Policy Name"
                  onChange={handleInputChange}
                  value={formData.policy_name}
                  className={`form-input ${errors.policy_name
                    ? "error"
                    : inputState.policy_name
                      ? "success"
                      : ""
                    }`}
                />
                {errors.policy_name && (
                  <span className="error-message font-size-text ">
                    {errors.policy_name}
                  </span>
                )}
              </div>

              {PERMISSION_AUTHORITY ? (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="sub_company"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Sub Company<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="sub_company"
                    name="sub_company"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.sub_company
                      ? "error"
                      : inputState.sub_company
                        ? "success"
                        : ""
                      }`}
                  >
                    <option value="">Select Site Company </option>
                    {SUB_COMPANIES.map((company) => (
                      <option value={company.id}>{company.title}</option>
                    ))}
                    ;
                  </select>
                  <div className="form-group-selection-arrow">
                    <DropdownArrowOption />
                  </div>
                  {errors.sub_company && (
                    <span className="error-message font-size-text ">
                      {errors.sub_company}
                    </span>
                  )}
                </div>
              ) : null}

              <div className="button-models">
                <button
                  className="model-button model-button-cancel  font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const SalaryCalculationPolicyUpdate = ({
  i,
  getSalaryCalculationPolicyList,
}) => {
  const [show, setShow] = useState(false);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setFormData(i);
    getSalaryPolicyRelatedData();
    setShow(true);
  };

  const [formData, setFormData] = useState({
    policy_name: "",
    sub_company: sessionStorage.getItem("company_id"),
  });

  // Validation
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["policy_name", "sub_company"];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] =
          `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait...");
      setLoading(true); //loading logic
      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/salarypolicy/${i.id}/`,
          formData,
        );
        if (res.status === 200) {
          await getSalaryCalculationPolicyList();
          setShow(false);
        }
      } catch (err) {
        handleAllError(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false); //loading logic
      }
    }
  };

  // Custom Deduction Policy part start

  const [customData, setCustomData] = useState([]);
  const [deductionData, setDeductionData] = useState([]);
  const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);

  const getSalaryPolicyRelatedData = async () => {
    try {
      // const deduction = await axios.get(`${BASE_URL}/wfm/customdeductionbysalary_policy/${i.id}/`);
      // setDeductionData(deduction.data);
      const headings = await axios.get(
        `${BASE_URL}/wfm/salaryHeadingbysubcompany/${i.sub_company}/`,
      );
      if (Array.isArray(headings.data)) {
        setSalaryStructureHeadings(headings.data);
        const customData = headings.data.map((item) => ({
          name: item.id,
          salary_policy: i.id,
          percentage: "",
          percentage_of: [],
          fixed_amount: "",
        }));
        setCustomData(customData);
      } else {
        console.error("Error: Expected a list of Salary Headings");
      }
    } catch (err) {
      handleAllError(err);
    } finally {
    }
  };

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Update Salary Calculation"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="four-fifth-modal"
      >
        <Modal.Header
          closeButton
          className=" task-Tab-heading font-weight500 font-size-heading "
        >
          <Modal.Title>Update Salary Calculation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <div className="flex-row justify-evenly">
                <div className="flex-column">
                  <label
                    htmlFor="policy_name"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Policy Name<span className="required">*</span>
                  </label>
                  <input
                    maxLength={100}
                    type="text"
                    id="policy_name"
                    name="policy_name"
                    placeholder="Policy Name"
                    onChange={handleInputChange}
                    value={formData.policy_name}
                    className={`form-input ${errors.policy_name
                      ? "error"
                      : inputState.policy_name
                        ? "success"
                        : ""
                      }`}
                  />
                  {errors.policy_name && (
                    <span className="error-message font-size-text ">
                      {errors.policy_name}
                    </span>
                  )}
                </div>
                <div className="button-models">
                  <button
                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                    onClick={handleFormSubmit}
                    disabled={loading}
                  >
                    Update
                  </button>
                </div>
              </div>
              {/* <div className="parent-div">
                <div className="bdy-div">

                </div>
              </div> */}
              <CustomDeductionsPolicy
                calculationPolicy={i}
                deductionData={deductionData}
                customData={customData}
                salaryStructureHeadings={salaryStructureHeadings}
                getSalaryPolicyRelatedData={getSalaryPolicyRelatedData}
              />
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const CustomDeductionsPolicy = ({
  calculationPolicy,
  customData,
  deductionData,
  salaryStructureHeadings,
  getSalaryPolicyRelatedData,
}) => {
  const [formData, setFormData] = useState(customData || []);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  console.log("customData");
  console.log(customData);
  useEffect(() => {
    setFormData(customData);
  }, [customData]);

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;

    // Update formData and clear dependent fields as needed
    const updatedFormData = formData.map((entry, i) => {
      if (i === index) {
        return {
          ...entry,
          [name]: value,
          ...(name === "fixed_amount"
            ? { percentage: "", percentage_of: [] }
            : {}),
          ...(name === "percentage" ? { fixed_amount: "" } : {}),
        };
      }
      return entry;
    });

    setFormData(updatedFormData);
  };

  const handleSelectChange = (selectedOptions, index) => {
    // Update percentage_of with selected values
    const updatedFormData = formData.map((entry, i) => {
      if (i === index) {
        return {
          ...entry,
          percentage_of: selectedOptions
            ? selectedOptions.map((option) => option.value)
            : [],
        };
      }
      return entry;
    });

    setFormData(updatedFormData);
  };

  const validateForm = () => {
    const newErrors = {};
    formData.forEach((entry, index) => {
      const hasFixedAmount = !!entry.fixed_amount;
      const hasPercentage = !!entry.percentage;
      const hasRelatedTo =
        entry.percentage_of && entry.percentage_of.length > 0;

      if (hasFixedAmount && (hasPercentage || hasRelatedTo)) {
        newErrors[index] =
          "Specify either Fixed Amount or Percentage with Related To, not both.";
      } else if (hasPercentage && !hasRelatedTo) {
        newErrors[index] =
          "Related To is required when Percentage is specified.";
      } else if (!hasPercentage && hasRelatedTo) {
        newErrors[index] =
          "Percentage is required when Related To is specified.";
      }
      // } else if (!hasFixedAmount && (!hasPercentage || !hasRelatedTo)) {
      //     newErrors[index] = "Either Fixed Amount or both Percentage and Related To are required.";
      // }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmitCustomDeduction = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      const res = await axios.post(
        `${BASE_URL}/wfm/bulkcustomdeduction/`,
        formData,
      );
      if (res.status === 200 || res.status === 201) {
        await getSalaryPolicyRelatedData();
        toast.success("Deductions saved successfully.");
      }
    } catch (err) {
      await getSalaryPolicyRelatedData();

      // toast.error("An error occurred while saving deductions.");
    } finally {
      // setLoading(false);
      // toast.dismiss(loadingToastId);
    }
  };

  const deductionIds = deductionData.map((item) => item.name);

  // Format options for react-select
  const relatedToOptions = salaryStructureHeadings
    .filter((i) => !deductionIds.includes(i.id))
    .sort((a, b) => a.sorting_var - b.sorting_var)
    .map((i) => ({ value: i.id, label: i.title }));

  return (
    <div>
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
      <table className="table-css width-10vw">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left width-5vw">Heading</th>
            <th className="align-center width-5vw">Type</th>
            <th className="align-center width-5vw">Amount</th>
            <th className="align-center" style={{ width: "0.5vw" }}>
              OR
            </th>
            <th className="align-center width-5vw">Percentage</th>
            <th className="align-center width-5vw">Related To</th>
            {deductionData.length > 0 && (
              <th className="align-center width-5vw">Action</th>
            )}
          </tr>
        </thead>
        <tbody>
          <>
            {deductionData.length > 0 ? (
              <>
                {deductionData
                  .sort((a, b) => a.name_sorting_var - b.name_sorting_var)
                  .map((entry, index) => (
                    <tr className="custom-table-head-td" key={index}>
                      <td className="align-left">{entry.name_title}</td>
                      <td className="align-left text-capitalize">
                        {entry.name_type}
                      </td>

                      <td className="align-center">
                        {entry.fixed_amount || "-"}
                      </td>
                      <td className="align-center">
                        <div
                          style={{ width: "1vw" }}
                          className="align-center width-5vw "
                        >
                          OR
                        </div>
                        {/* <hr className="field-cont-hr" /> */}
                      </td>
                      <td className="align-center">
                        {entry.percentage
                          ? `${parseFloat(entry.percentage) % 1 === 0
                            ? parseFloat(entry.percentage).toFixed(0)
                            : parseFloat(entry.percentage).toFixed(2)
                          }%`
                          : "-"}
                      </td>
                      <td className="align-leftt width-10vw">
                        {entry.percentage_of.length === 0 ? (
                          <div className="align-center">-</div>
                        ) : (
                          // entry.percentage_of?.join(", ") || '-'
                          <ul style={{ paddingLeft: "0" }}>
                            {entry.percentage_of.map((data, index) => (
                              <li key={index}>
                                <span className="text-capitalize">
                                  {data.name}
                                </span>
                              </li>
                            ))}
                          </ul>
                        )}
                      </td>
                      <td className="align-center">
                        <UpdateCustomDeductionPolicy
                          i={entry}
                          deductionData={deductionData}
                          salaryStructureHeadings={salaryStructureHeadings}
                          getSalaryPolicyRelatedData={
                            getSalaryPolicyRelatedData
                          }
                        />
                      </td>
                    </tr>
                  ))}
              </>
            ) : (
              <>
                {formData
                  .sort((a, b) => a.sorting_var - b.sorting_var)
                  .map((entry, index) => (
                    <>
                      <tr className="custom-table-head-td" key={index}>
                        <td className="align-left">
                          {salaryStructureHeadings.find(
                            (t) => t.id === entry.name,
                          )?.title || "Loading..."}
                        </td>
                        <td className="align-center text-capitalize">
                          {salaryStructureHeadings.find(
                            (t) => t.id === entry.name,
                          )?.salary_type || "Loading..."}
                        </td>
                        <td className="align-center">
                          <input
                            type="number"
                            name="fixed_amount"
                            min={0}
                            placeholder="Fixed Amount"
                            value={entry.fixed_amount || ""}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => handleInputChange(e, index)}
                            className={`form-input-date ${errors[index] ? "is-invalid" : ""}`}
                            disabled={!!entry.percentage} // Disable if percentage is provided
                          />
                        </td>
                        <td className="align-center">
                          <div
                            style={{ width: "1vw" }}
                            className="align-center width-5vw "
                          >
                            OR
                          </div>
                          {/* <hr className="field-cont-hr" /> */}
                        </td>
                        <td className="align-center">
                          <input
                            type="number"
                            name="percentage"
                            min={0}
                            placeholder="Percentage"
                            value={entry.percentage || ""}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => handleInputChange(e, index)}
                            className={`form-input-date ${errors[index] ? "is-invalid" : ""}`}
                            disabled={!!entry.fixed_amount} // Disable if fixed amount is provided
                          />
                        </td>
                        <td className="align-leftt width-10vw">
                          <Select
                            isMulti
                            name="percentage_of"
                            value={relatedToOptions.filter((option) =>
                              entry.percentage_of?.includes(option.value),
                            )}
                            onChange={(selectedOptions) =>
                              handleSelectChange(selectedOptions, index)
                            }
                            options={relatedToOptions}
                            className={` width-15vw ${errors[index] ? "is-invalid" : ""}`}
                            classNamePrefix="select"
                            placeholder="Select Related To"
                            isDisabled={!!entry.fixed_amount} // Disable if fixed amount is provided
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                // width: '33vw',
                                // height: '50px',
                                borderRadius: "10px",
                                border: "1px solid #e3e3e3",
                                margin: "10px 0px 20px 0px",
                                color: "#4a4a4a",
                                backgroundColor: "#f7f8fa",
                                padding: "0px 10px",
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                color: "#4a4a4a",
                              }),
                              menu: (provided) => ({
                                ...provided,
                                borderRadius: "10px",
                                marginTop: "0",
                              }),
                              input: (provided) => ({
                                ...provided,
                                color: "#4a4a4a",
                              }),
                              singleValue: (provided) => ({
                                ...provided,
                                color: "#4a4a4a",
                              }),
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        {errors[index] && (
                          <td
                            colSpan="6"
                            className="align-center error-message font-size-text"
                          >
                            {errors[index]}
                          </td>
                        )}
                      </tr>
                    </>
                  ))}
              </>
            )}
          </>
        </tbody>
      </table>

      <div className="button-models">
        {deductionData.length > 0 ? (
          salaryStructureHeadings?.filter((i) => !deductionIds.includes(i.id))
            .length > 0 ? (
            <AddCustomDeductionPolicy
              calculationPolicy={calculationPolicy}
              deductionData={deductionData}
              salaryStructureHeadings={salaryStructureHeadings}
              getSalaryPolicyRelatedData={getSalaryPolicyRelatedData}
            />
          ) : null
        ) : (
          <button
            onClick={handleSubmitCustomDeduction}
            className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Deductions"}
          </button>
        )}
      </div>
    </div>
  );
};

const AddCustomDeductionPolicy = ({
  calculationPolicy,
  deductionData,
  salaryStructureHeadings,
  getSalaryPolicyRelatedData,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    salary_policy: calculationPolicy.id,
    salary_type: "",
    percentage: "",
    percentage_of: [], // Initialize as an array for multiple selections
    fixed_amount: "",
  });
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const validateForm = () => {
    const newErrors = {};
    const isSalaryHeadingSelected = !!formData.name;
    const hasFixedAmount = formData.fixed_amount !== "";
    const hasPercentage =
      formData.percentage !== "" && formData.percentage_of.length > 0;

    // Validate Salary Heading
    if (!isSalaryHeadingSelected) {
      newErrors.name = "Salary Heading is required!";
    }

    // Validation for Fixed Amount or Percentage
    if (!hasFixedAmount && !hasPercentage) {
      newErrors.mixed =
        "Either Fixed Amount or Percentage with Related To is required!";
    }

    // Additional validation for Fixed Amount if it's entered
    if (hasFixedAmount && !formData.fixed_amount) {
      newErrors.fixed_amount = "Fixed Amount is required!";
    }

    // Additional validation for Percentage if it's entered
    if (hasPercentage) {
      if (!formData.percentage) {
        newErrors.percentage = "Percentage Amount is required!";
      }
      if (formData.percentage_of.length === 0) {
        newErrors.percentage_of = "Related To is required!";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Handle multiple selections for 'percentage_of'
    if (name === "percentage_of") {
      const options = Array.from(
        e.target.selectedOptions,
        (option) => option.value,
      );
      setFormData({ ...formData, percentage_of: options });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    setInputState({ ...inputState, [name]: value.trim() ? "green" : "" });
  };

  const handleHeadingChange = (e) => {
    const { value } = e.target;
    const selectedHeading = salaryStructureHeadings.find(
      (heading) => heading.id === value,
    );

    setFormData({
      ...formData,
      name: selectedHeading ? selectedHeading.id : "",
      salary_type: selectedHeading ? selectedHeading.salary_type : "",
    });

    setInputState({
      ...inputState,
      name: value.trim() ? "green" : "",
    });
  };
  const handleSelectChange = (selectedOptions) => {
    setFormData({
      ...formData,
      percentage_of: selectedOptions
        ? selectedOptions.map((option) => option.value)
        : [],
    });
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      const res = await axios.post(
        `${BASE_URL}/wfm/customdeductionpolicy/`,
        formData,
      );

      if (res.status === 200 || res.status === 201) {
        handleClose();
        await getSalaryPolicyRelatedData();
      } else {
        toast.error("Error adding deduction");
      }
    } catch (err) {
      toast.error("An error occurred while adding the deduction");
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };
  const deductionIds = deductionData.map((item) => item.name);
  const relatedToOptions = salaryStructureHeadings
    .filter((i) => deductionIds.includes(i.id))
    .map((i) => ({ value: i.title, label: i.title }));

  return (
    <div>
      <button
        title="Add Deduction Policy"
        className="model-button model-button-leave"
        onClick={handleShow}
      >
        Add
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header closeButton>
          <Modal.Title>Add Custom Deduction Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar
          />
          <form className="register-form" onSubmit={handleFormSubmit}>
            <div className="form-flex-wrap">
              <div
                title="Salary Structure Heading"
                className="flex-column form-group-selectt"
              >
                <label
                  htmlFor="name"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  Salary Structure Heading<span className="required">*</span>
                </label>
                <br />
                <select
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleHeadingChange}
                  className={`form-input form-group-selection ${errors.name ? "error" : inputState.name ? "success" : ""}`}
                >
                  <option value="">Select Salary Heading</option>
                  {salaryStructureHeadings
                    ?.filter((i) => !deductionIds.includes(i.id))
                    .map((i) => (
                      <option key={i.id} value={i.id}>
                        {i.title}
                      </option>
                    ))}
                </select>
                {/* <br /> */}
                <div>
                  {errors.name && (
                    <span className="error-message font-size-text">
                      {errors.name}
                    </span>
                  )}
                </div>
              </div>

              {formData.percentage ||
                formData.percentage_of.length > 0 ? null : (
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Fixed Amount<span className="required">*</span>
                  </label>
                  <input
                    type="number"
                    name="fixed_amount"
                    placeholder="Fixed Amount"
                    min={0}
                    value={formData.fixed_amount}
                    onChange={handleInputChange}
                    className={`form-input ${errors.fixed_amount ? "is-invalid" : ""}`}
                  />
                  {errors.fixed_amount && (
                    <div className="error-message font-size-text">
                      {errors.fixed_amount}
                    </div>
                  )}
                </div>
              )}
              {formData.fixed_amount ? null : (
                <>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Percentage Amount<span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      name="percentage"
                      placeholder="Percentage Amount"
                      min={0}
                      value={formData.percentage}
                      onChange={handleInputChange}
                      className={`form-input ${errors.percentage ? "is-invalid" : ""}`}
                    />
                    {errors.percentage && (
                      <div className="error-message font-size-text">
                        {errors.percentage}
                      </div>
                    )}
                  </div>

                  <div title="Related To" className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Related To<span className="required">*</span>
                    </label>
                    <Select
                      isMulti
                      name="percentage_of"
                      value={relatedToOptions.filter((option) =>
                        formData.percentage_of?.includes(option.value),
                      )}
                      onChange={(selectedOptions) =>
                        handleSelectChange(selectedOptions)
                      }
                      options={relatedToOptions}
                      className={`width-15vw ${errors.percentage_of ? "is-invalid" : ""}`}
                      classNamePrefix="select"
                      placeholder="Select Related To"
                      isDisabled={!!formData.fixed_amount} // Disable if fixed amount is provided
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "33vw",
                          minHeight: "50px",
                          borderRadius: "10px",
                          border: "1px solid #e3e3e3",
                          margin: "10px 0px 20px 0px",
                          color: "#4a4a4a",
                          backgroundColor: "#f7f8fa",
                          padding: "0px 10px",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "#4a4a4a",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: "33vw",
                          borderRadius: "10px",
                          marginTop: "0",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          color: "#4a4a4a",
                        }),
                        input: (provided) => ({
                          ...provided,
                          color: "#4a4a4a",
                        }),
                      }}
                    />
                    {errors.percentage_of && (
                      <div className="error-message font-size-text">
                        {errors.percentage_of}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            {errors.mixed && (
              <div className="error-message font-size-text">{errors.mixed}</div>
            )}
            <div className="button-models">
              <button
                className="model-button-cancel model-button font-weight500"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className="model-button font-weight500 model-button-leave font-size-heading"
                disabled={loading}
              >
                {loading ? "Adding..." : "Add"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const UpdateCustomDeductionPolicy = ({
  i,
  calculationPolicy,
  deductionData,
  salaryStructureHeadings,
  getSalaryPolicyRelatedData,
}) => {
  const [formData, setFormData] = useState({
    name: i.id,
    salary_policy: "",
    percentage: "",
    percentage_of: [],
    fixed_amount: "",
  });
  const [show, setShow] = useState(false);
  const handleShow = () => {
    setFormData(i);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const [inputState, setInputState] = useState({});
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const isSalaryHeadingSelected = !!formData.name;
    const hasFixedAmount = formData.fixed_amount !== "";
    const hasPercentage =
      formData.percentage !== "" && formData.percentage_of.length > 0;

    // Validate Salary Heading
    if (!isSalaryHeadingSelected) {
      newErrors.name = "Salary Heading is required!";
    }

    // Validation for Fixed Amount or Percentage
    if (!hasFixedAmount && !hasPercentage) {
      newErrors.mixed =
        "Either Fixed Amount or Percentage with Related To is required!";
    }

    // Additional validation for Fixed Amount if it's entered
    if (hasFixedAmount && !formData.fixed_amount) {
      newErrors.fixed_amount = "Fixed Amount is required!";
    }

    // Additional validation for Percentage if it's entered
    if (hasPercentage) {
      if (!formData.percentage) {
        newErrors.percentage = "Percentage Amount is required!";
      }
      if (formData.percentage_of.length === 0) {
        newErrors.percentage_of = "Related To is required!";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSelectChange = (selectedOptions) => {
    setFormData({
      ...formData,
      percentage_of: selectedOptions
        ? selectedOptions.map((option) => option.value)
        : [],
    });
  };
  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic

      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      let sucessToastId;

      try {
        let ress = await axios.put(
          `${BASE_URL}/wfm/customdeduction/${i.id}/`,
          formData,
        );

        if (ress.status === 200) {
          handleClose();
          await getSalaryPolicyRelatedData();
        } else {
          alert(ress);
        }
      } catch (err) {
        //toast Logic
        handleAllError(err);
      } finally {
        setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };
  const deductionIds = deductionData.map((item) => item.name);
  const relatedToOptions = salaryStructureHeadings
    .filter((i) => deductionIds.includes(i.id))
    .map((i) => ({ value: i.id, label: i.title }));

  return (
    <div>
      <>
        <button
          title="Update Deduction Policy"
          className="model-edit-button-ml"
          onClick={handleShow}
        >
          <UpdatePencil />
        </button>
        <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
          <Modal.Header closeButton>
            <Modal.Title>
              Update Deduction of : "
              {
                salaryStructureHeadings?.find((t) => t.id === formData.name)
                  ?.title
              }{" "}
              (
              {
                salaryStructureHeadings?.find((t) => t.id === formData.name)
                  ?.salary_type
              }
              )"
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ToastContainer
              position="top-center"
              autoClose={3000}
              hideProgressBar
            />
            <form className="register-form">
              <div className="">
                {formData.percentage || formData.percentage_of.length > 0 ? (
                  ""
                ) : (
                  <div className="flex-column">
                    <label className="form-labels  font-weight500 font-size-subheading">
                      Fixed Amount<span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      name="fixed_amount"
                      placeholder="Fixed Amount"
                      min={0}
                      value={formData.fixed_amount}
                      onChange={handleInputChange}
                      className={`form-input ${errors.fixed_amount ? "is-invalid" : ""}`}
                    />
                    {errors.fixed_amount && (
                      <div className="error-message font-size-text">
                        {errors.fixed_amount}
                      </div>
                    )}
                  </div>
                )}
                {formData.fixed_amount ? (
                  ""
                ) : (
                  <>
                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Percentage Amount<span className="required">*</span>
                      </label>
                      <input
                        type="number"
                        name="percentage"
                        placeholder="Percentage Amount"
                        min={0}
                        value={formData.percentage}
                        onChange={handleInputChange}
                        className={`form-input ${errors.percentage ? "is-invalid" : ""}`}
                      />
                      {errors.percentage && (
                        <div className="error-message font-size-text">
                          {errors.percentage}
                        </div>
                      )}
                    </div>
                    <div title="Related To" className="flex-column ">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Related To<span className="required">*</span>
                      </label>
                      <Select
                        isMulti
                        name="percentage_of"
                        value={relatedToOptions.filter((option) =>
                          formData.percentage_of?.includes(option.value),
                        )}
                        onChange={(selectedOptions) =>
                          handleSelectChange(selectedOptions)
                        }
                        options={relatedToOptions}
                        className={`width-15vw ${errors.percentage_of ? "is-invalid" : ""}`}
                        classNamePrefix="select"
                        placeholder="Select Related To"
                        isDisabled={!!formData.fixed_amount} // Disable if fixed amount is provided
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            width: "33vw",
                            minHeight: "50px",
                            borderRadius: "10px",
                            border: "1px solid #e3e3e3",
                            margin: "10px 0px 20px 0px",
                            color: "#4a4a4a",
                            backgroundColor: "#f7f8fa",
                            padding: "0px 10px",
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: "#4a4a4a",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            width: "33vw",
                            borderRadius: "10px",
                            marginTop: "0",
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            color: "#4a4a4a",
                          }),
                          input: (provided) => ({
                            ...provided,
                            color: "#4a4a4a",
                          }),
                        }}
                      />
                      {errors.percentage_of && (
                        <div className="error-message font-size-text">
                          {errors.percentage_of}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </form>
            {errors.mixed && (
              <div className="error-message font-size-text">{errors.mixed}</div>
            )}
            <div className="button-models">
              <button
                className="model-button-cancel model-button font-weight500"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className="model-button  font-weight500  model-button-leave font-size-heading"
                onClick={handleFormSubmit}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    </div>
  );
};

const SalaryCalculationPolicyDelete = ({
  i,
  getSalaryCalculationPolicyList,
}) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/salarypolicy/${i.id}/`);

      if (res.status === 200) {
        await getSalaryCalculationPolicyList();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        className="model-delete-button"
        title="Delete Salary Calculation Policy"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Delete Salary Calculation Policy : {i.policy_name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to Delete Salary Calculation Policy :{" "}
            {i.policy_name}
            <div className="button-models">
              <button
                className="model-button model-button-cancel font-weight500"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button model-button-delete font-weight500"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ? *************** SalaryCalculationPolicy Crud Models End ***************

// ! *************** WeeklyOffPolicy Crud Models Start ***************

const WeeklyOffPolicy = ({ getWeeklyOffPolicyName }) => {
  const [show, setShow] = useState(false);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    name: "",
    off_days: "",
    sub_company: sessionStorage.getItem("company_id"),
  });

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["name"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      setLoading(true); //loading logic
      try {
        let res = await axios.post(
          `${BASE_URL}/wfm/weeklyoffPolicy/`,
          formData,
        );

        if (res.status === 200) {
          setShow(false);
          await getWeeklyOffPolicyName();
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const options = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const weekdays = [
    { code: 1, name: "Sunday" },
    { code: 2, name: "Monday" },
    { code: 3, name: "Tuesday" },
    { code: 4, name: "Wednesday" },
    { code: 5, name: "Thursday" },
    { code: 6, name: "Friday" },
    { code: 7, name: "Saturday" },
  ];

  const weekdaysOptions = weekdays.map((day) => ({
    value: day.name,
    label: `${day.name}`,
  }));

  const handleChangeDays = (selected) => {
    const offDays =
      selected.length > 0 ? selected.map((item) => item.value).join(", ") : "";
    setFormData((prevState) => ({
      ...prevState,
      off_days: offDays,
    }));
  };

  return (
    <>
      <button
        className="models-button model-add"
        title="Add WeekOff Policy"
        onClick={handleShow}
      >
        <AddwithBlueCircle />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Weekly Off Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <div className="flex-column">
                <label
                  htmlFor="name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Attendance Policy Name"
                  onChange={handleInputChange}
                  value={formData.name}
                  className={`form-input ${errors.name ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.name && (
                  <span className="error-message font-size-text ">
                    {errors.name}
                  </span>
                )}
              </div>

              {PERMISSION_AUTHORITY ? (
                <div className="flex-column">
                  <label
                    htmlFor="sub_company"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Sub Company<span className="required">*</span>
                  </label>
                  <select
                    id="sub_company"
                    name="sub_company"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.sub_company
                      ? "error"
                      : inputState.sub_company
                        ? "success"
                        : ""
                      }`}
                  >
                    {SUB_COMPANIES.map((company) => (
                      <option value={company.id}>{company.title}</option>
                    ))}
                    ;
                  </select>
                  {errors.title && (
                    <span className="error-message font-size-text ">
                      {errors.title}
                    </span>
                  )}
                </div>
              ) : null}
              <div className="flex-column">
                <label
                  htmlFor="remarks"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Days to be Weekly Off
                </label>

                <Select
                  options={weekdaysOptions}
                  isMulti
                  onChange={handleChangeDays}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      width: "33vw",
                      minHeight: "50px",
                      borderRadius: "10px",
                      border: "1px solid #e3e3e3",
                      margin: "10px 0px 20px 0px",
                      color: "#4a4a4a",
                      backgroundColor: "#f7f8fa",
                      padding: "0px 10px",
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      color: "#4a4a4a",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      borderRadius: "10px",
                      marginTop: "0",
                    }),
                    input: (provided) => ({
                      ...provided,
                      color: "#4a4a4a",
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: "#4a4a4a",
                    }),
                  }}
                />
                {errors.remarks && (
                  <span className="error-message font-size-text ">
                    {errors.remarks}
                  </span>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button model-button-cancel font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const AddWeeklyOffPolicy = ({ getWeeklyOffPolicyName }) => {
  const [show, setShow] = useState(false);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    name: "",
    off_days: "",
    month_off_days: {},
    sub_company: sessionStorage.getItem("company_id"),
    updated_by: sessionStorage.getItem("emp_code"),
  });

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["name"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ?  ************** Validation End **************  ! //

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const weeks = [1, 2, 3, 4, 5];

  const handleCheckboxChange = (day, week) => {
    setFormData((prevState) => {
      const updatedDays = { ...prevState.month_off_days };
      if (!updatedDays[day]) {
        updatedDays[day] = [];
      }
      if (updatedDays[day].includes(week)) {
        updatedDays[day] = updatedDays[day].filter((w) => w !== week);
        if (updatedDays[day].length === 0) delete updatedDays[day];
      } else {
        updatedDays[day].push(week);
      }
      return { ...prevState, month_off_days: updatedDays };
    });
  };

  const handleSelectColumn = (day) => {
    setFormData((prevState) => {
      const updatedDays = { ...prevState.month_off_days };
      const allWeeks = [1, 2, 3, 4, 5];

      // If the column is already fully selected, deselect it
      if (updatedDays[day]?.length === allWeeks.length) {
        delete updatedDays[day];
      } else {
        // Otherwise, select all weeks for the day
        updatedDays[day] = allWeeks;
      }

      return { ...prevState, month_off_days: updatedDays };
    });
  };

  const handleSelectRow = (week) => {
    setFormData((prevState) => {
      const updatedDays = { ...prevState.month_off_days };

      // Toggle selection for all days in the week
      weekdays.forEach((day) => {
        if (!updatedDays[day]) {
          updatedDays[day] = [];
        }
        if (updatedDays[day].includes(week)) {
          updatedDays[day] = updatedDays[day].filter((w) => w !== week);
          if (updatedDays[day].length === 0) delete updatedDays[day];
        } else {
          updatedDays[day].push(week);
        }
      });

      return { ...prevState, month_off_days: updatedDays };
    });
  };

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      setLoading(true); //loading logic
      try {
        let res = await axios.post(
          `${BASE_URL}/wfm/weeklyoffPolicy/`,
          formData,
        );

        if (res.status === 200) {
          setShow(false);
          await getWeeklyOffPolicyName();
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="upload-svg"
        title="Add WeekOff Policy"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> Weekly Off Policy
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Weekly-Off Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <div className="form-flex-wrap">
                <div className="flex-column">
                  <label
                    htmlFor="name"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Name<span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Attendance Policy Name"
                    onChange={handleInputChange}
                    value={formData.name}
                    className={`form-input ${errors.name ? "error" : inputState.tile ? "success" : ""
                      }`}
                  />
                  {errors.name && (
                    <span className="error-message font-size-text ">
                      {errors.name}
                    </span>
                  )}
                </div>

                {PERMISSION_AUTHORITY ? (
                  <div className="flex-column">
                    <label
                      htmlFor="sub_company"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Sub Company<span className="required">*</span>
                    </label>
                    <select
                      id="sub_company"
                      name="sub_company"
                      value={formData.sub_company}
                      onChange={handleInputChange}
                      className={`form-input form-group-selection ${errors.sub_company
                        ? "error"
                        : inputState.sub_company
                          ? "success"
                          : ""
                        }`}
                    >
                      {SUB_COMPANIES.map((company) => (
                        <option value={company.id}>{company.title}</option>
                      ))}
                      ;
                    </select>
                    {errors.title && (
                      <span className="error-message font-size-text ">
                        {errors.title}
                      </span>
                    )}
                  </div>
                ) : null}
              </div>

              <div title="Weekly Off Days Selection">
                <table className="weeklypolicy-checkbox-table">
                  <thead>
                    <tr>
                      <th></th>
                      {weekdays.map((day) => (
                        <th
                          key={day}
                          onClick={() => handleSelectColumn(day)}
                          style={{ cursor: "pointer" }}
                        >
                          {day}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {weeks.map((week) => (
                      <tr key={week}>
                        <td
                          onClick={() => handleSelectRow(week)}
                          style={{ cursor: "pointer" }}
                        >
                          Week {week}
                        </td>
                        {weekdays.map((day) => (
                          <td key={day}>
                            <label className="checkbox-click">
                              <input
                                type="checkbox"
                                checked={
                                  formData.month_off_days[day]?.includes(
                                    week,
                                  ) || false
                                }
                                onChange={() => handleCheckboxChange(day, week)}
                              />
                              <div className="checkmark"></div>
                            </label>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="button-models">
                <button
                  className="model-button model-button-cancel  model-button-cancel  font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const WeeklyOffPolicyUpdate = ({ i, getWeeklyOffPolicyName }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setFormData(i);
    setShow(true);
    // console.log("formData -");
    // console.log(formData);
    // console.log("formData x");
    // console.log("I -");
    // console.log(i);
    // console.log("I x");
  };

  const [formData, setFormData] = useState({
    name: "",
    off_days: "",
    updated_by: sessionStorage.getItem("emp_code"),
  });

  const [selectedDays, setSelectedDays] = useState([]);

  // useEffect(() => {
  //   setFormData(i);
  // }, [i]);

  console.log(formData);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["name"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ?  ************** Validation End **************  ! //

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/weeklyoffPolicy/${i.id}/`,
          formData,
        );

        if (res.status === 200) {
          await getWeeklyOffPolicyName();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };
  // const weekdays = [
  //   { code: 1, name: "Sunday" },
  //   { code: 2, name: "Monday" },
  //   { code: 3, name: "Tuesday" },
  //   { code: 4, name: "Wednesday" },
  //   { code: 5, name: "Thursday" },
  //   { code: 6, name: "Friday" },
  //   { code: 7, name: "Saturday" }
  // ];

  // const weekdaysOptions = weekdays.map(day => ({
  //   value: day.name,
  //   label: `${day.name}`
  // }));

  // const handleChangeDays = (selected) => {
  //   const offDays = selected.length > 0 ? selected.map((item) => item.value).join(", ") : "";
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     off_days: offDays,
  //   }));
  //   setSelectedDays(selected);

  // };

  // useEffect(() => {
  //   // Assuming formData.off_type contains the value "Friday, Saturday, Sunday"
  //   const selectedDaysArray = formData.off_type?.split(", ").map((day) => ({
  //     value: day,
  //     label: day,
  //   }));
  //   setSelectedDays(selectedDaysArray);
  // }, [formData.off_type]);

  const weekdaysOptions = [
    { value: "Sunday", label: "Sunday" },
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
  ];

  const handleChangeDays = (selected) => {
    const offDays = selected.map((item) => item.value).join(", ");
    setFormData((prevState) => ({
      ...prevState,
      off_days: offDays,
    }));
  };

  useEffect(() => {
    if (formData.off_days) {
      const selectedDaysArray = formData.off_days.split(", ").map((day) => ({
        value: day,
        label: day,
      }));
      setSelectedDays(selectedDaysArray);
    }
  }, [formData.off_days]);

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Update WeekOff Policy"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Policy {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}
              <div className="flex-column">
                <label
                  htmlFor="name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Attendance Policy Name"
                  onChange={handleInputChange}
                  value={formData.name}
                  className={`form-input ${errors.name ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.name && (
                  <span className="error-message font-size-text ">
                    {errors.name}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="off_days"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Days to be Weekly Off
                </label>

                <Select
                  options={weekdaysOptions}
                  isMulti
                  value={selectedDays}
                  onChange={handleChangeDays}
                />
                {errors.remarks && (
                  <span className="error-message font-size-text ">
                    {errors.remarks}
                  </span>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button   font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmitPut}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const UpdateWeeklyOffPolicy = ({ i, getWeeklyOffPolicyName }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setFormData(i);
    setShow(true);
  };

  const [formData, setFormData] = useState({
    name: "",
    off_days: "",
    month_off_days: {},
    sub_company: sessionStorage.getItem("company_id"),
    updated_by: sessionStorage.getItem("emp_code"),
  });

  const [selectedDays, setSelectedDays] = useState([]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["name"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  // ?  ************** Validation End **************  ! //

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSelectColumn = (day) => {
    setFormData((prevState) => {
      const updatedDays = { ...prevState.month_off_days };
      const allWeeks = [1, 2, 3, 4, 5];

      // If the column is already fully selected, deselect it
      if (updatedDays[day]?.length === allWeeks.length) {
        delete updatedDays[day];
      } else {
        // Otherwise, select all weeks for the day
        updatedDays[day] = allWeeks;
      }

      return { ...prevState, month_off_days: updatedDays };
    });
  };

  const handleSelectRow = (week) => {
    setFormData((prevState) => {
      const updatedDays = { ...prevState.month_off_days };

      // Toggle selection for all days in the week
      weekdays.forEach((day) => {
        if (!updatedDays[day]) {
          updatedDays[day] = [];
        }
        if (updatedDays[day].includes(week)) {
          updatedDays[day] = updatedDays[day].filter((w) => w !== week);
          if (updatedDays[day].length === 0) delete updatedDays[day];
        } else {
          updatedDays[day].push(week);
        }
      });

      return { ...prevState, month_off_days: updatedDays };
    });
  };

  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const weeks = [1, 2, 3, 4, 5];

  const handleCheckboxChange = (day, week) => {
    setFormData((prevState) => {
      const updatedDays = { ...prevState.month_off_days };
      if (!updatedDays[day]) {
        updatedDays[day] = [];
      }
      if (updatedDays[day].includes(week)) {
        updatedDays[day] = updatedDays[day].filter((w) => w !== week);
        if (updatedDays[day].length === 0) delete updatedDays[day];
      } else {
        updatedDays[day].push(week);
      }
      return { ...prevState, month_off_days: updatedDays };
    });
  };

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/weeklyoffPolicy/${i.id}/`,
          formData,
        );

        if (res.status === 200) {
          await getWeeklyOffPolicyName();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  const weekdaysOptions = [
    { value: "Sunday", label: "Sunday" },
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
  ];

  const handleChangeDays = (selected) => {
    const offDays = selected.map((item) => item.value).join(", ");
    setFormData((prevState) => ({
      ...prevState,
      off_days: offDays,
    }));
  };

  useEffect(() => {
    if (formData.off_days) {
      const selectedDaysArray = formData.off_days.split(", ").map((day) => ({
        value: day,
        label: day,
      }));
      setSelectedDays(selectedDaysArray);
    }
  }, [formData.off_days]);

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Update WeekOff Policy"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="three-fourth-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Weekly-Off Policy "{i.name}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <div className="flex-column">
                <label
                  htmlFor="name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Attendance Policy Name"
                  onChange={handleInputChange}
                  value={formData.name}
                  className={`form-input ${errors.name ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.name && (
                  <span className="error-message font-size-text ">
                    {errors.name}
                  </span>
                )}
              </div>

              <div title="Weekly Off Days Selection">
                <table className="weeklypolicy-checkbox-table">
                  <thead>
                    <tr>
                      <th></th>
                      {weekdays.map((day) => (
                        <th
                          key={day}
                          onClick={() => handleSelectColumn(day)}
                          style={{ cursor: "pointer" }}
                        >
                          {day}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {weeks.map((week) => (
                      <tr key={week}>
                        <td
                          onClick={() => handleSelectRow(week)}
                          style={{ cursor: "pointer" }}
                        >
                          Week {week}
                        </td>
                        {weekdays.map((day) => (
                          <td key={day}>
                            <label className="checkbox-click">
                              <input
                                type="checkbox"
                                checked={
                                  formData.month_off_days[day]?.includes(
                                    week,
                                  ) || false
                                }
                                onChange={() => handleCheckboxChange(day, week)}
                              />
                              <div className="checkmark"></div>
                            </label>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="button-models">
                <button
                  className="model-button model-button-cancel   font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmitPut}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const WeeklyOffPolicyDelete = ({ i, getWeeklyOffPolicyName }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/weeklyoffPolicy/${i.id}/`);

      if (res.status === 200) {
        await getWeeklyOffPolicyName();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        className="model-delete-button"
        title={
          i.inactive_count === 0
            ? "Delete WeekOff Policy"
            : `Inactive Employee: ${i.inactive_count}`
        }
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Weeklyoff Policy : {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Wantto Delete Weekly Off Policy "{i.name}"?
            {i.inactive_count > 0 && (
              <>
                <br />"{i.inactive_count}" Inactive Employees Exist with "
                {i.name}" Weekly Off Policy
              </>
            )}
            <div className="button-models">
              <button
                className="model-button model-button-cancel font-weight500    "
                onClick={handleClose}
              >
                Cancel
              </button>
              {i.active_count + i.inactive_count === 0 && (
                <button
                  onClick={handleFormSubmitDelete}
                  className="model-button model-button-delete font-weight500"
                >
                  Delete
                </button>
              )}
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ? *************** Weekly Off Policy Crud Models End ***************

// ! *************** Calender Crud Models Start ***************
const CalenderAdd = ({ i, getcalender }) => {
  const [show, setShow] = useState(false);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    date: "",
    descritpion: "",
    offtype: "",
    sub_company: sessionStorage.getItem("company_id"),
    updated_by: sessionStorage.getItem("emp_code"),
  });

  //******************Valedation Start********************* */

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["date", "descritpion", "offtype", "sub_company"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  //******************Valedation End*********************** */

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      setLoading(true); //loading logic
      try {
        let res = await axios.post(`${BASE_URL}/wfm/calander/`, formData);

        if (res.status === 200) {
          await getcalender();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };
  return (
    <>
      <button className="upload-svg" title="Add Calender" onClick={handleShow}>
        <AddwithWhiteCircle /> Add Calender
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Calender</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">

              {PERMISSION_AUTHORITY ? (
                <div className="flex-column">
                  <label
                    htmlFor="sub_company"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Sub Company<span className="required">*</span>
                  </label>
                  <select
                    id="sub_company"
                    name="sub_company"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.sub_company
                      ? "error"
                      : inputState.sub_company
                        ? "success"
                        : ""
                      }`}
                  >
                    {SUB_COMPANIES.map((company) => (
                      <option value={company.id}>{company.title}</option>
                    ))}
                    ;
                  </select>
                  {errors.title && (
                    <span className="error-message font-size-text ">
                      {errors.title}
                    </span>
                  )}
                </div>
              ) : null}
              <div className="flex-column">
                <label
                  htmlFor="date"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Date
                </label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  autoComplete="off"
                  onChange={handleInputChange}
                  value={formData.date}
                  className={`form-input form-input-background ${errors.date ? "error" : inputState.date ? "success" : ""
                    }`}
                />
                {errors.date && (
                  <span className="error-message font-size-text ">
                    {errors.date}
                  </span>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels  font-weight500    font-size-subheading">
                  Type<span className="required">*</span>
                </label>
                <select
                  id="offtype"
                  name="offtype"
                  value={formData.offtype}
                  onChange={handleInputChange}
                  className={`form-input form-input-background ${errors.offtype
                    ? "error"
                    : inputState.offtype
                      ? "success"
                      : ""
                    }`}
                >
                  <option value="">Select Type</option>
                  {/* <option value="weeklyoff">Weekly off</option> */}
                  <option value="holiday">Holiday</option>
                  <option value="workingoff">Declared Working Day</option>
                </select>

                <div>
                  {errors.offtype && (
                    <span className="error-message font-size-text ">
                      {errors.offtype}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex-column">
                <label
                  htmlFor="descritpion"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Description<span className="required">*</span>
                </label>
                <input
                  type="descritpion"
                  id="descritpion"
                  name="descritpion"
                  placeholder="Description ..."
                  onChange={handleInputChange}
                  value={formData.descritpion}
                  className={`form-input ${errors.descritpion
                    ? "error"
                    : inputState.tile
                      ? "success"
                      : ""
                    }`}
                />
                {errors.descritpion && (
                  <span className="error-message font-size-text ">
                    {errors.descritpion}
                  </span>
                )}
              </div>


              <div className="button-models">
                <button
                  className="model-button   font-weight500  model-button-cancel "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const CalenderUpdate = ({ i, getcalender }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    date: "",
    descritpion: "",
    offtype: "",
    updated_by: sessionStorage.getItem("emp_code"),
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  //******************Valedation Start********************* */

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["date", "descritpion", "offtype", "sub_company"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  //******************Valedation End*********************** */

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      setLoading(true); //loading logic
      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/calander/${i.date}/`,
          formData,
        );

        if (res.status === 200) {
          await getcalender();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button className="model-edit-button-ml" onClick={handleShow}>
        <UpdatePencil />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Calender</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <div className="flex-column">
                <label
                  htmlFor="date"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Date<span className="required">*</span>
                </label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  placeholder="Date"
                  onChange={handleInputChange}
                  value={formData.date}
                  className={`form-input ${errors.date ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.date && (
                  <span className="error-message font-size-text ">
                    {errors.date}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading">
                  Type<span className="required">*</span>
                </label>
                <select
                  id="offtype"
                  name="offtype"
                  value={formData.offtype}
                  onChange={handleInputChange}
                  className={`form-input form-input-background ${errors.offtype
                    ? "error"
                    : inputState.offtype
                      ? "success"
                      : ""
                    }`}
                >
                  <option value="">Offtype</option>
                  <option value="weeklyoff">Weekly off</option>
                  <option value="holiday">Holiday</option>
                </select>
                <div>
                  {errors.offtype && (
                    <span className="error-message font-size-text ">
                      {errors.offtype}
                    </span>
                  )}
                </div>
              </div>

              <div className="flex-column">
                <label
                  htmlFor="descritpion"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Description<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="descritpion"
                  name="descritpion"
                  placeholder="Description..."
                  onChange={handleInputChange}
                  value={formData.descritpion}
                  className={`form-input ${errors.descritpion
                    ? "error"
                    : inputState.descritpion
                      ? "success"
                      : ""
                    }`}
                />
                {errors.descritpion && (
                  <span className="error-message font-size-text ">
                    {errors.descritpion}
                  </span>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button font-weight500 model-button-cancel"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button font-weight500 model-button-leave font-size-heading"
                  onClick={handleFormSubmit}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const CalenderDelete = ({ i, getcalender }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/calander/${i.date}/`);

      if (res.status === 200) {
        await getcalender();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };
  return (
    <>
      <button className="model-delete-button" onClick={handleShow}>
        <DeleteDustbin />
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Calender Entry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete Calender Entry {formattedDateLong(i.date)} of type {i.offtype}.
            <div className="button-models">
              <button
                className="model-button font-weight500 model-button-cancel"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button font-weight500 model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};
// ! *************** Calender Crud Models End ***************

// ! *************** InterCom Crud Models Start ***************

const InterCom = ({ getintercom, employeeList }) => {
  const [show, setShow] = useState(false);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    user_detail: "",
    work_email: "",
    contactno: "",
    extensionno: "",
    sub_company: sessionStorage.getItem("company_id"),
    updated_by: sessionStorage.getItem("emp_code"),
  });
  //******************Valedation Start********************* */

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "user_detail",
      "work_email",
      "contactno",
      "extensionno",
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  //******************Valedation End*********************** */

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      setLoading(true); // loading logic
      try {
        let res = await axios.post(`${BASE_URL}/wfm/intercom/`, formData);

        if (res.status === 200) {
          await getintercom();
          setShow(false);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); // Stop loading regardless of the outcome
        toast.dismiss(loadingToastId);
      }
    }
  };
  return (
    <>
      <button
        className="upload-svg"
        style={{ width: "max-content" }}
        title="Add Intercom"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> Add InterCom
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>InterCom</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}

              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="user_detail"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Employee<span className="required">*</span>
                </label>
                <br />
                <select
                  id="user_detail"
                  name="user_detail"
                  value={formData.user_detail}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.user_detail
                    ? "error"
                    : inputState.user_detail
                      ? "success"
                      : ""
                    }`}
                >
                  <option value="">Select Employee</option>
                  {employeeList.map((i) => (
                    <>
                      <option value={i.emp_code}>
                        {i.emp_code}-{i.name}
                      </option>
                    </>
                  ))}
                </select>
                <div className="form-group-selection-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="25"
                    fill="currentColor"
                    class="bi bi-caret-down-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                  </svg>
                </div>
                <div>
                  {errors.emp_code && (
                    <span className="error-message font-size-text ">
                      {errors.emp_code}
                    </span>
                  )}
                </div>
              </div>

              <div className="flex-column">
                <label
                  htmlFor="work_email"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Work Email<span className="required">*</span>
                </label>
                <input
                  type="emial"
                  id="work_email"
                  name="work_email"
                  placeholder="Email"
                  onChange={handleInputChange}
                  value={formData.work_email}
                  className={`form-input ${errors.work_email
                    ? "error"
                    : inputState.work_email
                      ? "success"
                      : ""
                    }`}
                />
                {errors.work_email && (
                  <span className="error-message font-size-text ">
                    {errors.work_email}
                  </span>
                )}
              </div>
              <div className="flex-column">
                <label
                  htmlFor="contactno"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Contact no.<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id="contactno"
                  name="contactno"
                  placeholder="Contact no"
                  onChange={handleInputChange}
                  value={formData.contactno}
                  className={`form-input ${errors.contactno
                    ? "error"
                    : inputState.contactno
                      ? "success"
                      : ""
                    }`}
                />
                {errors.contactno && (
                  <span className="error-message font-size-text ">
                    {errors.contactno}
                  </span>
                )}
              </div>
              <div className="flex-column">
                <label
                  htmlFor="extensionno"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Extension no.<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id="extensionno"
                  name="extensionno"
                  placeholder="Office extension no"
                  onChange={handleInputChange}
                  value={formData.extensionno}
                  className={`form-input ${errors.extensionno
                    ? "error"
                    : inputState.extensionno
                      ? "success"
                      : ""
                    }`}
                />
                {errors.extensionno && (
                  <span className="error-message font-size-text ">
                    {errors.extensionno}
                  </span>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button   font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>

      {/* <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover /> */}
    </>
  );
};

const InterComUpdate = ({ i, getintercom, employeeList }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    user_detail: "",
    work_email: "",
    contactno: "",
    extensionno: "",
    updated_by: sessionStorage.getItem("emp_code"),
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  //******************Valedation Start********************* */

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "user_detail",
      "work_email",
      "contactno",
      "extensionno",
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  //******************Valedation End*********************** */
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/intercom/${i.id}/`,
          formData,
        );

        if (res.status === 200) {
          await getintercom();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };
  return (
    <>
      <button className="model-edit-button-ml" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
            fill="#145650"
          />
        </svg>
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update InterCom</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}

              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="user_detail"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Employee<span className="required">*</span>
                </label>
                <br />
                <select
                  id="user_detail"
                  name="user_detail"
                  value={formData.user_detail}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.user_detail
                    ? "error"
                    : inputState.user_detail
                      ? "success"
                      : ""
                    }`}
                >
                  <option value="">Select Employee</option>
                  {employeeList.map((i) => (
                    <>
                      <option value={i.emp_code}>
                        {i.emp_code}-{i.name}
                      </option>
                    </>
                  ))}
                </select>
                <div className="form-group-selection-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="25"
                    fill="currentColor"
                    class="bi bi-caret-down-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                  </svg>
                </div>
                <div>
                  {errors.emp_code && (
                    <span className="error-message font-size-text ">
                      {errors.emp_code}
                    </span>
                  )}
                </div>
              </div>

              <div className="flex-column">
                <label
                  htmlFor="work_email"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Work Email<span className="required">*</span>
                </label>
                <input
                  type="emial"
                  id="work_email"
                  name="work_email"
                  placeholder="Email"
                  onChange={handleInputChange}
                  value={formData.work_email}
                  className={`form-input ${errors.work_email
                    ? "error"
                    : inputState.work_email
                      ? "success"
                      : ""
                    }`}
                />
                {errors.work_email && (
                  <span className="error-message font-size-text ">
                    {errors.work_email}
                  </span>
                )}
              </div>
              <div className="flex-column">
                <label
                  htmlFor="contactno"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Contact no.<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id="contactno"
                  name="contactno"
                  placeholder="Contact no"
                  onChange={handleInputChange}
                  value={formData.contactno}
                  className={`form-input ${errors.contactno
                    ? "error"
                    : inputState.contactno
                      ? "success"
                      : ""
                    }`}
                />
                {errors.contactno && (
                  <span className="error-message font-size-text ">
                    {errors.contactno}
                  </span>
                )}
              </div>
              <div className="flex-column">
                <label
                  htmlFor="extensionno"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Extension no.<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id="extensionno"
                  name="extensionno"
                  placeholder="Office extension no"
                  onChange={handleInputChange}
                  value={formData.extensionno}
                  className={`form-input ${errors.extensionno
                    ? "error"
                    : inputState.extensionno
                      ? "success"
                      : ""
                    }`}
                />
                {errors.extensionno && (
                  <span className="error-message font-size-text ">
                    {errors.extensionno}
                  </span>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button   font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const InterComDelete = ({ i, getintercom }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/intercom/${i.id}/`);

      if (res.status === 200) {
        await getintercom();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };
  return (
    <>
      <button className="model-delete-button" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete InterCom {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete nterCom {i.title}
            <div className="button-models">
              <button
                className="model-button   font-weight500    "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ! *************** InterCom Crud Models End ***************

// ! *************** Essl Crud Models End ***************

const EsslList = ({ getEssl }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    user_detail: "",
    work_email: "",
    contactno: "",
    extensionno: "",
    sub_company: sessionStorage.getItem("company_id"),
  });
  //******************Valedation Start********************* */

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "user_detail",
      "work_email",
      "contactno",
      "extensionno",
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  //******************Valedation End*********************** */

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); //loading logic

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.post(`${BASE_URL}/wfm/intercom/`, formData);

        if (res.status === 200) {
          await getEssl();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };
  return (
    <>
      <button className="models-button model-add" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clip-path="url(#clip0_1415_3177)">
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
              fill="#2576BC"
            />
          </g>
          <defs>
            <clipPath id="clip0_1415_3177">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Essl Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}

              <div className="flex-column">
                <label
                  htmlFor="user_detail"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Employee Code<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id="user_detail"
                  placeholder="Emp Code"
                  name="user_detail"
                  autoComplete="off"
                  onChange={handleInputChange}
                  value={formData.user_detail}
                  className={`form-input form-input-background ${errors.user_detail
                    ? "error"
                    : inputState.user_detail
                      ? "success"
                      : ""
                    }`}
                />
                {errors.user_detail && (
                  <span className="error-message font-size-text ">
                    {errors.user_detail}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="work_email"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Work Email<span className="required">*</span>
                </label>
                <input
                  type="emial"
                  id="work_email"
                  name="work_email"
                  placeholder="Email"
                  onChange={handleInputChange}
                  value={formData.work_email}
                  className={`form-input ${errors.work_email
                    ? "error"
                    : inputState.work_email
                      ? "success"
                      : ""
                    }`}
                />
                {errors.work_email && (
                  <span className="error-message font-size-text ">
                    {errors.work_email}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="contactno"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Contact no.<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id="contactno"
                  name="contactno"
                  placeholder="Contact no"
                  onChange={handleInputChange}
                  value={formData.contactno}
                  className={`form-input ${errors.contactno
                    ? "error"
                    : inputState.contactno
                      ? "success"
                      : ""
                    }`}
                />
                {errors.contactno && (
                  <span className="error-message font-size-text ">
                    {errors.contactno}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="extensionno"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Extension no.<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id="extensionno"
                  name="extensionno"
                  placeholder="Office extension no"
                  onChange={handleInputChange}
                  value={formData.extensionno}
                  className={`form-input ${errors.extensionno
                    ? "error"
                    : inputState.extensionno
                      ? "success"
                      : ""
                    }`}
                />
                {errors.extensionno && (
                  <span className="error-message font-size-text ">
                    {errors.extensionno}
                  </span>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button   font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const EsslUpdate = ({ i, getEssl }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    user_detail: "",
    work_email: "",
    contactno: "",
    extensionno: "",
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  //******************Valedation Start********************* */

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "user_detail",
      "work_email",
      "contactno",
      "extensionno",
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  //******************Valedation End*********************** */
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/intercom/${i.id}/`,
          formData,
        );

        if (res.status === 200) {
          await getEssl();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };
  return (
    <>
      <button className="model-edit-button-ml" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
            fill="#145650"
          />
        </svg>
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update InterCom</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}
              <div className="flex-column">
                <label
                  htmlFor="user_detail"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Employee Code<span className="required">*</span>
                </label>
                <input
                  // type=""
                  id="user_detail"
                  placeholder="Emp Code"
                  name="user_detail"
                  autoComplete="off"
                  onChange={handleInputChange}
                  value={formData.user_detail}
                  className={`form-input form-input-background ${errors.user_detail
                    ? "error"
                    : inputState.user_detail
                      ? "success"
                      : ""
                    }`}
                />
                {errors.user_detail && (
                  <span className="error-message font-size-text ">
                    {errors.user_detail}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="work_email"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Work Email<span className="required">*</span>
                </label>
                <input
                  type="emial"
                  id="work_email"
                  name="work_email"
                  placeholder="Email"
                  onChange={handleInputChange}
                  value={formData.work_email}
                  className={`form-input ${errors.work_email
                    ? "error"
                    : inputState.work_email
                      ? "success"
                      : ""
                    }`}
                />
                {errors.work_email && (
                  <span className="error-message font-size-text ">
                    {errors.work_email}
                  </span>
                )}
              </div>
              <div className="flex-column">
                <label
                  htmlFor="contactno"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Contact no.<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id="contactno"
                  name="contactno"
                  placeholder="Contact no"
                  onChange={handleInputChange}
                  value={formData.contactno}
                  className={`form-input ${errors.contactno
                    ? "error"
                    : inputState.contactno
                      ? "success"
                      : ""
                    }`}
                />
                {errors.contactno && (
                  <span className="error-message font-size-text ">
                    {errors.contactno}
                  </span>
                )}
              </div>
              <div className="flex-column">
                <label
                  htmlFor="extensionno"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Extension no.<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id="extensionno"
                  name="extensionno"
                  placeholder="Office extension no"
                  onChange={handleInputChange}
                  value={formData.extensionno}
                  className={`form-input ${errors.extensionno
                    ? "error"
                    : inputState.extensionno
                      ? "success"
                      : ""
                    }`}
                />
                {errors.extensionno && (
                  <span className="error-message font-size-text ">
                    {errors.extensionno}
                  </span>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button   font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const EsslDelete = ({ i, getEssl }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/intercom/${i.id}/`);

      if (res.status === 200) {
        await getEssl();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };
  return (
    <>
      <button className="model-delete-button" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete InterCom {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete nterCom {i.title}
            <div className="button-models">
              <button
                className="model-button   font-weight500    "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ! *************** Essl Crud Models End ***************

// ! *************** Hierarchy By employee and department wise ***************

const DepartmentHierarchyAdd = ({
  getHierarchies,
  SUB_COMPANIES,
  SUPER_ADMIN,
  toggleCompany,
  setToggleCompany,
  DEPARTMENTS,
  EMPLOYEES,
  loadingDepts,
  loadingRH
}) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const empCode = sessionStorage.getItem("emp_code");

  const initialLevel = { level: 1, approver: "", role: "" };

  const [formData, setFormData] = useState({
    sub_company: "",
    department: "",
    levels: [{ ...initialLevel }]
  });

  const handleClose = () => {
    setFormData({
      sub_company: "",
      department: "",
      levels: [{ ...initialLevel }]
    });
    setErrors({});
    setInputState({});
    setShow(false);
  };

  const handleShow = () => {
    const currentCompany = (toggleCompany && toggleCompany !== "null")
      ? toggleCompany
      : sessionStorage.getItem('company_id') || "";

    // Sync the parent's dropdown if it wasn't already
    if (currentCompany && setToggleCompany && currentCompany !== toggleCompany) {
      setToggleCompany(currentCompany);
    }

    setFormData(prev => ({
      ...prev,
      sub_company: currentCompany,
      department: "" // Clear out old selections
    }));
    setShow(true);
  };

  // Validation
  const validateForm = () => {
    const newErrors = {};
    if (SUPER_ADMIN && !formData.sub_company) newErrors.sub_company = "Sub Company is required!";
    if (!formData.department) newErrors.department = "Department is required!";

    formData.levels.forEach((lvl, index) => {
      if (!lvl.approver) {
        newErrors[`level_${index}`] = `Approver for Level ${lvl.level} is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });
    setFormData({
      ...formData,
      [name]: value,
    });

    if (value.trim()) {
      setErrors(prevErrors => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }

    // If super admin changes the sub-company inside the modal, tell the parent to fetch new data!
    if (name === 'sub_company' && setToggleCompany) {
      setToggleCompany(value);
      setFormData(prev => ({ ...prev, department: "", levels: [{ ...initialLevel }] }));
    }
  };

  // Dynamic Levels Handlers
  // const handleLevelChange = (index, e) => {
  //   const { value } = e.target;
  //   const updatedLevels = [...formData.levels];
  //   updatedLevels[index].approver = value;
  //   setFormData({ ...formData, levels: updatedLevels });

  //   if (value.trim()) {
  //     setErrors(prevErrors => {
  //       const updatedErrors = { ...prevErrors };
  //       delete updatedErrors[`level_${index}`];
  //       return updatedErrors;
  //     });
  //   }
  // };
  const handleLevelChange = (index, e) => {
    const { value } = e.target;

    const selectedRH = EMPLOYEES.find(
      (rh) => rh.emp_code === value
    );

    const updatedLevels = [...formData.levels];

    updatedLevels[index] = {
      ...updatedLevels[index],
      approver: value,
      role: selectedRH?.role || ""
    };

    setFormData((prev) => ({
      ...prev,
      levels: updatedLevels
    }));

    if (value) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[`level_${index}`];
        return updatedErrors;
      });
    }
  };

  const addLevel = () => {
    if (formData.levels.length >= 3) return; // Max 3 levels
    const nextLevelNum = formData.levels.length + 1;

    setFormData((prev) => ({
      ...prev,
      levels: [
        ...prev.levels,
        {
          level: nextLevelNum,
          approver: "",
          role: ""
        }
      ]
    }));
  };

  const removeLevel = (index) => {
    const updatedLevels = formData.levels.filter((_, i) => i !== index);
    const reindexedLevels = updatedLevels.map((lvl, i) => ({
      ...lvl,
      level: i + 1
    }));
    setFormData({ ...formData, levels: reindexedLevels });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading('Loading: Please wait...');
      setLoading(true);

      const payload = [
        {
          department: formData.department,
          created_by: empCode,
          updated_by: empCode,
          manual_hierarchy: {
            levels: formData.levels.map(lvl => ({
              level: lvl.level,
              approver: lvl.approver,
              role: lvl.role
            }))
          }
        }
      ];

      try {
        let res = await axios.post(`${BASE_URL}/wfm/manual-hierarchy-bulk-create/`, payload);
        if (res.status === 200 || res.status === 201) {
          if (getHierarchies) await getHierarchies();
          handleClose();
          toast.success("Department Hierarchy Created Successfully!");
        }
      } catch (err) {
        toast.error(err?.response?.data?.[0].department?.[0] || "Failed to create hierarchy");
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false);
      }
    }
  };

  return (
    <>
      <button className='upload-svg' title='Add Department Hierarchy' onClick={handleShow}>
        <AddwithWhiteCircle />  Department Hierarchy
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton className="task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Configure Department Hierarchy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">

              {SUPER_ADMIN && (
                <div className="flex-column">
                  <label htmlFor="sub_company" className="form-labels font-weight500 font-size-subheading">
                    Sub Company<span className="required">*</span>
                  </label>
                  <select
                    id="sub_company"
                    name="sub_company"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""}`}
                    style={{ width: 'calc(100% - 22px)', margin: '8px 0' }}
                  >
                    <option value="">Select Site Company</option>
                    {SUB_COMPANIES?.map((company, idx) => (
                      <option key={idx} value={company.id}>{company.title}</option>
                    ))}
                  </select>
                  {errors.sub_company && <span className="error-message font-size-text">{errors.sub_company}</span>}
                </div>
              )}

              {/* Department Selection with Loader passed from parent */}
              <div className="flex-column " title="Departments List">
                <label htmlFor="department" className="form-labels font-weight500 font-size-subheading">
                  Department<span className="required">*</span>
                </label>

                {loadingDepts ? (
                  <div className="form-loader">
                    <div className="bar-loader"></div>
                  </div>
                ) : (
                  <>
                    <select
                      id="department"
                      name="department"
                      value={formData.department}
                      onChange={handleInputChange}
                      className={`form-input form-group-selection ${errors.department ? "error" : inputState.department ? "success" : ""}`}
                      style={{ width: 'calc(100% - 22px)', margin: '8px 0' }}
                    >
                      <option value="">Select Department</option>
                      {DEPARTMENTS
                        ?.sort((a, b) =>
                          a.title?.localeCompare(b.title, "en", {
                            ignorePunctuation: true,
                          }),
                        )
                        .map((i, index) => (
                          <option key={index} value={i.id}>
                            {i.title || i.name} - {i.sub_company_name}
                          </option>
                        ))}
                    </select>
                    {errors.department && <span className="error-message font-size-text">{errors.department}</span>}
                  </>
                )}
              </div>

              <hr className="field-cont-hr" style={{ margin: '15px 0', width: '100%', height: '1px' }} />

              {/* Dynamic Approval Levels */}
              <div className="flex-column">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px 0' }}>
                  <label className="form-labels font-weight500 font-size-subheading" style={{ margin: 0 }}>
                    Approval Hierarchy Levels
                  </label>

                  {formData.levels.length < 3 && (
                    <button type="button" onClick={addLevel} className="model-button font-weight500" style={{ padding: '5px 15px', fontSize: '12px' }}>
                      + Add Level
                    </button>
                  )}
                </div>

                {formData.levels.map((lvl, index) => (
                  <div key={index} className="flex-column" style={{ background: '#ffffff', padding: '15px', borderRadius: '8px', marginBottom: '10px', border: '1px solid #e9ecef', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                    <div className="flex-row" style={{ gap: '15px', alignItems: 'center', width: '100%', flexWrap: 'nowrap' }}>

                      {/* Level Indicator */}
                      <div className="flex-column" style={{ flexShrink: 0, minWidth: '70px' }}>
                        <label className="form-labels font-weight600 font-size-text" style={{ color: '#2576bc', margin: 0 }}>
                          Level {lvl.level}
                        </label>
                      </div>

                      {/* Approver Selection with Loader and Exclusion Logic */}
                      <div className="flex-column" style={{ flex: 1, minWidth: 0 }}>
                        {loadingRH ? (
                          <div className="form-loader" style={{ margin: '0', width: 'calc(100% - 22px)' }}>
                            <div className="bar-loader"></div>
                          </div>
                        ) : (
                          <select
                            name={`approver_${index}`}
                            value={lvl.approver}
                            onChange={(e) => handleLevelChange(index, e)}
                            className={`form-input form-group-selection ${errors[`level_${index}`] ? "error" : ""}`}
                            style={{ width: 'calc(100% - 22px)', margin: '0' }}
                          >
                            <option value="">Select Approver</option>
                            {EMPLOYEES
                              // Logic to exclude RHs selected in OTHER levels
                              ?.filter(rh => {
                                const isSelectedElsewhere = formData.levels.some(
                                  (l, i) => i !== index && l.approver === rh.emp_code
                                );
                                return !isSelectedElsewhere;
                              })
                              ?.sort((a, b) =>
                                a.name.localeCompare(b.name, "en", {
                                  ignorePunctuation: true,
                                }),
                              )
                              .map((i, idx) => (
                                <option key={idx} value={i.emp_code}>
                                  {i.name} - {i.division_name}
                                </option>
                              ))}
                          </select>
                        )}
                      </div>

                      {/* Remove Level Button */}
                      {formData.levels.length > 1 && index === formData.levels.length - 1 && (
                        <div style={{ flexShrink: 0 }}>
                          <button
                            type="button"
                            onClick={() => removeLevel(index)}
                            style={{ background: 'transparent', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '22px', fontWeight: 'bold', lineHeight: 1 }}
                            title="Remove Level"
                          >
                            ×
                          </button>
                        </div>
                      )}
                    </div>
                    {errors[`level_${index}`] && (
                      <span className="error-message font-size-text" style={{ display: 'block', marginTop: '8px' }}>
                        {errors[`level_${index}`]}
                      </span>
                    )}
                  </div>
                ))}
              </div>

              {/* Submit Buttons */}
              <div className="button-models" style={{ marginTop: '20px' }}>
                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                  Cancel
                </button>
                <button
                  className="model-button font-weight500 model-button-leave font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Submit
                </button>
              </div>

            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const DepartmentHierarchyUpdate = ({ i, getHierarchies, SUB_COMPANIES, SUPER_ADMIN, DEPARTMENTS, EMPLOYEES }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const empCode = sessionStorage.getItem("emp_code");

  const [formData, setFormData] = useState({
    id: "",
    sub_company: "",
    department: "",
    levels: []
  });

  const handleClose = () => setShow(false);

  const handleShow = () => {
    setFormData({
      id: i.id,
      sub_company: i.sub_company_id || "",
      department: i.department || "",
      // Ensure levels are copied correctly
      levels: i.manual_hierarchy?.levels ? JSON.parse(JSON.stringify(i.manual_hierarchy.levels)) : [{ level: 1, approver: "", role: "" }]
    });
    setShow(true);
  };

  // const handleLevelChange = (index, e) => {
  //   const { value } = e.target;
  //   const updatedLevels = [...formData.levels];
  //   updatedLevels[index].approver = value;
  //   setFormData({ ...formData, levels: updatedLevels });
  // };

  const handleLevelChange = (index, e) => {
    const { value } = e.target;

    const selectedRH = EMPLOYEES.find(
      (rh) => rh.emp_code === value
    );

    const updatedLevels = [...formData.levels];

    updatedLevels[index] = {
      ...updatedLevels[index],
      approver: value,
      role: selectedRH?.role || ""
    };

    setFormData((prev) => ({
      ...prev,
      levels: updatedLevels
    }));
  };

  const addLevel = () => {
    if (formData.levels.length >= 3) return; // Limit to 3 levels
    const nextLevelNum = formData.levels.length + 1;
    setFormData({
      ...formData,
      levels: [...formData.levels, { level: nextLevelNum, approver: "", role: "" }]
    });
  };

  const removeLevel = (index) => {
    const updatedLevels = formData.levels.filter((_, i) => i !== index);
    // Re-index remaining levels
    const reindexedLevels = updatedLevels.map((lvl, i) => ({
      ...lvl,
      level: i + 1
    }));
    setFormData({ ...formData, levels: reindexedLevels });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Check if all levels have approvers
    if (formData.levels.some(l => !l.approver)) {
      toast.warn("Please select an approver for all levels.");
      return;
    }

    // const payload = [{
    //   id: formData.id,
    //   department: formData.department,
    //   updated_by: empCode,
    //   manual_hierarchy: {
    //     levels: formData.levels
    //   }
    // }];

    const payload = [
      {
        id: formData.id,
        department: formData.department,
        updated_by: empCode,
        manual_hierarchy: {
          levels: formData.levels.map((lvl) => ({
            level: lvl.level,
            approver: lvl.approver,
            role: lvl.role
          }))
        }
      }
    ];

    setLoading(true);
    const loadingToastId = toast.loading('Updating...');

    try {
      await axios.put(`${BASE_URL}/wfm/manual-hierarchy-bulk-update/`, payload);
      toast.success("Hierarchy Updated Successfully!");
      getHierarchies();
      handleClose();
    } catch (err) {
      toast.error("Failed to update hierarchy");
    } finally {
      toast.dismiss(loadingToastId);
      setLoading(false);
    }
  };

  return (
    <>
      <button className="model-edit-button-ml" title="Update Hierarchy" onClick={handleShow}>
        <UpdatePencil />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton className="task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Update Hierarchy: {i.department_title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <label className="form-labels font-weight500">Approval Levels</label>
                {formData.levels.length < 3 && (
                  <button type="button" onClick={addLevel} className="model-button font-weight500" style={{ padding: '5px 15px', fontSize: '12px' }}>
                    + Add Level
                  </button>
                )}
              </div>

              {formData.levels.map((lvl, index) => (
                <div key={index} className="flex-row" style={{ gap: '15px', marginBottom: '10px', alignItems: 'center' }}>
                  <div style={{ minWidth: '70px', fontWeight: '600', color: '#2576bc' }}>Level {lvl.level}</div>

                  <select
                    className="form-input form-group-selection"
                    value={lvl.approver}
                    onChange={(e) => handleLevelChange(index, e)}
                    style={{ width: '100%', margin: '0' }}
                  >
                    <option value="">Select Approver</option>
                    {EMPLOYEES
                      // EXCLUSION LOGIC: Filter out employees already selected in other levels
                      ?.filter(emp => {
                        const isSelectedElsewhere = formData.levels.some(
                          (l, i) => i !== index && l.approver === emp.emp_code
                        );
                        return !isSelectedElsewhere || emp.emp_code === lvl.approver; // Allow the currently selected one
                      })
                      .map((emp) => (
                        <option key={emp.emp_code} value={emp.emp_code}>
                          {emp.name} ({emp.emp_code})
                        </option>
                      ))}
                  </select>

                  {formData.levels.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeLevel(index)}
                      style={{ background: 'transparent', border: 'none', color: '#dc3545', fontSize: '22px', fontWeight: 'bold' }}
                    >
                      ×
                    </button>
                  )}
                </div>
              ))}

              <div className="button-models" style={{ marginTop: '20px' }}>
                <button className="model-button model-button-cancel" onClick={handleClose}>Cancel</button>
                <button className="model-button model-button-leave" onClick={handleFormSubmit} disabled={loading}>
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const DepartmentHierarchyDelete = ({ i, getHierarchies }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    const loadingToastId = toast.loading('Deleting...');

    try {
      // Assuming your delete endpoint takes the hierarchy ID
      await axios.delete(`${BASE_URL}/wfm/manual-hierarchy-data-update/${i.id}/`);

      toast.success("Hierarchy Deleted Successfully!");
      if (getHierarchies) await getHierarchies();
      handleClose();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to delete hierarchy");
    } finally {
      toast.dismiss(loadingToastId);
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className="model-delete-button"
        title="Delete Hierarchy"
        onClick={handleShow}
        style={{ marginLeft: '10px' }}
      >
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are you sure you want to delete the hierarchy for <strong>"{i.department_title}"</strong>?
            <div className="button-models">
              <button
                className="model-button model-button-cancel font-weight500"
                onClick={handleClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="model-button model-button-delete font-weight500"
                onClick={handleDelete}
                disabled={loading}
              >
                {loading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer position="top-center" autoClose={1000} />
    </>
  );
};


// const EmployeeHierarchyAdd = ({ getHierarchies,
//   EMPLOYEELIST,
//   employeeLoading,
//   RHLIST,
//   loadingRH,
//   SUB_COMPANIES,
//   SUPER_ADMIN,
//   toggleCompany }) => {
//   const [show, setShow] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});

//   const [employeeSearch, setEmployeeSearch] = useState("");
//   const initialLevel = { level: 1, approver: "" };

//   const [formData, setFormData] = useState({
//     sub_company: sessionStorage.getItem("company_id"),
//     created_by: sessionStorage.getItem("emp_code"),
//     updated_by: sessionStorage.getItem("emp_code"),
//     employees: [],
//     levels: [{ ...initialLevel }]
//   });

//   const handleClose = () => {
//     setFormData({
//       sub_company: "",
//       employees: [],
//       levels: [{ ...initialLevel }]
//     });
//     setErrors({});
//     setInputState({});
//     setEmployeeSearch("");
//     setShow(false);
//   };
//   const handleShow = () => {
//     const currentCompany =
//       toggleCompany && toggleCompany !== "null"
//         ? toggleCompany
//         : sessionStorage.getItem("company_id") || "";

//     setFormData(prev => ({
//       ...prev,
//       sub_company: currentCompany,
//       employees: []
//     }));



//     setShow(true);
//   };



//   // Validation
//   const validateForm = () => {
//     const newErrors = {};
//     if (SUPER_ADMIN && !formData.sub_company) newErrors.sub_company = "Sub Company is required!";
//     if (!formData.employees.length) newErrors.employees = "Select at least one employee!";

//     formData.levels.forEach((lvl, index) => {
//       if (!lvl.approver) {
//         newErrors[`level_${index}`] = `Approver for Level ${lvl.level} is required!`;
//       }
//     });

//     // Optional: Check for duplicate approvers in the same hierarchy chain
//     const approvers = formData.levels.map(l => l.approver).filter(Boolean);
//     if (new Set(approvers).size !== approvers.length) {
//       newErrors.general = "An employee cannot be an approver at multiple levels!";
//     }

//     // An employee shouldn't be their own approver
//     const selfApprover = formData.employees.some(empCode => approvers.includes(empCode));
//     if (selfApprover) {
//       newErrors.general = "A selected employee cannot also be an approver for this hierarchy!";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setInputState(prev => ({
//       ...prev,
//       [name]: value.trim() ? "green" : "",
//     }));

//     if (name === "sub_company") {

//       // Reset employees and hierarchy selections
//       setFormData(prev => ({
//         ...prev,
//         sub_company: value,
//         employees: [],
//         levels: prev.levels.map(level => ({
//           ...level,
//           approver: ""
//         }))
//       }));

//       return;
//     }

//     setFormData(prev => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const employeeOptions = EMPLOYEELIST
//     ?.sort((a, b) => a.emp_code - b.emp_code)
//     .map(emp => ({
//       value: emp.emp_code,
//       label: `${emp.name} - ${emp.emp_code}`
//     }));

//   // Employee Multi-Select Handlers
//   const toggleEmployee = (empCode) => {
//     setFormData(prev => {
//       const alreadySelected = prev.employees.includes(empCode);
//       const updatedEmployees = alreadySelected
//         ? prev.employees.filter(code => code !== empCode)
//         : [...prev.employees, empCode];
//       return { ...prev, employees: updatedEmployees };
//     });
//     setInputState(prev => ({ ...prev, employees: "green" }));
//   };

//   const removeEmployee = (empCode) => {
//     setFormData(prev => ({
//       ...prev,
//       employees: prev.employees.filter(code => code !== empCode)
//     }));
//   };




//   // Dynamic Levels Handlers
//   const handleLevelChange = (index, e) => {
//     const { value } = e.target;
//     const updatedLevels = [...formData.levels];
//     updatedLevels[index].approver = value;
//     setFormData({ ...formData, levels: updatedLevels });

//     if (value.trim()) {
//       setErrors(prevErrors => {
//         const updatedErrors = { ...prevErrors };
//         delete updatedErrors[`level_${index}`];
//         return updatedErrors;
//       });
//     }
//   };

//   const addLevel = () => {
//     if (formData.levels.length >= 3) return; // Max 3 levels
//     const nextLevelNum = formData.levels.length + 1;
//     setFormData({
//       ...formData,
//       levels: [...formData.levels, { level: nextLevelNum, approver: "" }]
//     });
//   };

//   const removeLevel = (index) => {
//     const updatedLevels = formData.levels.filter((_, i) => i !== index);
//     const reindexedLevels = updatedLevels.map((lvl, i) => ({
//       ...lvl,
//       level: i + 1
//     }));
//     setFormData({ ...formData, levels: reindexedLevels });
//   };



//   const handleFormSubmit = async (e) => {
//     e.preventDefault();

//     if (validateForm()) {
//       const loadingToastId = toast.loading('Loading: Please wait...');
//       setLoading(true);


//       const payload = [
//         {
//           employee: formData.employees,
//           manual_hierarchy: {
//             levels: formData.levels.map(lvl => ({
//               level: lvl.level,
//               approver: lvl.approver
//             }))
//           }
//         }
//       ];

//       try {
//         let res = await axios.post(`${BASE_URL}/wfm/manual-hierarchy-bulk-create/`, payload);
//         if (res.status === 200 || res.status === 201) {
//           if (getHierarchies) await getHierarchies();
//           handleClose();
//           toast.success("Employee Hierarchy Created Successfully!");
//         }
//       } catch (err) {
//         toast.error(err?.response?.data?.message || "Failed to create hierarchy");
//       } finally {
//         toast.dismiss(loadingToastId);
//         setLoading(false);
//       }
//     }
//   };
//   // wfm/rhlistactive/3e640f93-152c-45b4-aee8-b461160d23d4/active/

//   return (
//     <>
//       <button className="upload-svg" title="Add Employee Hierarchy" onClick={handleShow}>
//         <AddwithWhiteCircle /> Employee Hierarchy
//       </button>


//       <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
//         <Modal.Header closeButton className="task-Tab-heading font-weight500 font-size-heading">
//           <Modal.Title>Configure Employee Hierarchy</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="parent-div">
//             <div className="bdy-div">

//               {errors.general && (
//                 <div style={{ color: '#dc3545', marginBottom: '15px', fontWeight: '500' }}>
//                   {errors.general}
//                 </div>
//               )}

//               {SUPER_ADMIN && (
//                 <div className="flex-column">
//                   <label htmlFor="sub_company" className="form-labels font-weight500 font-size-subheading">
//                     Sub Company<span className="required">*</span>
//                   </label>
//                   <select
//                     id="sub_company"
//                     name="sub_company"
//                     value={formData.sub_company}
//                     onChange={handleInputChange}
//                     className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""}`}
//                     style={{ width: 'calc(100% - 22px)', margin: '8px 0' }}
//                   >
//                     <option value="">Select Site Company</option>
//                     {SUB_COMPANIES?.map((company, idx) => (
//                       <option key={idx} value={company.id}>{company.title}</option>
//                     ))}
//                   </select>
//                   {errors.sub_company && <span className="error-message font-size-text">{errors.sub_company}</span>}
//                 </div>
//               )}

//               {/* Employee Selection - supports single or multiple employees */}
//               <div className="flex-column">

//                 <label className="form-labels font-weight500 font-size-subheading">
//                   Employee<span className="required">*</span>
//                 </label>
//                 {employeeLoading ? (
//                   <div className="form-loader">
//                     <div className="bar-loader"></div>
//                   </div>
//                 ) : (
//                   <Select
//                     isMulti
//                     isSearchable
//                     options={employeeOptions}
//                     placeholder="Search & Select Employees"
//                     closeMenuOnSelect={false}
//                     value={employeeOptions.filter(option =>
//                       formData.employees.includes(option.value)
//                     )}
//                     onChange={(selected) => {
//                       setFormData(prev => ({
//                         ...prev,
//                         employees: selected
//                           ? selected.map(item => item.value)
//                           : []
//                       }));

//                       setInputState(prev => ({
//                         ...prev,
//                         employees: "green"
//                       }));
//                     }}
//                     className={errors.employees ? "error" : ""}
//                     styles={{
//                       control: (provided) => ({
//                         ...provided,
//                         width: '98%',
//                         minHeight: '50px',
//                         borderRadius: '10px',
//                         border: '1px solid #e3e3e3',
//                         margin: '10px 0px 20px 0px',
//                         color: '#4a4a4a',
//                         backgroundColor: '#f7f8fa',
//                         padding: '0px 10px',
//                       }),
//                       placeholder: (provided) => ({ ...provided, color: '#4a4a4a' }),
//                       menu: (provided) => ({ ...provided, borderRadius: '10px', marginTop: '0' }),
//                       input: (provided) => ({ ...provided, color: '#4a4a4a' }),
//                       singleValue: (provided) => ({ ...provided, color: '#4a4a4a' }),
//                     }}
//                   />
//                 )}
//                 {errors.employees && (
//                   <span className="error-message">
//                     {errors.employees}
//                   </span>
//                 )}
//               </div>

//               <hr className="field-cont-hr" style={{ margin: '15px 0', width: '100%', height: '1px' }} />

//               {/* Dynamic Approval Levels */}
//               <div className="flex-column">
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
//                   <label className="form-labels font-weight500 font-size-subheading" style={{ margin: 0 }}>
//                     Approval Hierarchy Levels
//                   </label>
//                   <button type="button" onClick={addLevel} className="model-button font-weight500" style={{ padding: '5px 15px', fontSize: '12px' }}>
//                     + Add Level
//                   </button>
//                 </div>

//                 {formData.levels.map((lvl, index) => (
//                   <div key={index} className="flex-column" style={{ background: '#ffffff', padding: '15px', borderRadius: '8px', marginBottom: '10px', border: '1px solid #e9ecef', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
//                     <div className="flex-row" style={{ gap: '15px', alignItems: 'center', width: '100%', flexWrap: 'nowrap' }}>

//                       {/* Level Indicator */}
//                       <div className="flex-column" style={{ flexShrink: 0, minWidth: '70px' }}>
//                         <label className="form-labels font-weight600 font-size-text" style={{ color: '#2576bc' }}>
//                           Level {lvl.level}
//                         </label>
//                       </div>

//                       {/* Approver Selection with Loader and Exclusion Logic */}
//                       <div className="flex-column" style={{ flex: 1, minWidth: 0 }}>
//                         {loadingRH ? (
//                           <div className="form-loader" style={{ margin: '0', width: 'calc(100% - 22px)' }}>
//                             <div className="bar-loader"></div>
//                           </div>
//                         ) : (
//                           <select
//                             name={`approver_${index}`}
//                             value={lvl.approver}
//                             onChange={(e) => handleLevelChange(index, e)}
//                             className={`form-input form-group-selection ${errors[`level_${index}`] ? "error" : ""}`}
//                             style={{ width: 'calc(100% - 22px)', margin: '0' }}
//                           >
//                             <option value="">Select Approver</option>
//                             {RHLIST
//                               // Logic to exclude RHs selected in OTHER levels
//                               ?.filter(rh => {
//                                 const isSelectedElsewhere = formData.levels.some(
//                                   (l, i) => i !== index && l.approver === rh.emp_code
//                                 );
//                                 return !isSelectedElsewhere;
//                               })
//                               ?.sort((a, b) =>
//                                 a.name.localeCompare(b.name, "en", {
//                                   ignorePunctuation: true,
//                                 }),
//                               )
//                               .map((i, idx) => (
//                                 <option key={idx} value={i.emp_code}>
//                                   {i.name}-{i.division_name}
//                                 </option>
//                               ))}
//                           </select>
//                         )}
//                       </div>

//                       {/* Remove Level Button */}
//                       {formData.levels.length > 1 && index === formData.levels.length - 1 && (
//                         <div style={{ flexShrink: 0 }}>
//                           <button
//                             type="button"
//                             onClick={() => removeLevel(index)}
//                             style={{ background: 'transparent', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '22px', fontWeight: 'bold', lineHeight: 1 }}
//                             title="Remove Level"
//                           >
//                             ×
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                     {errors[`level_${index}`] && (
//                       <span className="error-message font-size-text" style={{ display: 'block', marginTop: '8px' }}>
//                         {errors[`level_${index}`]}
//                       </span>
//                     )}
//                   </div>
//                 ))}
//               </div>

//               {/* Submit Buttons */}
//               <div className="button-models" style={{ marginTop: '20px' }}>
//                 <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
//                   Cancel
//                 </button>
//                 <button
//                   className="model-button font-weight500 model-button-leave font-size-heading"
//                   onClick={handleFormSubmit}
//                   disabled={loading}
//                 >
//                   Submit
//                 </button>
//               </div>

//             </div>
//           </div>
//           <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

const EmployeeHierarchyAdd = ({ getHierarchies,
  EMPLOYEELIST,
  employeeLoading,
  RHLIST,
  loadingRH,
  SUB_COMPANIES,
  SUPER_ADMIN,
  toggleCompany }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const [employeeSearch, setEmployeeSearch] = useState("");
  const initialLevel = { level: 1, approver: "", role: "" };

  const [formData, setFormData] = useState({
    sub_company: sessionStorage.getItem("company_id"),
    created_by: sessionStorage.getItem("emp_code"),
    updated_by: sessionStorage.getItem("emp_code"),
    employees: [],
    levels: [{ ...initialLevel }]
  });

  // NEW: local employee/RH lists scoped to whatever sub_company is currently
  // selected INSIDE the modal (not the parent table's toggleCompany filter).
  // Seeded from props so the first render (sub_company === toggleCompany) has
  // data immediately, then kept in sync via the effect below.
  const [modalEmpList, setModalEmpList] = useState(EMPLOYEELIST || []);
  const [modalEmpLoading, setModalEmpLoading] = useState(false);
  const [modalRHList, setModalRHList] = useState(RHLIST || []);
  const [modalRHLoading, setModalRHLoading] = useState(false);

  // Refetch employee list + RH list whenever the modal's sub_company changes
  useEffect(() => {
    if (!show) return;

    const subId = formData.sub_company;
    if (!subId || subId === "null") {
      setModalEmpList([]);
      setModalRHList([]);
      return;
    }

    const fetchForSubCompany = async () => {
      setModalEmpLoading(true);
      setModalRHLoading(true);
      try {
        const [empRes, rhRes] = await Promise.all([
          axios.get(`${BASE_URL}/wfm/ourcompanyempdetailsactive/${subId}/`),
          axios.get(`${BASE_URL}/wfm/rhlistactive/${subId}/active/`)
        ]);
        setModalEmpList(customSortByKey(empRes.data, "emp_code"));
        setModalRHList(rhRes.data);
      } catch (err) {
        console.error("Failed to fetch employees/reporting heads for sub company", err);
        setModalEmpList([]);
        setModalRHList([]);
      } finally {
        setModalEmpLoading(false);
        setModalRHLoading(false);
      }
    };

    fetchForSubCompany();
  }, [formData.sub_company, show]);

  const handleClose = () => {
    // FIX #4: created_by / updated_by were being dropped on close and never
    // restored, so every form-open after the first close submitted with
    // undefined created_by/updated_by.
    setFormData({
      sub_company: sessionStorage.getItem("company_id"),
      created_by: sessionStorage.getItem("emp_code"),
      updated_by: sessionStorage.getItem("emp_code"),
      employees: [],
      levels: [{ ...initialLevel }]
    });
    setErrors({});
    setInputState({});
    setEmployeeSearch("");
    setShow(false);
  };
  const handleShow = () => {
    const currentCompany =
      toggleCompany && toggleCompany !== "null"
        ? toggleCompany
        : sessionStorage.getItem("company_id") || "";

    setFormData(prev => ({
      ...prev,
      sub_company: currentCompany,
      created_by: sessionStorage.getItem("emp_code"),
      updated_by: sessionStorage.getItem("emp_code"),
      employees: []
    }));

    setShow(true);
  };



  // Validation
  const validateForm = () => {
    const newErrors = {};
    if (SUPER_ADMIN && !formData.sub_company) newErrors.sub_company = "Sub Company is required!";
    if (!formData.employees.length) newErrors.employees = "Select at least one employee!";

    formData.levels.forEach((lvl, index) => {
      if (!lvl.approver) {
        newErrors[`level_${index}`] = `Approver for Level ${lvl.level} is required!`;
      }
    });

    // Optional: Check for duplicate approvers in the same hierarchy chain
    const approvers = formData.levels.map(l => l.approver).filter(Boolean);
    if (new Set(approvers).size !== approvers.length) {
      newErrors.general = "An employee cannot be an approver at multiple levels!";
    }

    // An employee shouldn't be their own approver
    const selfApprover = formData.employees.some(empCode => approvers.includes(empCode));
    if (selfApprover) {
      newErrors.general = "A selected employee cannot also be an approver for this hierarchy!";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState(prev => ({
      ...prev,
      [name]: value.trim() ? "green" : "",
    }));

    if (name === "sub_company") {

      // Reset employees and hierarchy selections
      setFormData(prev => ({
        ...prev,
        sub_company: value,
        employees: [],
        levels: prev.levels.map(level => ({
          ...level,
          approver: "",
          role: ""
        }))
      }));

      return;
    }

    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const employeeOptions = modalEmpList
    ?.slice()
    ?.sort((a, b) => a.emp_code - b.emp_code)
    .map(emp => ({
      value: emp.emp_code,
      label: `${emp.name} - ${emp.emp_code}`
    })) || [];

  // Employee Multi-Select Handlers
  const toggleEmployee = (empCode) => {
    setFormData(prev => {
      const alreadySelected = prev.employees.includes(empCode);
      const updatedEmployees = alreadySelected
        ? prev.employees.filter(code => code !== empCode)
        : [...prev.employees, empCode];
      return { ...prev, employees: updatedEmployees };
    });
    setInputState(prev => ({ ...prev, employees: "green" }));
  };

  const removeEmployee = (empCode) => {
    setFormData(prev => ({
      ...prev,
      employees: prev.employees.filter(code => code !== empCode)
    }));
  };




  // Dynamic Levels Handlers
  // const handleLevelChange = (index, e) => {
  //   const { value } = e.target;
  //   const updatedLevels = [...formData.levels];
  //   updatedLevels[index].approver = value;
  //   updatedLevels[index].role = value;
  //   setFormData({ ...formData, levels: updatedLevels });

  //   if (value.trim()) {
  //     setErrors(prevErrors => {
  //       const updatedErrors = { ...prevErrors };
  //       delete updatedErrors[`level_${index}`];
  //       return updatedErrors;
  //     });
  //   }
  // };

  const handleLevelChange = (index, e) => {
    const { value } = e.target;

    // Find selected reporting head
    const selectedRH = modalRHList.find(
      (rh) => rh.emp_code === value
    );

    const updatedLevels = [...formData.levels];

    updatedLevels[index] = {
      ...updatedLevels[index],
      approver: value,
      role: selectedRH?.role || ""
    };

    setFormData((prev) => ({
      ...prev,
      levels: updatedLevels
    }));

    if (value) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[`level_${index}`];
        return updatedErrors;
      });
    }
  };

  const addLevel = () => {
    if (formData.levels.length >= 3) return; // Max 3 levels
    const nextLevelNum = formData.levels.length + 1;
    setFormData({
      ...formData,
      levels: [...formData.levels, { level: nextLevelNum, approver: "", role: "" }]
    });
  };

  const removeLevel = (index) => {
    const updatedLevels = formData.levels.filter((_, i) => i !== index);
    const reindexedLevels = updatedLevels.map((lvl, i) => ({
      ...lvl,
      level: i + 1
    }));
    setFormData({ ...formData, levels: reindexedLevels });
  };



  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading('Loading: Please wait...');
      setLoading(true);

      // FIX #3: sub_company / created_by / updated_by were missing from the
      // payload entirely — backend had no way of knowing which sub-company
      // this hierarchy belonged to, or who created/updated it.
      const payload = [
        {
          employee: formData.employees,
          sub_company: formData.sub_company,
          created_by: formData.created_by,
          updated_by: formData.updated_by,
          manual_hierarchy: {
            levels: formData.levels.map(lvl => ({
              level: lvl.level,
              approver: lvl.approver,
              role: lvl.role
            }))
          }
        }
      ];

      try {
        let res = await axios.post(`${BASE_URL}/wfm/manual-hierarchy-bulk-create/`, payload);
        if (res.status === 200 || res.status === 201) {
          if (getHierarchies) await getHierarchies();
          handleClose();
          toast.success("Employee Hierarchy Created Successfully!");
        }
      } catch (err) {
        let errorMessage = "Failed to create hierarchy";

        const errorData = err?.response?.data;

        if (Array.isArray(errorData)) {
          // Handles: [{ employee: ["message"] }]
          const firstErrorObj = errorData[0];

          if (firstErrorObj) {
            const firstKey = Object.keys(firstErrorObj)[0];

            if (firstKey) {
              const value = firstErrorObj[firstKey];

              errorMessage = Array.isArray(value) ? value[0] : value;
            }
          }
        } else if (typeof errorData === "object" && errorData !== null) {
          // Handles: { employee: ["message"] } or { message: "..." }
          if (errorData.message) {
            errorMessage = errorData.message;
          } else {
            const firstKey = Object.keys(errorData)[0];
            const value = errorData[firstKey];
            errorMessage = Array.isArray(value) ? value[0] : value;
          }
        }

        toast.error(errorMessage);
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false);
      }
    }
  };

  return (
    <>
      <button className="upload-svg" title="Add Employee Hierarchy" onClick={handleShow}>
        <AddwithWhiteCircle /> Employee Hierarchy
      </button>


      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton className="task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Configure Employee Hierarchy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">

              {errors.general && (
                <div style={{ color: '#dc3545', marginBottom: '15px', fontWeight: '500' }}>
                  {errors.general}
                </div>
              )}

              {SUPER_ADMIN && (
                <div className="flex-column">
                  <label htmlFor="sub_company" className="form-labels font-weight500 font-size-subheading">
                    Sub Company<span className="required">*</span>
                  </label>
                  <select
                    id="sub_company"
                    name="sub_company"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""}`}
                    style={{ width: 'calc(100% - 22px)', margin: '8px 0' }}
                  >
                    <option value="">Select Site Company</option>
                    {SUB_COMPANIES?.map((company, idx) => (
                      <option key={idx} value={company.id}>{company.title}</option>
                    ))}
                  </select>
                  {errors.sub_company && <span className="error-message font-size-text">{errors.sub_company}</span>}
                </div>
              )}

              {/* Employee Selection - supports single or multiple employees */}
              <div className="flex-column">

                <label className="form-labels font-weight500 font-size-subheading">
                  Employee<span className="required">*</span>
                </label>
                {(employeeLoading || modalEmpLoading) ? (
                  <div className="form-loader">
                    <div className="bar-loader"></div>
                  </div>
                ) : (
                  <Select
                    isMulti
                    isSearchable
                    options={employeeOptions}
                    placeholder="Search & Select Employees"
                    closeMenuOnSelect={false}
                    value={employeeOptions.filter(option =>
                      formData.employees.includes(option.value)
                    )}
                    onChange={(selected) => {
                      setFormData(prev => ({
                        ...prev,
                        employees: selected
                          ? selected.map(item => item.value)
                          : []
                      }));

                      setInputState(prev => ({
                        ...prev,
                        employees: "green"
                      }));
                    }}
                    className={errors.employees ? "error" : ""}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        width: '96%',
                        minHeight: '50px',
                        borderRadius: '10px',
                        border: '1px solid #e3e3e3',
                        margin: '10px 0px 20px 0px',
                        color: '#4a4a4a',
                        backgroundColor: '#f7f8fa',
                        padding: '0px 10px',
                      }),
                      placeholder: (provided) => ({ ...provided, color: '#4a4a4a' }),
                      menu: (provided) => ({ ...provided, borderRadius: '10px', marginTop: '0' }),
                      input: (provided) => ({ ...provided, color: '#4a4a4a' }),
                      singleValue: (provided) => ({ ...provided, color: '#4a4a4a' }),
                    }}
                  />
                )}
                {errors.employees && (
                  <span className="error-message">
                    {errors.employees}
                  </span>
                )}
              </div>

              <hr className="field-cont-hr" style={{ margin: '15px 0', width: '100%', height: '1px' }} />

              {/* Dynamic Approval Levels */}
              <div className="flex-column">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                  <label className="form-labels font-weight500 font-size-subheading" style={{ margin: 0 }}>
                    Approval Hierarchy Levels
                  </label>
                  <button type="button" onClick={addLevel} className="model-button font-weight500" style={{ padding: '5px 15px', fontSize: '12px' }}>
                    + Add Level
                  </button>
                </div>

                {formData.levels.map((lvl, index) => (
                  <div key={index} className="flex-column" style={{ background: '#ffffff', padding: '15px', borderRadius: '8px', marginBottom: '10px', border: '1px solid #e9ecef', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                    <div className="flex-row" style={{ gap: '15px', alignItems: 'center', width: '100%', flexWrap: 'nowrap' }}>

                      {/* Level Indicator */}
                      <div className="flex-column" style={{ flexShrink: 0, minWidth: '70px' }}>
                        <label className="form-labels font-weight600 font-size-text" style={{ color: '#2576bc' }}>
                          Level {lvl.level}
                        </label>
                      </div>

                      {/* Approver Selection with Loader and Exclusion Logic */}
                      <div className="flex-column" style={{ flex: 1, minWidth: 0 }}>
                        {(loadingRH || modalRHLoading) ? (
                          <div className="form-loader" style={{ margin: '0', width: 'calc(100% - 22px)' }}>
                            <div className="bar-loader"></div>
                          </div>
                        ) : (
                          <select
                            name={`approver_${index}`}
                            value={lvl.approver}
                            onChange={(e) => handleLevelChange(index, e)}
                            className={`form-input form-group-selection ${errors[`level_${index}`] ? "error" : ""}`}
                            style={{ width: 'calc(100% - 22px)', margin: '0' }}
                          >
                            <option value="">Select Approver</option>
                            {modalRHList
                              // Logic to exclude RHs selected in OTHER levels
                              ?.filter(rh => {
                                const isSelectedElsewhere = formData.levels.some(
                                  (l, i) => i !== index && l.approver === rh.emp_code
                                );
                                return !isSelectedElsewhere;
                              })
                              ?.sort((a, b) =>
                                a.name.localeCompare(b.name, "en", {
                                  ignorePunctuation: true,
                                }),
                              )
                              .map((i, idx) => (
                                <option key={idx} value={i.emp_code}>
                                  {i.name}-{i.division_name}
                                </option>
                              ))}
                          </select>
                        )}
                      </div>

                      {/* Remove Level Button */}
                      {formData.levels.length > 1 && index === formData.levels.length - 1 && (
                        <div style={{ flexShrink: 0 }}>
                          <button
                            type="button"
                            onClick={() => removeLevel(index)}
                            style={{ background: 'transparent', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '22px', fontWeight: 'bold', lineHeight: 1 }}
                            title="Remove Level"
                          >
                            ×
                          </button>
                        </div>
                      )}
                    </div>
                    {errors[`level_${index}`] && (
                      <span className="error-message font-size-text" style={{ display: 'block', marginTop: '8px' }}>
                        {errors[`level_${index}`]}
                      </span>
                    )}
                  </div>
                ))}
              </div>

              {/* Submit Buttons */}
              <div className="button-models" style={{ marginTop: '20px' }}>
                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                  Cancel
                </button>
                <button
                  className="model-button font-weight500 model-button-leave font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Submit
                </button>
              </div>

            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};



// const EmployeeHierarchyUpdate = ({ i, getHierarchies, EMPLOYEELIST, employeeLoading, RHLIST, loadingRH, SUB_COMPANIES, SUPER_ADMIN, toggleCompany }) => {
//   const [show, setShow] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});
//   const initialLevel = { level: 1, approver: "" };
//   console.log(i, "i....................");


//   // Local employee/RH lists scoped to whatever sub_company is currently
//   // selected INSIDE the modal (not the parent table's toggleCompany filter).
//   // Seeded from props, kept in sync via the effect below.
//   const [modalEmpList, setModalEmpList] = useState(EMPLOYEELIST || []);
//   const [modalEmpLoading, setModalEmpLoading] = useState(false);
//   const [modalRHList, setModalRHList] = useState(RHLIST || []);
//   const [modalRHLoading, setModalRHLoading] = useState(false);

//   const [formData, setFormData] = useState({
//     sub_company: sessionStorage.getItem("company_id"),
//     created_by: sessionStorage.getItem("emp_code"),
//     updated_by: sessionStorage.getItem("emp_code"),
//     employees: [],
//     levels: [{ ...initialLevel }]
//   });

//   // Prefill formData from the row being edited when the modal opens.
//   useEffect(() => {
//     if (!show || !i) return;

//     setFormData({
//       sub_company: i.sub_company,
//       created_by: sessionStorage.getItem("emp_code"),
//       updated_by: sessionStorage.getItem("emp_code"),
//       employees: i.employees || [],
//       levels: i.levels && i.levels.length ? i.levels : [{ ...initialLevel }]
//     });
//   }, [show, i]);

//   // Refetch employee list + RH list whenever the modal's sub_company changes
//   // (covers both the initial prefill above and manual sub_company switches).
//   useEffect(() => {
//     if (!show) return;

//     const subId = formData.sub_company;
//     if (!subId || subId === "null") {
//       setModalEmpList([]);
//       setModalRHList([]);
//       return;
//     }

//     const fetchForSubCompany = async () => {
//       setModalEmpLoading(true);
//       setModalRHLoading(true);
//       try {
//         const [empRes, rhRes] = await Promise.all([
//           axios.get(`${BASE_URL}/wfm/ourcompanyempdetailsactive/${subId}/`),
//           axios.get(`${BASE_URL}/wfm/rhlistactive/${subId}/active/`)
//         ]);
//         setModalEmpList(customSortByKey(empRes.data, "emp_code"));
//         setModalRHList(rhRes.data);
//       } catch (err) {
//         console.error("Failed to fetch employees/reporting heads for sub company", err);
//         setModalEmpList([]);
//         setModalRHList([]);
//       } finally {
//         setModalEmpLoading(false);
//         setModalRHLoading(false);
//       }
//     };

//     fetchForSubCompany();
//   }, [formData.sub_company, show]);

//   const handleClose = () => {
//     setFormData({
//       sub_company: "",
//       created_by: sessionStorage.getItem("emp_code"),
//       updated_by: sessionStorage.getItem("emp_code"),
//       employees: [],
//       levels: [{ ...initialLevel }]
//     });
//     setErrors({});
//     setInputState({});
//     setShow(false);
//   };

//   const handleShow = () => {
//     const currentCompany =
//       toggleCompany && toggleCompany !== "null"
//         ? toggleCompany
//         : sessionStorage.getItem("company_id") || "";

//     // Just seed sub_company here; the sub_company-driven effect above owns
//     // the actual data fetch, and the [show, i] effect owns the full prefill.
//     setFormData(prev => ({
//       ...prev,
//       sub_company: currentCompany,
//       employees: []
//     }));

//     setShow(true);
//   };

//   // Validation
//   const validateForm = () => {
//     const newErrors = {};
//     if (SUPER_ADMIN && !formData.sub_company) newErrors.sub_company = "Sub Company is required!";
//     if (!formData.employees.length) newErrors.employees = "Select at least one employee!";

//     formData.levels.forEach((lvl, index) => {
//       if (!lvl.approver) {
//         newErrors[`level_${index}`] = `Approver for Level ${lvl.level} is required!`;
//       }
//     });

//     // Check for duplicate approvers in the same hierarchy chain
//     const approvers = formData.levels.map(l => l.approver).filter(Boolean);
//     if (new Set(approvers).size !== approvers.length) {
//       newErrors.general = "An employee cannot be an approver at multiple levels!";
//     }

//     // An employee shouldn't be their own approver
//     const selfApprover = formData.employees.some(empCode => approvers.includes(empCode));
//     if (selfApprover) {
//       newErrors.general = "A selected employee cannot also be an approver for this hierarchy!";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setInputState(prev => ({
//       ...prev,
//       [name]: value.trim() ? "green" : "",
//     }));

//     if (name === "sub_company") {
//       // No manual fetch call needed here — the formData.sub_company effect
//       // above picks this up automatically.
//       setFormData(prev => ({
//         ...prev,
//         sub_company: value,
//         employees: [],
//         levels: prev.levels.map(level => ({
//           ...level,
//           approver: ""
//         }))
//       }));

//       return;
//     }

//     setFormData(prev => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Don't mutate modalEmpList in place — sort a copy.
//   const employeeOptions = [...(modalEmpList || [])]
//     .sort((a, b) => a.emp_code - b.emp_code)
//     .map(emp => ({
//       value: emp.emp_code,
//       label: `${emp.name} - ${emp.emp_code}`
//     }));

//   // Dynamic Levels Handlers
//   const handleLevelChange = (index, e) => {
//     const { value } = e.target;
//     // Build a fresh array of fresh objects — never mutate the objects
//     // already sitting inside formData.levels.
//     const updatedLevels = formData.levels.map((lvl, idx) =>
//       idx === index ? { ...lvl, approver: value } : lvl
//     );
//     setFormData(prev => ({ ...prev, levels: updatedLevels }));

//     if (value.trim()) {
//       setErrors(prevErrors => {
//         const updatedErrors = { ...prevErrors };
//         delete updatedErrors[`level_${index}`];
//         delete updatedErrors.general;
//         return updatedErrors;
//       });
//     }
//   };

//   const addLevel = () => {
//     if (formData.levels.length >= 3) return; // Max 3 levels
//     const nextLevelNum = formData.levels.length + 1;
//     setFormData(prev => ({
//       ...prev,
//       levels: [...prev.levels, { level: nextLevelNum, approver: "" }]
//     }));
//   };

//   const removeLevel = (index) => {
//     const updatedLevels = formData.levels.filter((_, i) => i !== index);
//     const reindexedLevels = updatedLevels.map((lvl, i) => ({
//       ...lvl,
//       level: i + 1
//     }));
//     setFormData(prev => ({ ...prev, levels: reindexedLevels }));

//     // Clean up stale error keys so an old `level_2` error doesn't linger
//     // and point at the wrong row after re-indexing.
//     setErrors(prevErrors => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors[`level_${index}`];
//       return updatedErrors;
//     });
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();

//     if (validateForm()) {
//       const loadingToastId = toast.loading('Loading: Please wait...');
//       setLoading(true);

//       const payload = [
//         {
//           employee: formData.employees,
//           sub_company: formData.sub_company,
//           created_by: formData.created_by,
//           updated_by: formData.updated_by,
//           manual_hierarchy: {
//             levels: formData.levels.map(lvl => ({
//               level: lvl.level,
//               approver: lvl.approver
//             }))
//           }
//         }
//       ];

//       try {
//         let res = await axios.put(`${BASE_URL}/wfm/manual-hierarchy-bulk-update/`, payload);
//         if (res.status === 200 || res.status === 201) {
//           if (getHierarchies) await getHierarchies();
//           handleClose();
//           toast.success("Employee Hierarchy Updated Successfully!");
//         }
//       } catch (err) {
//         toast.error(err?.response?.data?.message || "Failed to create hierarchy");
//       } finally {
//         toast.dismiss(loadingToastId);
//         setLoading(false);
//       }
//     }
//   };

//   return (
//     <>
//       <button className="model-edit-button-ml" onClick={handleShow}>
//         <UpdatePencil />
//       </button>

//       <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
//         <Modal.Header closeButton className="task-Tab-heading font-weight500 font-size-heading">
//           <Modal.Title> Update Employee Hierarchy</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="parent-div">
//             <div className="bdy-div">

//               {errors.general && (
//                 <div style={{ color: '#dc3545', marginBottom: '15px', fontWeight: '500' }}>
//                   {errors.general}
//                 </div>
//               )}

//               {SUPER_ADMIN && (
//                 <div className="flex-column">
//                   <label htmlFor="sub_company" className="form-labels font-weight500 font-size-subheading">
//                     Sub Company<span className="required">*</span>
//                   </label>
//                   <select
//                     id="sub_company"
//                     name="sub_company"
//                     value={formData.sub_company}
//                     onChange={handleInputChange}
//                     className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""}`}
//                     style={{ width: 'calc(100% - 22px)', margin: '8px 0' }}
//                   >
//                     <option value="">Select Site Company</option>
//                     {SUB_COMPANIES?.map((company, idx) => (
//                       <option key={idx} value={company.id}>{company.title}</option>
//                     ))}
//                   </select>
//                   {errors.sub_company && <span className="error-message font-size-text">{errors.sub_company}</span>}
//                 </div>
//               )}

//               {/* Employee Selection - supports single or multiple employees */}
//               <div className="flex-column">

//                 <label className="form-labels font-weight500 font-size-subheading">
//                   Employee<span className="required">*</span>
//                 </label>
//                 {(employeeLoading || modalEmpLoading) ? (
//                   <div className="form-loader">
//                     <div className="bar-loader"></div>
//                   </div>
//                 ) : (
//                   <Select
//                     isMulti
//                     isSearchable
//                     options={employeeOptions}
//                     placeholder="Search & Select Employees"
//                     closeMenuOnSelect={false}
//                     value={employeeOptions.filter(option =>
//                       formData.employees.includes(option.value)
//                     )}
//                     onChange={(selected) => {
//                       setFormData(prev => ({
//                         ...prev,
//                         employees: selected
//                           ? selected.map(item => item.value)
//                           : []
//                       }));

//                       setInputState(prev => ({
//                         ...prev,
//                         employees: "green"
//                       }));

//                       setErrors(prevErrors => {
//                         const updatedErrors = { ...prevErrors };
//                         delete updatedErrors.employees;
//                         return updatedErrors;
//                       });
//                     }}
//                     className={errors.employees ? "error" : ""}
//                     styles={{
//                       control: (provided) => ({
//                         ...provided,
//                         width: '98%',
//                         minHeight: '50px',
//                         borderRadius: '10px',
//                         border: '1px solid #e3e3e3',
//                         margin: '10px 0px 20px 0px',
//                         color: '#4a4a4a',
//                         backgroundColor: '#f7f8fa',
//                         padding: '0px 10px',
//                       }),
//                       placeholder: (provided) => ({ ...provided, color: '#4a4a4a' }),
//                       menu: (provided) => ({ ...provided, borderRadius: '10px', marginTop: '0' }),
//                       input: (provided) => ({ ...provided, color: '#4a4a4a' }),
//                       singleValue: (provided) => ({ ...provided, color: '#4a4a4a' }),
//                     }}
//                   />
//                 )}
//                 {errors.employees && (
//                   <span className="error-message">
//                     {errors.employees}
//                   </span>
//                 )}
//               </div>

//               <hr className="field-cont-hr" style={{ margin: '15px 0', width: '100%', height: '1px' }} />

//               {/* Dynamic Approval Levels */}
//               <div className="flex-column">
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
//                   <label className="form-labels font-weight500 font-size-subheading" style={{ margin: 0 }}>
//                     Approval Hierarchy Levels
//                   </label>
//                   <button type="button" onClick={addLevel} className="model-button font-weight500" style={{ padding: '5px 15px', fontSize: '12px' }}>
//                     + Add Level
//                   </button>
//                 </div>

//                 {formData.levels.map((lvl, index) => (
//                   <div key={index} className="flex-column" style={{ background: '#ffffff', padding: '15px', borderRadius: '8px', marginBottom: '10px', border: '1px solid #e9ecef', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
//                     <div className="flex-row" style={{ gap: '15px', alignItems: 'center', width: '100%', flexWrap: 'nowrap' }}>

//                       {/* Level Indicator */}
//                       <div className="flex-column" style={{ flexShrink: 0, minWidth: '70px' }}>
//                         <label className="form-labels font-weight600 font-size-text" style={{ color: '#2576bc' }}>
//                           Level {lvl.level}
//                         </label>
//                       </div>

//                       {/* Approver Selection with Loader and Exclusion Logic */}
//                       <div className="flex-column" style={{ flex: 1, minWidth: 0 }}>
//                         {(loadingRH || modalRHLoading) ? (
//                           <div className="form-loader" style={{ margin: '0', width: 'calc(100% - 22px)' }}>
//                             <div className="bar-loader"></div>
//                           </div>
//                         ) : (
//                           <select
//                             name={`approver_${index}`}
//                             value={lvl.approver}
//                             onChange={(e) => handleLevelChange(index, e)}
//                             className={`form-input form-group-selection ${errors[`level_${index}`] ? "error" : ""}`}
//                             style={{ width: 'calc(100% - 22px)', margin: '0' }}
//                           >
//                             <option value="">Select Approver</option>
//                             {modalRHList
//                               // Exclude RHs already selected in OTHER levels
//                               ?.filter(rh => {
//                                 const isSelectedElsewhere = formData.levels.some(
//                                   (l, i) => i !== index && l.approver === rh.emp_code
//                                 );
//                                 return !isSelectedElsewhere;
//                               })
//                               ?.sort((a, b) =>
//                                 a.name.localeCompare(b.name, "en", {
//                                   ignorePunctuation: true,
//                                 }),
//                               )
//                               .map((rh, idx) => (
//                                 <option key={idx} value={rh.emp_code}>
//                                   {rh.name}-{rh.division_name}
//                                 </option>
//                               ))}
//                           </select>
//                         )}
//                       </div>

//                       {/* Remove Level Button */}
//                       {formData.levels.length > 1 && index === formData.levels.length - 1 && (
//                         <div style={{ flexShrink: 0 }}>
//                           <button
//                             type="button"
//                             onClick={() => removeLevel(index)}
//                             style={{ background: 'transparent', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '22px', fontWeight: 'bold', lineHeight: 1 }}
//                             title="Remove Level"
//                           >
//                             ×
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                     {errors[`level_${index}`] && (
//                       <span className="error-message font-size-text" style={{ display: 'block', marginTop: '8px' }}>
//                         {errors[`level_${index}`]}
//                       </span>
//                     )}
//                   </div>
//                 ))}
//               </div>

//               {/* Submit Buttons */}
//               <div className="button-models" style={{ marginTop: '20px' }}>
//                 <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
//                   Cancel
//                 </button>
//                 <button
//                   className="model-button font-weight500 model-button-leave font-size-heading"
//                   onClick={handleFormSubmit}
//                   disabled={loading}
//                 >
//                   Submit
//                 </button>
//               </div>

//             </div>
//           </div>
//           <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

const EmployeeHierarchyUpdate = ({ i, getHierarchies, EMPLOYEELIST, employeeLoading, RHLIST, loadingRH, SUB_COMPANIES, SUPER_ADMIN, toggleCompany }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const initialLevel = { level: 1, approver: "", role: "" };

  // Local employee/RH lists scoped to whatever sub_company is currently
  // selected INSIDE the modal (not the parent table's toggleCompany filter).
  // Seeded from props, kept in sync via the effect below.
  const [modalEmpList, setModalEmpList] = useState(EMPLOYEELIST || []);
  const [modalEmpLoading, setModalEmpLoading] = useState(false);
  const [modalRHList, setModalRHList] = useState(RHLIST || []);
  const [modalRHLoading, setModalRHLoading] = useState(false);

  const [formData, setFormData] = useState({
    sub_company: sessionStorage.getItem("company_id"),
    created_by: sessionStorage.getItem("emp_code"),
    updated_by: sessionStorage.getItem("emp_code"),
    employees: [],
    levels: [{ ...initialLevel }]
  });

  // Prefill formData from the row being edited when the modal opens.
  // NOTE: the API returns sub_company_id (not sub_company), employee (not
  // employees), and the approval levels nested under manual_hierarchy.levels.
  useEffect(() => {
    if (!show || !i) return;

    const prefillLevels = i.manual_hierarchy?.levels;

    setFormData({
      sub_company: i.sub_company_id,
      created_by: sessionStorage.getItem("emp_code"),
      updated_by: sessionStorage.getItem("emp_code"),
      employees: i.employee || [],
      levels: prefillLevels && prefillLevels.length
        ? prefillLevels.map(lvl => ({ level: lvl.level, approver: lvl.approver, role: lvl.role || "" }))
        : [{ ...initialLevel }]
    });
  }, [show, i]);

  // Refetch employee list + RH list whenever the modal's sub_company changes
  // (covers both the initial prefill above and manual sub_company switches).
  useEffect(() => {
    if (!show) return;

    const subId = formData.sub_company;
    if (!subId || subId === "null") {
      setModalEmpList([]);
      setModalRHList([]);
      return;
    }

    const fetchForSubCompany = async () => {
      setModalEmpLoading(true);
      setModalRHLoading(true);
      try {
        const [empRes, rhRes] = await Promise.all([
          axios.get(`${BASE_URL}/wfm/ourcompanyempdetailsactive/${subId}/`),
          axios.get(`${BASE_URL}/wfm/rhlistactive/${subId}/active/`)
        ]);
        setModalEmpList(customSortByKey(empRes.data, "emp_code"));
        setModalRHList(rhRes.data);
      } catch (err) {
        console.error("Failed to fetch employees/reporting heads for sub company", err);
        setModalEmpList([]);
        setModalRHList([]);
      } finally {
        setModalEmpLoading(false);
        setModalRHLoading(false);
      }
    };

    fetchForSubCompany();
  }, [formData.sub_company, show]);

  const handleClose = () => {
    setFormData({
      sub_company: "",
      created_by: sessionStorage.getItem("emp_code"),
      updated_by: sessionStorage.getItem("emp_code"),
      employees: [],
      levels: [{ ...initialLevel }]
    });
    setErrors({});
    setInputState({});
    setShow(false);
  };

  const handleShow = () => {
    const currentCompany =
      toggleCompany && toggleCompany !== "null"
        ? toggleCompany
        : sessionStorage.getItem("company_id") || "";

    // Just seed sub_company here; the sub_company-driven effect above owns
    // the actual data fetch, and the [show, i] effect owns the full prefill.
    setFormData(prev => ({
      ...prev,
      sub_company: currentCompany,
      employees: []
    }));

    setShow(true);
  };

  // Validation
  const validateForm = () => {
    const newErrors = {};
    if (SUPER_ADMIN && !formData.sub_company) newErrors.sub_company = "Sub Company is required!";
    if (!formData.employees.length) newErrors.employees = "Select at least one employee!";

    formData.levels.forEach((lvl, index) => {
      if (!lvl.approver) {
        newErrors[`level_${index}`] = `Approver for Level ${lvl.level} is required!`;
      }
    });

    // Check for duplicate approvers in the same hierarchy chain
    const approvers = formData.levels.map(l => l.approver).filter(Boolean);
    if (new Set(approvers).size !== approvers.length) {
      newErrors.general = "An employee cannot be an approver at multiple levels!";
    }

    // An employee shouldn't be their own approver
    const selfApprover = formData.employees.some(empCode => approvers.includes(empCode));
    if (selfApprover) {
      newErrors.general = "A selected employee cannot also be an approver for this hierarchy!";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState(prev => ({
      ...prev,
      [name]: value.trim() ? "green" : "",
    }));

    if (name === "sub_company") {
      // No manual fetch call needed here — the formData.sub_company effect
      // above picks this up automatically.
      setFormData(prev => ({
        ...prev,
        sub_company: value,
        employees: [],
        levels: prev.levels.map(level => ({
          ...level,
          approver: "",
          role: ""
        }))
      }));

      return;
    }

    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  // Don't mutate modalEmpList in place — sort a copy.
  const employeeOptions = [...(modalEmpList || [])]
    .sort((a, b) => a.emp_code - b.emp_code)
    .map(emp => ({
      value: emp.emp_code,
      label: `${emp.name} - ${emp.emp_code}`
    }));

  // Dynamic Levels Handlers
  // const handleLevelChange = (index, e) => {
  //   const { value } = e.target;
  //   // Build a fresh array of fresh objects — never mutate the objects
  //   // already sitting inside formData.levels.
  //   const updatedLevels = formData.levels.map((lvl, idx) =>
  //     idx === index ? { ...lvl, approver: value } : lvl
  //   );
  //   setFormData(prev => ({ ...prev, levels: updatedLevels }));

  //   if (value.trim()) {
  //     setErrors(prevErrors => {
  //       const updatedErrors = { ...prevErrors };
  //       delete updatedErrors[`level_${index}`];
  //       delete updatedErrors.general;
  //       return updatedErrors;
  //     });
  //   }
  // };
  const handleLevelChange = (index, e) => {
    const { value } = e.target;

    const selectedRH = modalRHList.find(
      (rh) => rh.emp_code === value
    );

    const updatedLevels = formData.levels.map((lvl, idx) =>
      idx === index
        ? {
          ...lvl,
          approver: value,
          role: selectedRH?.role || ""
        }
        : lvl
    );

    setFormData(prev => ({
      ...prev,
      levels: updatedLevels
    }));

    if (value) {
      setErrors(prevErrors => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[`level_${index}`];
        delete updatedErrors.general;
        return updatedErrors;
      });
    }
  };

  const addLevel = () => {
    if (formData.levels.length >= 3) return; // Max 3 levels
    const nextLevelNum = formData.levels.length + 1;
    setFormData(prev => ({
      ...prev,
      levels: [...prev.levels, { level: nextLevelNum, approver: "", role: "" }]
    }));
  };

  const removeLevel = (index) => {
    const updatedLevels = formData.levels.filter((_, i) => i !== index);
    const reindexedLevels = updatedLevels.map((lvl, i) => ({
      ...lvl,
      level: i + 1
    }));
    setFormData(prev => ({ ...prev, levels: reindexedLevels }));

    // Clean up stale error keys so an old `level_2` error doesn't linger
    // and point at the wrong row after re-indexing.
    setErrors(prevErrors => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[`level_${index}`];
      return updatedErrors;
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading('Loading: Please wait...');
      setLoading(true);

      const payload = [
        {
          id: i?.id,
          employee: formData.employees,
          sub_company: formData.sub_company,
          created_by: formData.created_by,
          updated_by: formData.updated_by,
          manual_hierarchy: {
            levels: formData.levels.map(lvl => ({
              level: lvl.level,
              approver: lvl.approver,
              role: lvl.role
            }))
          }
        }
      ];

      try {
        let res = await axios.put(`${BASE_URL}/wfm/manual-hierarchy-bulk-update/`, payload);
        if (res.status === 200 || res.status === 201) {
          if (getHierarchies) await getHierarchies();
          handleClose();
          toast.success("Employee Hierarchy Updated Successfully!");
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || "Failed to create hierarchy");
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false);
      }
    }
  };

  return (
    <>
      <button className="model-edit-button-ml" onClick={handleShow}>
        <UpdatePencil />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton className="task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title> Update Employee Hierarchy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">

              {errors.general && (
                <div style={{ color: '#dc3545', marginBottom: '15px', fontWeight: '500' }}>
                  {errors.general}
                </div>
              )}

              {SUPER_ADMIN && (
                <div className="flex-column">
                  <label htmlFor="sub_company" className="form-labels font-weight500 font-size-subheading">
                    Sub Company<span className="required">*</span>
                  </label>
                  <select
                    id="sub_company"
                    name="sub_company"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""}`}
                    style={{ width: 'calc(100% - 22px)', margin: '8px 0' }}
                  >
                    <option value="">Select Site Company</option>
                    {SUB_COMPANIES?.map((company, idx) => (
                      <option key={idx} value={company.id}>{company.title}</option>
                    ))}
                  </select>
                  {errors.sub_company && <span className="error-message font-size-text">{errors.sub_company}</span>}
                </div>
              )}

              {/* Employee Selection - supports single or multiple employees */}
              <div className="flex-column">

                <label className="form-labels font-weight500 font-size-subheading">
                  Employee<span className="required">*</span>
                </label>
                {(employeeLoading || modalEmpLoading) ? (
                  <div className="form-loader">
                    <div className="bar-loader"></div>
                  </div>
                ) : (
                  <Select
                    isMulti
                    isSearchable
                    options={employeeOptions}
                    placeholder="Search & Select Employees"
                    closeMenuOnSelect={false}
                    value={employeeOptions.filter(option =>
                      formData.employees.includes(option.value)
                    )}
                    onChange={(selected) => {
                      setFormData(prev => ({
                        ...prev,
                        employees: selected
                          ? selected.map(item => item.value)
                          : []
                      }));

                      setInputState(prev => ({
                        ...prev,
                        employees: "green"
                      }));

                      setErrors(prevErrors => {
                        const updatedErrors = { ...prevErrors };
                        delete updatedErrors.employees;
                        return updatedErrors;
                      });
                    }}
                    className={errors.employees ? "error" : ""}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        width: '96%',
                        minHeight: '50px',
                        borderRadius: '10px',
                        border: '1px solid #e3e3e3',
                        margin: '10px 0px 20px 0px',
                        color: '#4a4a4a',
                        backgroundColor: '#f7f8fa',
                        padding: '0px 10px',
                      }),
                      placeholder: (provided) => ({ ...provided, color: '#4a4a4a' }),
                      menu: (provided) => ({ ...provided, borderRadius: '10px', marginTop: '0' }),
                      input: (provided) => ({ ...provided, color: '#4a4a4a' }),
                      singleValue: (provided) => ({ ...provided, color: '#4a4a4a' }),
                    }}
                  />
                )}
                {errors.employees && (
                  <span className="error-message">
                    {errors.employees}
                  </span>
                )}
              </div>

              <hr className="field-cont-hr" style={{ margin: '15px 0', width: '100%', height: '1px' }} />

              {/* Dynamic Approval Levels */}
              <div className="flex-column">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                  <label className="form-labels font-weight500 font-size-subheading" style={{ margin: 0 }}>
                    Approval Hierarchy Levels
                  </label>
                  <button type="button" onClick={addLevel} className="model-button font-weight500" style={{ padding: '5px 15px', fontSize: '12px' }}>
                    + Add Level
                  </button>
                </div>

                {formData.levels.map((lvl, index) => (
                  <div key={index} className="flex-column" style={{ background: '#ffffff', padding: '15px', borderRadius: '8px', marginBottom: '10px', border: '1px solid #e9ecef', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                    <div className="flex-row" style={{ gap: '15px', alignItems: 'center', width: '100%', flexWrap: 'nowrap' }}>

                      {/* Level Indicator */}
                      <div className="flex-column" style={{ flexShrink: 0, minWidth: '70px' }}>
                        <label className="form-labels font-weight600 font-size-text" style={{ color: '#2576bc' }}>
                          Level {lvl.level}
                        </label>
                      </div>

                      {/* Approver Selection with Loader and Exclusion Logic */}
                      <div className="flex-column" style={{ flex: 1, minWidth: 0 }}>
                        {(loadingRH || modalRHLoading) ? (
                          <div className="form-loader" style={{ margin: '0', width: 'calc(100% - 22px)' }}>
                            <div className="bar-loader"></div>
                          </div>
                        ) : (
                          <select
                            name={`approver_${index}`}
                            value={lvl.approver}
                            onChange={(e) => handleLevelChange(index, e)}
                            className={`form-input form-group-selection ${errors[`level_${index}`] ? "error" : ""}`}
                            style={{ width: 'calc(100% - 22px)', margin: '0' }}
                          >
                            <option value="">Select Approver</option>
                            {modalRHList
                              // Exclude RHs already selected in OTHER levels
                              ?.filter(rh => {
                                const isSelectedElsewhere = formData.levels.some(
                                  (l, i) => i !== index && l.approver === rh.emp_code
                                );
                                return !isSelectedElsewhere;
                              })
                              ?.sort((a, b) =>
                                a.name.localeCompare(b.name, "en", {
                                  ignorePunctuation: true,
                                }),
                              )
                              .map((rh, idx) => (
                                <option key={idx} value={rh.emp_code}>
                                  {rh.name}-{rh.division_name}
                                </option>
                              ))}
                          </select>
                        )}
                      </div>

                      {/* Remove Level Button */}
                      {formData.levels.length > 1 && index === formData.levels.length - 1 && (
                        <div style={{ flexShrink: 0 }}>
                          <button
                            type="button"
                            onClick={() => removeLevel(index)}
                            style={{ background: 'transparent', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '22px', fontWeight: 'bold', lineHeight: 1 }}
                            title="Remove Level"
                          >
                            ×
                          </button>
                        </div>
                      )}
                    </div>
                    {errors[`level_${index}`] && (
                      <span className="error-message font-size-text" style={{ display: 'block', marginTop: '8px' }}>
                        {errors[`level_${index}`]}
                      </span>
                    )}
                  </div>
                ))}
              </div>

              {/* Submit Buttons */}
              <div className="button-models" style={{ marginTop: '20px' }}>
                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                  Cancel
                </button>
                <button
                  className="model-button font-weight500 model-button-leave font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Submit
                </button>
              </div>

            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};


const EmployeeHierarchyDelete = ({ i, getHierarchies }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    const loadingToastId = toast.loading('Deleting...');

    try {
      await axios.delete(`${BASE_URL}/wfm/manual-hierarchy-data-update/${i.id}/`);
      toast.success("Hierarchy Deleted Successfully!");
      if (getHierarchies) await getHierarchies();
      handleClose();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to delete hierarchy");
    } finally {
      toast.dismiss(loadingToastId);
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className="model-delete-button"
        title="Delete Hierarchy"
        onClick={handleShow}
        style={{ marginLeft: '10px' }}
      >
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            {/* i.employee_name doesn't exist on the real API object — the
                actual field is employee_details: [{emp_code, name}, ...] */}
            Are you sure you want to delete the hierarchy for{" "}
            <strong>
              {i.employee_details && i.employee_details.length > 0
                ? i.employee_details.map(emp => emp.name).join(", ")
                : "this employee"}
            </strong>?
            <div className="button-models">
              <button
                className="model-button model-button-cancel font-weight500"
                onClick={handleClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="model-button model-button-delete font-weight500"
                onClick={handleDelete}
                disabled={loading}
              >
                {loading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer position="top-center" autoClose={1000} />
    </>
  );
};


export {
  Department,
  DepartmentUpdate,
  DepartmentDelete,
  DesignationName,
  DesignationUpdate,
  DesignationDelete,
  AddSubCompany,
  UpdateSubCompany,
  DeleteSubCompany,
  AttendancePolicyAdd,
  AttendancePolicyUpdate,
  AttendancePolicyDelete,
  WeeklyOffPolicy,
  AddWeeklyOffPolicy, //new method trial
  WeeklyOffPolicyUpdate,
  UpdateWeeklyOffPolicy, //new method trial
  WeeklyOffPolicyDelete,
  SalaryStructureHeadingAdd,
  SalaryStructureHeadingUpdate,
  SalaryStructureHeadingDelete,
  SalaryCalculationPolicyAdd,
  SalaryCalculationPolicyUpdate,
  SalaryCalculationPolicyDelete,
  Woksiteadd,
  Woksiteupdate,
  WoksiteDelete,
  CalenderAdd,
  CalenderUpdate,
  CalenderDelete,
  InterCom,
  InterComUpdate,
  InterComDelete,
  EsslList,
  EsslUpdate,
  EsslDelete,
  DepartmentHierarchyAdd,
  DepartmentHierarchyUpdate,
  DepartmentHierarchyDelete,
  EmployeeHierarchyAdd,
  EmployeeHierarchyUpdate,
  EmployeeHierarchyDelete
};
